// i18n namespace `recognition` (ro) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Înapoi la portal',
    collapseMenu: 'Restrânge meniul',
    expandMenu: 'Extinde meniul',
    fundamentals: 'Fundamentale',
  },
  moduleTitle: 'Programul de Recunoaștere',
  nav: {
    recognize: 'Recunoaște',
    shine: 'Strălucim Împreună',
    profile: 'Profilul meu',
    admin: 'Admin',
    team: 'Echipă',
    dashboard: 'Tablou de bord',
    innovation: 'Inovație LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Vezi mai mult',
    title: 'Mai multe opțiuni',
    documents: 'Documente',
    language: 'Limbă',
    selectLanguage: 'Selectează limba',
  },
  common: {
    loading: 'Se încarcă…',
    error: 'Informațiile nu au putut fi încărcate.',
    retry: 'Reîncearcă',
    empty: 'Încă nu există nimic de afișat.',
    notConfigured: 'Serviciul de recunoaștere nu este configurat.',
    forbidden: 'Nu ai permisiunea de a vedea această secțiune.',
    close: 'Închide',
    remove: 'Elimină',
    cancel: 'Anulează',
    insertEmoji: 'Inserează un emoji',
    actions: 'Acțiuni',
  },
  recognize: {
    title: 'Recunoaște un coleg',
    subtitle: 'Mulțumește pentru un comportament aliniat Fundamentalelor noastre.',
    feedTitle: 'Recunoașteri recente',
    feedEmpty: 'Încă nu există recunoașteri. Fii primul care recunoaște!',
    newCta: 'Recunoaștere nouă',
    form: {
      messagePlaceholder: 'Scrie mesajul tău de recunoaștere…',
      anonymous: 'Trimite anonim',
      submit: 'Trimite recunoașterea',
    },
  },
  wall: {
    title: 'Zidul recunoașterilor',
    count: '{{count}} recunoașteri',
    empty: 'Încă nu există recunoașteri de afișat.',
    prev: 'Anterioare',
    next: 'Următoarele',
    pageOf: 'Pagina {{page}} din {{total}}',
    for: 'pentru',
    anonymous: 'Anonim',
    senderHidden: 'Identitate neafișată',
    userUnavailable: 'Utilizator indisponibil',
    points_one: '+{{count}} punct',
    points_other: '+{{count}} puncte',
    pointsTitle: 'Puncte pe care le valorează această apreciere',
    fundamentalsRecognized: 'Fundamentale recunoscute',
    fundIconTooltipAria: 'Vezi toate Fundamentalele acestei recunoașteri',
    behaviorsRecognized: 'Comportamente recunoscute',
    habitsRecognized: 'Obiceiuri zilnice recunoscute',
    detailUnavailable: 'Detaliile complete nu au putut fi încărcate.',
    reportCount: 'Raportat de {{count}} ori — în analiză',
    receivedIn: 'Primit în:',
    antiSpoilerBlurredHint: 'Așteaptă festivitatea de premiere a evenimentului Brillamos Juntos pentru a-ți vedea nominalizările.',
    antiSpoilerHiddenHint: 'Unele recunoașteri sunt ascunse de modul Anti-Spoiler până la încheierea campaniei lor.',
  },
  reactions: {
    addLabel: 'Reacționează',
    countLabel: '{{count}} reacții',
    modalTitle: 'Reacții',
    error: 'Reacția ta nu a putut fi salvată. Încearcă din nou.',
    whoReacted: 'Au reacționat',
    whoLoading: 'Se încarcă…',
    whoEmpty: 'Nimeni nu a reacționat încă.',
    whoError: 'Lista nu a putut fi încărcată.',
  },
  origin: {
    diario: 'Zilnic',
    brillamos: 'Strălucim',
    personalizada: 'Campanie',
    csv: 'Încărcare în masă',
    delegado: 'Delegat',
    sistema: 'Sistem',
  },
  panel: {
    title: 'Recunoaște-ți colegii',
    recipientsLabel: 'Persoane',
    recipientsPlaceholder: 'Caută după nume sau e-mail…',
    searchError: 'Persoanele nu au putut fi căutate',
    fundamentalLabel: 'Fundament (max. {{max}})',
    fundamentalLabelUnbounded: 'Fundament',
    maxFundamentalsHint: 'Poți selecta cel mult {{max}} Fundament(e).',
    behaviorsLabel: 'Comportamente',
    habitsLabel: 'Obiceiuri zilnice',
    habitRequiredHint: 'Selectează cel puțin un obicei zilnic pentru a putea trimite.',
    summaryLabel: 'Rezumat',
    edit: 'Editează',
    messageLabel: 'Mesajul tău',
    messagePlaceholder: 'De ce recunoști această persoană?',
    anonymous: 'Trimite anonim',
    sendToBrillamos: 'Trimite și către ,,Strălucim”',
    // Decisión 6 (2026-10-15) — «Enviar también a Brillamos» avisa antes y después de enviar.
    sendToBrillamosNoCabe: 'Această recunoaștere nu respectă regulile „{{campana}}” ({{limites}}). Dacă o trimiți așa, va pleca drept recunoaștere zilnică.',
    brillamosMaxPersonas_one: 'cel mult {{count}} persoană',
    brillamosMaxPersonas_few: 'cel mult {{count}} persoane',
    brillamosMaxPersonas_other: 'cel mult {{count}} de persoane',
    brillamosMaxFundamentales_one: 'cel mult {{count}} Fundamental',
    brillamosMaxFundamentales_few: 'cel mult {{count}} Fundamentale',
    brillamosMaxFundamentales_other: 'cel mult {{count}} de Fundamentale',
    sendToBrillamosSalioDiario: 'Trimisă ca recunoaștere zilnică: nu a intrat în „{{campana}}”.',
    charCount: '{{count}} caractere',
    charsAvailableHint: 'Te apropii de limită. Ți-au mai rămas {{remaining}} caractere din {{max}}.',
    charsLimitReachedHint: 'Ai ajuns la limita de {{max}} caractere. Scurtează o parte ca să poți continua.',
    charsLimitSentenceNote: 'Fraza compusă pe post-it intră și ea în limită.',
    errMessageTooLong: 'Mesajul tău depășește limita de {{max}} caractere. Scurtează o parte și trimite-l din nou.',
    errRecipientRequired: 'Alege persoana pe care vrei să o recunoști înainte de a trimite.',
    errFundamentalRequired: 'Alege cel puțin un Fundament înainte de a trimite.',
    errSessionUnknown: 'Nu am putut identifica sesiunea ta. Închide aplicația, autentifică-te din nou și încearcă iar.',
    errRecipientWithoutCampaign_one: '{{names}} nu are o campanie activă, așa că nu poate primi această recunoaștere. Elimină această persoană din trimitere pentru a continua.',
    errRecipientWithoutCampaign_few: '{{names}} nu au o campanie activă, așa că nu pot primi această recunoaștere. Elimină aceste persoane din trimitere pentru a continua.',
    errRecipientWithoutCampaign_other: '{{names}} nu au o campanie activă, așa că nu pot primi această recunoaștere. Elimină aceste persoane din trimitere pentru a continua.',
    errDelegateNotAllowed: 'Nu ai permisiunea „Recunoaște în numele altei persoane”. Trimite recunoașterea în numele tău.',
    errDelegateOtherUnit: 'Poți recunoaște doar în numele persoanelor din unitatea ta. Alege altă persoană ca emițător.',
    errDelegateNotOperational: 'Poți recunoaște doar în numele personalului operațional. Alege altă persoană ca emițător.',
    errDelegateNotFound: 'Persoana aleasă ca emițător nu există sau nu mai este activă. Alege altă persoană.',
    errDelegateRequesterWithoutUnit: 'Profilul tău nu are o unitate atribuită, așa că nu poți recunoaște în numele altei persoane.',
    errDelegateNotEligible: 'Nu poți recunoaște în numele acestei persoane. Alege altă persoană ca emițător.',
    errDelegateCheckUnavailable: 'Nu am putut verifica persoana aleasă ca emițător. Încearcă din nou în câteva minute.',
    send: 'Trimite',
    sending: 'Se trimite…',
    sentTitle: 'Recunoaștere trimisă!',
    sentSubtitle: 'Vizibilă pentru echipă și pentru lider.',
    sendErrorGeneric: 'Recunoașterea nu a putut fi trimisă. Încearcă din nou.',
    legalHint: 'Trebuie să accepți termenii legali în vigoare înainte de a recunoaște.',
    sendingDisabledHint: 'Trimiterea recunoașterilor este temporar dezactivată.',
    scheduleRestrictedHint: 'Trimiterea este în afara ferestrei orare permise pentru locația ta chiar acum.',
    weeklyLimitHint: 'Există o limită de {{count}} recunoașteri pe săptămână pentru locația ta.',
    missingRecipientsHint: 'Selectează cel puțin o persoană pe care să o recunoști.',
    missingFundamentalHint: 'Selectează cel puțin un Fundament.',
    messageMinCharsHint: 'Scrie cel puțin {{count}} caractere în mesajul tău.',
    missingBehaviorForHabitHint: 'Alege un comportament pentru a vedea obiceiurile zilnice disponibile.',
    noHabitsAvailableHint: 'Acest Fundament nu are obiceiuri zilnice configurate; alege altul.',
    groupTag: 'Echipă',
    delegateTitle: 'Mod de trimitere',
    modeSelfTab: 'În numele meu',
    modeOnBehalfTab: 'În numele altcuiva',
    delegateLabel: 'În numele',
    delegateSubtitle: 'Poți trimite recunoașteri în numele colegilor din operațional/teren.',
    delegatePlaceholder: 'Caută un coleg…',
    onBehalfActiveBanner: 'Trimiți în numele: {{name}}.',
  },
  profile: {
    title: 'Profilul meu de recunoaștere',
    subtitle: 'Activitatea ta de recunoaștere și seria ta.',
    received: 'Primite',
    sent: 'Trimise',
    streak: 'Serie',
    empty: 'Încă nu ai activitate de recunoaștere.',
    weeksStreak: 'Săptămâni în serie',
    monthsStreak: 'Luni de serie',
    record: 'Record',
    totalSent: 'Trimise',
  },
  catalog: {
    title: 'Fundamentale',
    empty: 'Catalogul de Fundamentale este gol.',
  },
  notifications: {
    title: 'Notificări',
    close: 'Închide notificările',
    placeholder: 'Cutia de notificări va fi disponibilă în curând.',
    unread: '{{count}} necitite',
    markAllRead: 'Marchează tot ca citit',
    markRead: 'Marchează ca citită',
    readState: 'Stare de citire',
    inviteToRecognize: 'Recunoaște pe cineva',
    markUnread: 'Marchează ca necitită',
    loadMore: 'Vezi notificările anterioare',
    recognitionUnavailable: 'Această recunoaștere nu mai este disponibilă.',
    unsavedTitle: 'Ai modificări nesalvate',
    unsavedDesc: 'Dacă pleci acum, vei pierde ce scrii.',
    unsavedConfirm: 'Ieși fără salvare',
    unsavedCancel: 'Rămâi aici',
    campaignInactive: 'Campania aceasta de Recunoaștere s-a încheiat, așa că nu mai poate fi deschisă.',
    campaignUnavailable: 'Această campanie s-a încheiat, așa că nu mai poate fi deschisă.',
    unavailable: 'Cutia de mesaje nu este disponibilă momentan.',
    empty: 'Nu ai notificări.',
  },
  // ── WP-12/WP-13 (D4) — Strălucim+Nominalizare, Bibliotecă, Profil, Wrapped ──
  home: {
    sent: 'Trimise', received: 'Primite', recognizeCta: 'Recunoaște acum', recent: 'Recunoașteri recente',
    active: 'Campanie activă',
    ended: 'Campanie încheiată',
    daysLeft: '{{count}} zile rămase',
    heroLogoAlt: 'Strălucim Împreună',
    nominateNow: 'Nominalizează acum',
    // Paritate demo (D1/D2) — hero din /app/reconocer, preluat din HomePage.tsx al demo-ului.
    titleLine1: 'Nominalizează pe cineva care',
    titleVive: 'trăiește',
    subtitle: 'Recunoaște un coleg care îi inspiră pe ceilalți trăind Fundamentalele noastre.',
    cta: '✨ Nominalizează pe cineva',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: 'Încă nu ai recunoscut pe nimeni!',
    emptyReceived: 'Continuă să trăiești Fundamentele și vei fi recunoscut în curând!',
  },
  streak: {
    title: 'Seria ta de nominalizări',
    subtitle: 'Recunoaște în fiecare săptămână!',
    subtitleMonthly: 'Recunoaște în fiecare lună și continuă să strălucești!',
    weeks: 'săpt',
    months: 'luni',
    month: 'luna',
    monthsMany: 'de luni',
    record: 'Record',
    total: 'Nominalizări',
    activeDays: '{{count}} zile active săptămâna aceasta',
    currentLevel: 'NIVEL ACTUAL',
    atRisk: 'Seria ta este în pericol săptămâna aceasta',
    atRiskMonthly: 'Seria ta este în pericol luna aceasta',
    // FAZA 7 (paritate demo, H-91) — familia .streak-* unificată.
    current: 'Seria actuală',
    thisWeek: 'Săptămâna aceasta',
    days: 'zile',
    today: 'Astăzi!',
    nudgeDone: 'Ai strălucit deja azi! 🌟',
    nudgeTodo: 'Recunoaște azi și menține seria! 🚀',
    periodProgress: '{{sent}} din {{min}} săptămâna aceasta',
    periodProgressDone: 'Obiectivul săptămânii atins! ({{sent}} din {{min}})',
    periodProgressMonthly: '{{sent}} din {{min}} luna aceasta',
    periodProgressDoneMonthly: 'Obiectivul lunii atins! ({{sent}} din {{min}})',
    provisionalNote: 'Include săptămâna aceasta · se confirmă la închidere',
    provisionalNoteMonthly: 'Include luna aceasta · se confirmă la închidere',
    badgeProvisional: 'LA ÎNCHIDERE',
    badgeProvisionalTooltip: 'Ai atins deja minimul acestei perioade: insigna apare deja și va fi confirmată la închiderea perioadei.',
    badgesTitle: 'Insigne',
    celebration: {
      title: 'Insignă deblocată!',
      message: 'Continuă așa, se vede că ești constant!',
      cta: 'Grozav!',
    },
    badgeWeek: '{{count}} săptămână',
    badgeWeeks: '{{count}} săptămâni',
    badgeWeeksMany: '{{count}} de săptămâni',
    badgeMonth: '{{count}} lună',
    badgeMonths: '{{count}} luni',
    badgeMonthsMany: '{{count}} de luni',
    note: '* Seria se calculează pe baza recunoașterilor trimise',
    day: { mon: 'L', tue: 'M', wed: 'M', thu: 'J', fri: 'V', sat: 'S', sun: 'D' },
  },
  // 2026-08-10 — doar `crossOu` mai este folosit (de NominarView). Restul aparținea "Fluxului de
  // activitate" din Brillamos Juntos (`BrillamosFeed`, eliminat din arbore la cererea clientului).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Toate limbile",
    title: 'Documentele campaniei',
    download: 'Descarcă',
    loadError: 'Documentul nu a putut fi încărcat.',
    cat: {
      howto: 'Cum să nominalizezi',
      awards: 'Premii',
      legal: 'Regulament',
      privacy: 'Politica de confidențialitate',
      cookies: 'Politica de cookie-uri',
      notice: 'Notă legală',
    },
  },
  library: {
    title: 'Fundamentalele',
    subtitle: 'Baza felului în care lucrăm, colaborăm și creștem la Sigma.',
    watchVideo: 'Vezi videoclipul',
    behaviorsCount: '{{count}} Atitudini și Comportamente',
    dailyHabits: 'Obiceiuri Zilnice',
    micrositeSpace: 'Spațiul microsite-ului cultural',
  },
  nominate: {
    back: 'Strălucim Împreună',
    thanksTo: 'Mulțumim {{name}} pentru',
    demonstrating: 'că a demonstrat {{fundamental}}',
    defaultMessage: 'Recunoaștere trimisă',
    sentTitle: 'Nominalizare trimisă!',
    sentSubtitle: 'Mulțumim că îl faci pe {{name}} să strălucească.',
    redirecting: 'Revenire la campanie…',
    yourRecognition: 'Recunoașterea ta',
    thanksWord: 'Mulțumim',
    slotWho: 'cine?',
    forWord: 'pentru',
    slotWhat: 'ce a făcut?',
    demonstratingWord: 'demonstrând',
    slotFund: 'care Fundament?',
    elements: '{{done}}/3 elemente',
    eyebrow: 'Creează Recunoaștere',
    title: 'Completează cele trei câmpuri',
    field1: 'Etichetează-ți colegul',
    searchPlaceholder: 'Numele colegului…',
    noResults: 'Nu am găsit pe nimeni cu acest nume.',
    field2: 'La ce Fundament?',
    field3: 'Ce a făcut?',
    noActions: 'Acest Fundament nu are comportamente configurate.',
    pickFundFirst: 'Alege mai întâi un Fundament.',
    completeMessage: 'Completează-ți mesajul',
    personalizeTitle: 'Personalizează-ți mesajul',
    personalizeSub: 'Adaugă-ți vocea. Restul este deja pregătit.',
    messagePlaceholder: 'Descrie momentul concret pe care l-ai observat…',
    charCount: '{{count}} caractere',
    idealRange: '30–80 ideal',
    nudgeText: 'Mesajul tău va avea mai mult impact dacă adaugi un rând propriu.',
    addLine: 'Adaugă un rând',
    sendAnyway: 'Trimite așa',
    send: 'Trimite Nominalizarea',
  },
  wrapped: {
    readyTitle: 'Recap-ul tău este gata', readySubtitle: 'Retrăiește momentele care au făcut ca {{year}} să strălucească.', open: 'Vezi Recap-ul meu',
    introHint: 'O privire asupra anului tău de recunoaștere.',
    topReceptor: 'Pe cine ai recunoscut cel mai mult',
    topEmisor: 'Fanul tău nr. 1',
    topFundamentalHint: 'Cel pe care l-ai celebrat cel mai mult.',
    bottomFundamentalHint: 'Cel pe care l-ai celebrat cel mai puțin. Provocarea ta pentru anul acesta.',
    crossOuValue: '{{count}} recunoașteri cross-OU',
    messageFrom: 'De la {{name}}',
    winnerYear: 'Anul {{anio}}',
    winnerPosition: 'Locul {{position}}',
    sinceMonth: 'Rezumatul tău acoperă din {{month}}.',
    streakValue: '{{count}} săptămâni',
    streakValueOne: '{{count}} săptămână',
    streakValueMany: '{{count}} de săptămâni',
    streakValueMonth: '{{count}} luni',
    streakValueMonthOne: '{{count}} lună',
    streakValueMonthMany: '{{count}} de luni',
    unavailable: 'Rezumatul tău nu este încă disponibil.',
    // Corecție RF-130 F1 (H-06) — backend-ul trimite o CHEIE STABILĂ
    // (`GetRecognitionWrappedQueryHandler.cs`), nu text. `WrappedModal.tsx` o rezolvă față de aceste
    // trei, cu o listă albă: niciodată `t(cheieBrută)`.
    generosityTag: {
      generoso: 'Generos',
      muyGeneroso: 'Foarte generos',
      superGeneroso: 'Super generos',
    },
  },
  prof: {
    myFolders: 'Recunoașterile mele primite, filtrate după Fundamental',
    viewingTitle: 'Profilul lui {{name}}',
    backToMine: 'Profilul meu',
    myTeam: 'Echipă',
    searchColleague: 'Caută un coleg…',
    campaignBannerSub: 'Campania este activă - intră în Strălucim Împreună',
    ctaRecognize: 'Recunoaște pe cineva',
    myWrapped: 'Rezumatul meu {{year}}',
    brillamosFolder: 'Strălucim Împreună',
    emptySent: 'Încă nu ai trimis recunoașteri.',
    emptyBrillamos: 'Încă nu există recunoașteri din ,,Strălucim” aici.',
    folderEmpty: 'Încă nu există recunoașteri în acest dosar.',
    recognizeName: 'Recunoaște pe {{name}}',
    // FAZA 6 (paritate demo, H-75/H-77/H-78) — profil `.rp2-*`.
    thisWeek: 'Săptămâna aceasta',
    weekdayInitials: 'L,M,M,J,V,S,D',
    badges: 'Insigne · Strălucim Împreună',
    recap: 'Rezumat {{year}}',
    sigmaMsg: '"Mulțumim că trăiești cultura Sigma"',
    sigmaFrom: '— Sigma · {{year}}',
    sigmaNote: 'Nicio recunoaștere primită în {{year}}. Această recunoaștere este o amintire a valorii tale pentru echipă.',
    sigmaNoteSent: 'Nicio recunoaștere trimisă în {{year}}. Această recunoaștere este o amintire a valorii tale pentru echipă.',
  },
  time: {
    moment: 'Chiar acum',
    hours: 'Acum {{n}} h',
    yesterday: 'Ieri',
    days: 'Acum {{n}} zile',
  },
  // ── WP-11 REQ-104 — Post-it interactiv / Word Builder ──
  builder: {
    modeLabel: 'Mod de recunoaștere',
    modeClassic: 'Clasic',
    modeInteractive: 'Interactiv',
    previewLabel: 'Previzualizarea recunoașterii',
    thanksWord: 'Îl recunosc pe',
    forWord: 'pentru',
    demonstratingWord: 'demonstrând',
    slotWho: 'pe cine?',
    slotWhat: 'ce a făcut?',
    slotFund: 'fundamental?',
    stepOf: 'Pasul {{step}} din {{total}}',
    step1Title: 'Pe cine recunoști?',
    step3Title: 'Ce comportament sau obicei?',
    step4Title: 'Adaugă-ți mesajul',
    complementPlaceholder: 'Descrie momentul concret pe care l-ai observat…',
    noActions: 'Acest Fundamental nu are comportamente sau obiceiuri configurate.',
    back: 'Înapoi',
    next: 'Următorul',
  },
  ri: {
    bankLabel: 'Bancă',
    bankTitle: 'Alege-ți cuvintele',
    bankHint: 'Atinge un cuvânt mai jos pentru a-ți completa post-it-ul 👇',
    forWhom: 'Pentru cine este',
    searchPlaceholder: 'Numele colegului…',
    catAccion: 'Fundamentale',
    catComportamiento: 'Comportamente',
    catHabito: 'Obiceiuri',
    catImpacto: 'Impact',
    msgLabel: 'Mesajul tău',
    msgTitle: 'Construiește-ți recunoașterea',
    words: 'elemente',
    clear: 'Golește',
    clickToRemove: 'Clic pentru a elimina',
    clickHint: 'Dă clic pe un cuvânt din bancă',
    pickFundFirst: '👆 Alege un fundamental pentru a vedea comportamentele lui',
    pickBehaviorFirst: '👆 Alege un comportament pentru a vedea obiceiurile lui',
    noHabitsForFund: '👆 Acest Fundamental nu are obiceiuri configurate',
    howLabel: 'Cum funcționează?',
    howTitle: 'Trei pași simpli',
    step1: '<strong>Treci mouse-ul</strong> peste un cuvânt și câmpul țintă se va aprinde.',
    step2: '<strong>Dă clic</strong> pe cuvânt pentru a-l pune în mesaj.',
    step3: '<strong>Dă clic pe câmpul</strong> post-it-ului pentru a elimina un cuvânt deja pus.',
    quote: 'A recunoaște înseamnă a numi invizibilul. Când îi spunem cuiva ce vedem în el, țesem comunitate.',
    cta: 'Completează-ți mesajul',
    ctaDone: 'Completează-ți mesajul →',
    popupTitle: 'Adaugă nota personală',
    popupChars: '30-80 de caractere ideal',
    nudgeMsg: 'Mesajul tău va avea mai mult impact dacă adaugi un rând propriu 💛',
    nudgeAdd: 'Adaugă un rând',
    nudgeSkip: 'Trimite așa',
    sent: 'Recunoaștere trimisă!',
    sentIntro: 'Mulțumesc colegului meu',
    continueBtn: 'Continuă →',
    seeRecognition: 'Vezi recunoașterea mea →',
    clearReset: 'Golește și începe din nou',
    wStep: 'Pasul {{step}} din {{total}}',
    wQPersona: 'Pe cine recunoști?',
    wQFund: 'Ce fundamental a trăit?',
    wQBehavior: 'Ce comportament a arătat?',
    wQHabit: 'Care a fost obiceiul?',
    wQImpact: 'Care a fost impactul?',
    templateThanks: 'Îl recunosc pe',
    templateForLiving: 'pentru că trăiește',
    templateWith: 'cu',
    templateShowing: ', demonstrând că',
    templateThat: '. Asta',
    slotPersona: 'persoană',
    slotAccion: 'fundamental',
    slotComportamiento: 'comportament',
    slotHabito: 'obicei',
    slotImpacto: 'impact',
    impact1: 'ne inspiră',
    impact2: 'ne face să creștem',
    impact3: 'ne aliniază',
    impact4: 'mișcă echipa înainte',
    tooltipFundamental: 'Un Fundamental este valoarea pe care persoana a trăit-o.',
    tooltipComportamiento: 'Comportamentul concret care a arătat acea valoare.',
    tooltipHabito: 'Obiceiul zilnic în care se observă acel comportament.',
    tooltipImpacto: 'Efectul pe care l-a avut asupra echipei.',
    guideStep1Title: 'Alege-ți cuvintele',
    guideStep1Text: 'Aici alegi Fundamentalul, comportamentul, obiceiul și impactul pe care vrei să le recunoști.',
    guideStep2Title: 'Post-it-ul tău prinde formă',
    guideStep2Text: 'Fiecare cuvânt ales completează un loc din fraza recunoașterii tale.',
    guideStep3Title: 'Adaugă atingerea ta personală',
    guideStep3Text: 'Acest mesaj face recunoașterea sa și mai specială.',
    guideStep4Title: 'Trimite recunoașterea',
    guideStep4Text: 'Când este completă, acest buton se activează și poți trimite.',
    guideReopen: 'Vezi din nou ghidul',
    guideNext: 'Următor',
    guideSkip: 'Sari peste',
    guideDone: 'Am înțeles',
    progressLabel: '{{value}} din {{total}} pași finalizați',
  },
  // ── WP-11 REQ-106 — Încărcare în masă CSV ──
  bulk: {
    or: 'sau',
    open: 'Încărcare în masă',
    title: 'Încărcare în masă a recunoașterilor',
    subtitle: 'Încarcă un CSV cu mai multe recunoașteri deodată, verifică și corectează înainte de a confirma.',
    stepInstructions: 'Instrucțiuni',
    stepUpload: 'Încarcă fișier',
    stepReview: 'Revizuire',
    stepConfirm: 'Confirmă',
    stepOf: 'Pasul {{step}} din {{total}}',
    next: 'Următorul',
    back: 'Înapoi',
    instructionsIntro: 'Descarcă șablonul, completează-l cu un coleg pe rând și încarcă-l pentru a valida și încărca în lot.',
    matchByIdentity: 'Caută persoana după adresa de e-mail înregistrată sau după numărul de marcă — este suficient unul dintre cele două. Nu știi adresa de e-mail? Numărul de marcă funcționează la fel de bine.',
    onePersonPerRowWarning: 'Important: fiecare rând din fișier reprezintă O SINGURĂ persoană. Nu introduce mai multe adrese de e-mail sau numere de marcă în aceeași celulă — dacă trebuie să recunoști mai multe persoane, adaugă câte un rând pentru fiecare.',
    // colRequired/colOptional: partajate cu adminBulkUsers/StepInstructions.tsx (registrul
    // Europa/SUA) — acest asistent nu le mai folosește (coloanele sale fixe nu au etichetă
    // obligatoriu/opțional). Nu le elimina într-o curățare aici fără să verifici mai întâi acel
    // celălalt consumator.
    colRequired: 'Obligatoriu',
    colOptional: 'Opțional',
    colNameNombre: 'Nume',
    colNameCorreoNomina: 'E-mail sau ID de salarizare',
    colNameFundamental: 'Fundament',
    colReceptorEmailDesc: 'E-mailul persoanei care primește recunoașterea.',
    colMensajeDesc: 'Mesajul recunoașterii. Poate fi obligatoriu în funcție de unitatea organizațională.',
    colEmisorEmailDesc: 'E-mailul celui care trimite. Obligatoriu: acest e-mail sau marca.',
    colReceptorNominaDesc: 'Numărul de marcă al destinatarului (AD, SuccessFactors sau registrul Europa). O alternativă la e-mail — nu îl înlocuiește, este util pentru persoane care nu au încă e-mail sau nu s-au înregistrat.',
    colEmisorNominaDesc: 'Marca celui care trimite. Obligatoriu: această marcă sau e-mailul.',
    markColumnsTitle: 'Plus câte o coloană pentru fiecare Fundament, Comportament și Obicei zilnic',
    markColumnsIntro: 'După aceste coloane fixe vei vedea câte o coloană pentru fiecare — marchează cu un X (sau orice alt semn, precum „da") pe cea potrivită. Nu trebuie să scrii niciun cod.',
    markFundamentalHint: 'Marchează unul sau mai multe Fundamente pe rând — până la limita permisă de unitatea ta organizațională.',
    markBehaviorHint: 'Comportamentul este opțional — poți marca mai multe.',
    markHabitHint: 'Obiceiurile zilnice sunt opționale — poți marca mai multe.',
    markColumnsOutro: 'Coloana Mensaje este ultima coloană din fișier, după toate coloanele de marcaj.',
    downloadTemplate: 'Descarcă șablonul',
    templateError: 'Șablonul nu a putut fi descărcat.',
    catalogError: 'Catalogul de Fundamente nu a putut fi încărcat. Încearcă din nou — fără catalog, fișierul nu poate fi validat.',
    upload: 'Încarcă CSV',
    dragDropHint: 'Trage fișierul CSV aici sau dă clic pentru a-l selecta.',
    invalidFileType: 'Sunt acceptate doar fișiere CSV.',
    emptyFile: 'Fișierul nu are rânduri cu date.',
    parseError: 'Fișierul CSV nu a putut fi citit.',
    uploadError: 'Încărcarea în masă nu a putut fi procesată.',
    validRows: '{{count}} rânduri valide',
    invalidRows: '{{count}} cu erori',
    reviewHint: 'Corectează rândurile evidențiate cu roșu direct în tabel; fiecare modificare este revalidată.',
    colLine: '#',
    colReceptor: 'Destinatar',
    colFundamental: 'Fundamental',
    colMensaje: 'Mesaj',
    colReceptorNomina: 'Nr. marcă',
    colBehavior: 'Comportament',
    colHabits: 'Daily Habits',
    colStatus: 'Stare',
    ok: 'Valid',
    expandRow: 'Vezi detaliile rândului {{line}}',
    collapseRow: 'Ascunde detaliile rândului {{line}}',
    habitsCount_one: '{{count}} Obicei zilnic',
    habitsCount_other: '{{count}} Obiceiuri zilnice',
    revalidating: 'Se revalidează…',
    downloadErrors: 'Descarcă erorile (CSV)',
    confirmSummary: 'Vor fi create {{count}} recunoașteri. Rândurile cu erori sunt omise.',
    confirm: 'Încarcă {{count}} valide',
    committed: 'Au fost create {{created}} recunoașteri. {{skipped}} rânduri au fost omise.',
    duplicatesSkipped_one: '1 recunoaștere nu a fost trimisă: fusese deja trimisă anterior cu același mesaj.',
    duplicatesSkipped_other: '{{count}} recunoașteri nu au fost trimise: fuseseră deja trimise anterior cu același mesaj.',
    notFoundTitle: 'E-mailuri negăsite în director:',
    errors: {
      receptorRequired: 'E-mailul destinatarului este obligatoriu.',
      receptorNotFound: 'Acest e-mail nu există în director.',
      emisorMissing: 'Lipsește emițătorul: indică e-mailul sau marca celui care recunoaște.',
      emisorOtherUnit: 'Emițător din afara unității tale: poți încărca doar în numele persoanelor din unitatea ta.',
      emisorStaff: 'Emițător cu cont corporativ (staff): se poate încărca doar în numele personalului operațional.',
      delegateCheckUnavailable: 'Nu am putut verifica emițătorii din fișier și nu s-a încărcat nimic. Încearcă din nou în câteva minute.',
      multiplePeopleNotSupported: 'Această coloană trebuie să conțină o singură persoană (un e-mail sau un număr de marcă). Pentru a recunoaște mai multe persoane, adaugă câte un rând pentru fiecare.',
      fundamentalInvalid: 'Fundamentalul este obligatoriu, sau mesajul nu respectă cerințele unității tale organizaționale.',
      selfRecognition: 'Nu te poți recunoaște pe tine însuți.',
      blockedWord: 'Mesajul conține un cuvânt care nu este permis.',
      weeklyCapExceeded: 'Expeditorul a atins limita săptămânală de recunoașteri.',
      duplicateInFile: 'Acest rând se repetă în fișier.',
      behaviorInvalid: 'Comportamentul nu este valid pentru Fundamentalul acestui rând.',
      habitInvalid: 'Unul dintre Daily Habits nu este valid pentru Fundamentalul acestui rând.',
      campaignClosed: 'Campania nu este activă.',
      notAllowedForCampaign: 'Acest rând nu este permis pentru campania acestui lot.',
      maxFundamentalsExceeded: 'Nu poți selecta mai multe Fundamente pentru această recunoaștere: limita este stabilită de configurația unității organizaționale a expeditorului.',
      generic: 'Acest rând nu a putut fi validat.',
    },
  },
  // ── WP-11 REQ-107 — Acțiuni post-it ──
  actions: {
    // RF-086 / RN-M06 — catalogul de motive (`reportReasons`) a fost eliminat: motivul e text liber.
    reportCharsLeft: 'Au mai rămas {{n}} caractere',
    edit: 'Editează',
    report: 'Raportează',
    delete: 'Șterge',
    saveEdit: 'Salvează',
    editError: 'Recunoașterea nu a putut fi editată.',
    editMinChars: 'Mesajul trebuie să aibă cel puțin {{min}} caractere ({{count}}/{{min}}).',
    reportReason: 'Motivul raportării',
    reportPlaceholder: 'Descrie pe scurt problema…',
    reportError: 'Raportarea nu a putut fi trimisă.',
    reportSent: 'Raportare trimisă. Echipa noastră o va analiza.',
    sendReport: 'Trimite raportarea',
    deleteConfirm: 'Sigur vrei să ștergi această recunoaștere? Această acțiune nu poate fi anulată.',
    deleteError: 'Recunoașterea nu a putut fi ștearsă.',
    confirmDelete: 'Da, șterge',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Încărcare în masă a evidenței de personal (Europa și SUA)',
      descLong: 'Creează și actualizează evidența de personal Europa/SUA dintr-un CSV cu 24 de coloane, plus regiunea fișierului (Europa sau SUA), aleasă la încărcare. Este incrementală: cine lipsește din fișier rămâne neschimbat, iar plecările se marchează prin coloana EMPLOYEE DELETED. La plecări, e-mailul poate fi golit sau modificat, iar e-mailul unei persoane plecate devine disponibil pentru alții. Celelalte regiuni sunt sincronizate automat de SuccessFactors.',
      importHint: 'Descarcă modelul, completează-l și încarcă-l. La încărcare se afișează întâi o previzualizare care nu scrie nimic. Format dată MM/dd/aaaa.',
      openWizard: 'Deschide încărcarea în masă',
      wizardSubtitle: 'Încarcă CSV-ul evidenței, verifică rezultatul și confirmă — nu se scrie nimic până la ultimul pas.',
      confirm: 'Confirmă încărcarea',
      downloadErrors: 'Descarcă erorile (CSV)',
      received: 'Rânduri',
      created: 'Create',
      updated: 'Actualizate',
      deactivated: 'Dezactivate',
      skipped: 'Omise',
      disabled: 'Încărcarea în masă Europa/SUA este dezactivată în configurarea surselor.',
      previewNotice: 'Previzualizare: nu s-a scris încă nimic. Acestea sunt numărătorile pe care le va avea încărcarea reală.',
      allOk: 'Toate rândurile au fost procesate fără erori.',
      blockingErrorsNotice: 'Există erori care împiedică continuarea. Corectează fișierul și încarcă-l din nou.',
      importError: 'Fișierul nu a putut fi procesat.',
      importErrorTimeout: 'Serverul a durat prea mult să răspundă. Este posibil ca încărcarea să se fi finalizat totuși pe server — verifică evidența de personal înainte de a încerca din nou. Referință: {{correlationId}}',
      ignoredColumnsNotice: 'Aceste coloane din fișierul tău nu sunt recunoscute și vor fi ignorate: {{columns}}',
      confirmRecap: 'Vor fi procesate {{total}} rânduri: {{created}} create, {{updated}} actualizate, {{deactivated}} dezactivate.',
      committed: 'Încărcare finalizată: {{created}} create, {{updated}} actualizate, {{deactivated}} dezactivate, {{skipped}} omise.',
      committedErrorsNotice: 'Unele rânduri au avut probleme în timpul încărcării. Verifică detaliile înainte de a considera aceste date corecte.',
      paginationPage: 'Pagina {{page}} din {{total}}',
      errorColumn: 'Coloană',
      errorDetail: 'Detaliu erori / omisiuni',
      ouLabel: 'Regiunea fișierului',
      ouPlaceholder: 'Selectează o regiune',
      ouEuropa: 'Europa',
      ouUsa: 'Statele Unite (SUA)',
      ouCentral: 'Central',
      ouHint: 'Se aplică tuturor rândurilor din fișier. Nu se mai scrie pe fiecare rând în CSV, pentru a evita erorile de tastare sau de limbă.',
      ouRequired: 'Selectează regiunea înainte de a încărca fișierul.',
      errorCode: {
        'email-in-use-active': 'Adresa de e-mail este folosită de un utilizator activ, introdu o altă adresă validă.',
        'reactivation-email-in-use': 'Nereactivat: adresa de e-mail este folosită de un utilizator activ, introdu o altă adresă validă.',
        'import-audit-failed': 'Încărcarea a fost aplicată, dar nu a putut fi înregistrată în jurnalul încărcărilor. Contactează suportul.',
        'user-audit-failed': 'Încărcarea a fost aplicată, dar nu a putut fi înregistrat cine a încărcat unele persoane. Contactează suportul.',
        'cache-not-cleared': 'Încărcarea a fost aplicată, dar memoria cache nu a putut fi golită pentru unele persoane: datele lor pot părea depășite timp de cel mult o oră.',
        'row-write-failed': 'Acest rând nu a putut fi salvat; dacă problema persistă, contactează suportul.',
      },
      col: {
        employeeDeleted: '1 dezactivează persoana; 0 sau gol o lasă activă. La dezactivarea unei persoane, e-mailul ei devine liber pentru alți utilizatori; dacă este reactivată (0) iar e-mailul ei este deja folosit de un utilizator activ, nu este reactivată și rândul este raportat.',
        localId: 'Numărul de personal al angajatului. Este cheia: fără el rândul nu poate fi procesat.',
        firstName: 'Prenume.',
        lastName: 'Nume de familie.',
        secondLastName: 'Al doilea nume de familie (opțional).',
        completeName: 'Numele complet așa cum trebuie afișat. Dacă e gol, se construiește din cele trei câmpuri anterioare.',
        email: 'E-mailul angajatului. Poate fi gol — fișa rămâne în evidență până când persoana se înregistrează. Pe rândurile de PLECARE (EMPLOYEE DELETED = 1), o celulă goală șterge e-mailul persoanei (rămâne fără e-mail), iar un e-mail nou îl înlocuiește, cu condiția să nu fie folosit de alt utilizator activ; pe rândurile care nu sunt plecări, o celulă goală nu schimbă nimic.',
        bu: 'Unitate de afaceri.',
        siteId: 'Identificatorul locației/fabricii.',
        site: 'Numele locației/fabricii.',
        orgDirectionId: 'Identificatorul Direcției Organizaționale.',
        orgDirection: 'Numele Direcției Organizaționale.',
        funcDirectionId: 'Identificatorul Direcției Funcționale.',
        funcDirection: 'Numele Direcției Funcționale.',
        departmentId: 'Identificatorul Departamentului.',
        department: 'Numele Departamentului.',
        jobPosition: 'Postul angajatului.',
        manager: 'Numele șefului direct (doar informativ).',
        managerId: 'Numărul de personal al șefului direct. Folosit pentru a lega ierarhia; șeful trebuie să existe deja în evidență.',
        managerEmail: 'E-mailul șefului direct (doar informativ).',
        hireDate: 'Data angajării, format MM/dd/aaaa.',
        birthDate: 'Data nașterii, format MM/dd/aaaa.',
        notification: "YES sau NO: dacă persoana primește notificări. Gol înseamnă 'nedefinit', nu NO.",
        country: 'Țara persoanei. Opțional, dar fără el persoana rămâne în afara domeniului administratorilor de țară.',
      },
    },
    title: 'Administrare',
    subtitle: 'Configurează Programul de Recunoaștere.',
    denied: 'Nu ai permisiuni pentru a accesa această secțiune.',
    save: 'Salvează',
    saving: 'Se salvează…',
    saved: 'Modificări salvate',
    saveError: 'Modificările nu au putut fi salvate.',
    rowsPerPage: 'Rânduri pe pagină',
    fundPanelTitle: 'Admin Fundamentale — Recunoaștere',
    fundPanelSubtitle: 'Fiecare modul este independent. Activează-l sau dezactivează-l în funcție de nevoile organizației tale.',
    pager: {
      showing: 'Se afișează {{range}} din {{total}}',
      perPage: '{{size}} pe pagină',
      all: 'Toate',
      prev: 'Pagina anterioară',
      next: 'Pagina următoare',
      pageSize: 'Rezultate pe pagină',
    },
    nav: {
      roles: 'Configurează rolurile și permisiunile',
      points: 'Puncte',
      moderation: 'Moderare',
      winners: 'Câștigători',
      campaigns: 'Campanii',
      reports: 'Rapoarte',
      team: 'Echipă',
      dashboard: 'Tablou de bord',
      management: 'Gestiune',
      notifications: 'Notificări',
      views: 'Vizualizări',
      docs: 'Documentație',
      recap: 'Recap',
    },
    roles: {
      title: 'Configurează rolurile și permisiunile',
      desc: 'Gestionează administratorii, aria lor pe OU/țară și matricea lor de permisiuni.',
      searchEmail: 'Caută după e-mail…',
      empty: 'Nu există administratori de afișat.',
      colAdmin: 'Administrator',
      colRole: 'Rol',
      colScope: 'Arie',
      colStatus: 'Stare',
      allScopes: 'Toate',
      active: 'Activ',
      inactive: 'Inactiv',
      edit: 'Editează',
      remove: 'Elimină',
      removeConfirmTitle: 'Elimină administratorul Brillamos',
      removeConfirmMsg: 'Elimini „{{name}}" ca administrator Brillamos? Contul rămâne colaborator standard.',
      removeConfirm: 'Da, elimină',
      removeError: 'Rolul de administrator nu a putut fi eliminat. Încearcă din nou.',
      status: 'Stare',
      permMatrix: 'Matricea de permisiuni',
      readOnlyConflict: '„Doar citire” nu poate coexista cu permisiuni de scriere (RN-R03). Sunt bifate: {{permisos}}. Modificarea oricărei căsuțe rezolvă conflictul; salvat așa, serverul îl respinge.',
      addAdmin: 'Adaugă administrator',
      addTitle: 'Adaugă administrator',
      editTitle: 'Editează administrator — {{name}}',
      searchPersonLabel: 'Caută angajat',
      searchPersonPlaceholder: 'Numele sau e-mailul angajatului…',
      alreadyAdminNote: 'Această persoană este deja administrator Recunoaștere — editează datele mai jos.',
      cannotEditGlobal: 'Această persoană are deja rolul Admin General. Acel rol nu se gestionează de aici.',
      selectRolePlaceholder: 'Selectează un rol…',
      selectRoleFirst: 'Alege un rol înainte de a salva.',
      accountActive: 'Cont activ (acces la platformă)',
      accountActiveHint: 'Este contul persoanei, nu rolul de administrator. Dezactivat, persoana nu se poate autentifica pe platformă.',
      deactivateAccountTitle: 'Dezactivează contul',
      deactivateAccountMsg: '{{name}} nu se va mai putea autentifica pe platformă. Rolul nu este eliminat: contul este dezactivat. Continuați?',
      deactivateAccountConfirm: 'Da, dezactivează contul',
      peopleLabel: 'Persoane',
      peopleHint: 'Adăugați câte persoane aveți nevoie: căutați-le și adăugați-le una după alta sau lipiți mai multe e-mailuri separate prin punct și virgulă sau virgulă. Toate primesc același rol, aceeași arie și aceleași permisiuni.',
      peopleCount: 'Persoane selectate: {{count}}',
      removeAllPeople: 'Elimină toate',
      removePerson: 'Elimină pe {{name}}',
      alreadyAdminTag: 'Este deja administrator',
      alreadyAdminBulkNote: '{{count}} dintre aceste persoane sunt deja administratori Brillamos: la salvare, rolul și permisiunile lor sunt înlocuite cu cele de mai jos.',
      globalSkipped: '{{names}} nu a fost adăugat: are rolul Admin General, care nu se gestionează de aici.',
      resolvingEmails: 'Se caută {{count}} e-mailuri…',
      emailsNotFound: 'Nu s-a găsit nimeni cu aceste e-mailuri: {{emails}}',
      bulkProgress: 'Se salvează {{done}} din {{total}}…',
      bulkDone: 'Rol atribuit tuturor celor {{count}} persoane.',
      bulkPartial: 'Atribuit la {{ok}} din {{total}}. Cele care au eșuat rămân în listă; verificați motivul și salvați din nou:',
      saveForPeople: 'Salvează pentru {{count}} persoane',
      saveForbidden: 'Nu ai permisiunea să faci această modificare.',
      role: {
        AdminGlobal: 'Admin General',
        AdminBrillamos: 'Admin Recunoaștere',
        AdminOUBrillamos: 'Admin OU Recunoaștere',

        AdminOU: 'Admin OU Pulse',
      },
    },
    perm: {
      manageUsers: 'Gestionează utilizatorii',
      manageRecognitions: 'Gestionează recunoașterile',
      manageNotifications: 'Gestionează notificările',
      manageDocuments: 'Gestionează documentele',
      manageWinners: 'Gestionează câștigătorii',
      viewAnalytics: 'Vezi analytics',
      viewReports: 'Vezi rapoartele',
      exportData: 'Exportă datele',
      configureViews: 'Configurează vizualizările',
      bulkCsv: 'Trimitere în masă (CSV)',
      moderateContent: 'Moderează conținutul',
      manageCampaigns: 'Gestionează campaniile',
      createCampaigns: 'Creează și gestionează campanii',
      readOnly: 'Doar citire',
      approveNominations: 'Confirmă câștigătorii',
      managePoints: 'Gestiune',
      manageRoles: 'Configurează rolurile și permisiunile',
      manageBlockedWords: 'Gestionează cuvintele blocate',
      managePointsConfig: 'Puncte',
      manageRecap: 'Editează Recap-ul anual',
      delegateRecognition: 'Recunoaște în numele altcuiva',
      accessCatalogFundamentals: 'Catalog Fundamentals',
      accessCatalogOus: 'Catalog OU-uri',
    },
    points: {
      title: 'Puncte',
      desc: 'Configurează punctele pe criteriu (0-9), în oglindă Staff/Frontline. Punctele nu sunt niciodată vizibile angajatului.',
      empty: 'Niciun criteriu de puncte configurat.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Activ',
      segmentActiveHint: 'Dacă este dezactivat, acest tabel (Staff sau Frontline) nu acordă puncte chiar dacă are criterii configurate.',
      lockedCampaign: 'Configurația nu mai poate fi editată după ce campania a început.',
      campaignActiveWarning: 'Configurația punctelor nu poate fi editată cât timp există o campanie activă în această unitate organizațională.',
      colCategory: 'Categorie',
      colCriterion: 'Criteriu',
      colPoints: 'Puncte',
      colActive: 'Activ',
      criterionActiveHint: 'Dacă este dezactivat, acest criteriu nu acordă puncte chiar dacă este îndeplinit.',
      colAccumulated: 'Total acumulat',
      accumulatedFooter: 'Nominalizări evaluate',
      resetAccumulated: 'Resetare la 0',
      resetAccumulatedConfirmTitle: 'Resetare total acumulat',
      resetAccumulatedConfirmMessage: 'Contorul „Total acumulat” al acestei OU și segment va reporni de la 0. Istoricul recunoașterilor NU este șters; doar nu se mai contorizează de acum înainte. Această acțiune nu poate fi anulată.',
      resetAccumulatedSuccess: 'Totalul acumulat a fost resetat la 0.',
      resetAccumulatedError: 'Nu s-a putut reseta totalul acumulat.',
      accumulatedError: 'Numărul de nominalizări nu a putut fi încărcat.',
      accumulatedDisabledHint: 'Cu punctele dezactivate motorul nu evaluează, deci totalul rămâne zero chiar dacă există recunoașteri.',
      globalToggle: 'Se aplică puncte (global)',
      globalToggleHint: 'Activează sau dezactivează sistemul de puncte pentru TOATE unitățile organizaționale, indiferent de configurația proprie a fiecăreia.',
      visibleToEmployees: 'Vizibil pentru angajați',
      visibleToEmployeesHint: 'Afișează pe post-it punctele fiecărei aprecieri din această OU. Niciodată totalul unei persoane.',
      visibleUnknown: 'Starea comutatorului nu a putut fi citită. Nu se schimbă nimic până nu se știe.',
      visibleGdprBlocked: 'Această OU este supusă GDPR: punctele nu se afișează nici cu comutatorul pornit.',
      globalOffHint: 'Comutatorul global este oprit: nicio OU nu acordă puncte, chiar dacă tabelul ei este activ.',
      ouPicker: 'Unitate organizațională',
      ouPickPlaceholder: 'Selectează o unitate…',
      pickOuFirst: 'Selectează o unitate organizațională pentru a vedea și edita configurația de puncte.',
      accumulatedNoKey: 'Acest criteriu nu are cheie canonică, deci nu poate fi asociat cu numărătoarea.',
      globalOverriddenHint: 'Această unitate are propria excepție, deci aici comutatorul este {{estado}}, indiferent de valoarea globală.',
      globalOn: 'pornit',
      globalOff: 'oprit',

      globalUnknown: 'Comutatorul global nu a putut fi citit; starea sa reală este necunoscută.',
      noOuInProfile: 'Profilul tău nu are o unitate organizațională atribuită, deci nu există configurație de puncte de afișat. Cere-o administratorului global.',
      exportReport: 'Descarcă raportul de puncte',
      exporting: 'Se descarcă…',
      exportError: 'Raportul de puncte nu a putut fi generat. Încearcă din nou.',
      exportEmpty: 'Nu există rânduri de puncte de exportat în acest domeniu.',
      exportTruncated: 'Raportul a fost trunchiat la {{tope}} rânduri; restrânge domeniul pentru a exporta totul.',
      exportNamesUnresolved: 'Unele nume nu au putut fi rezolvate; acele rânduri afișează identificatorul.',
      exportColPerson: 'Persoană',
      exportColOu: 'Unitate organizațională',
      exportColPoints: 'Puncte'
    },
    placeholder: {
      soon: 'Această secțiune va fi disponibilă în curând.',
      tracked: 'Urmărire: {{req}}',
    },
    recognitions: {
      title: 'Recunoașteri',
      descLong: 'Gestionează catalogul de Fundamentale/Obiceiuri: creare, editare, activare/dezactivare, legare la campanie și microsite.',
      tabActive: 'Fundamentale',
      tabTrash: 'Coș de gunoi',
      tabHabits: 'Daily Habits',
      newHabit: 'Daily Habit nou',
      habitSearchPlaceholder: 'Caută habit…',
      habitsEmpty: 'Nu există Daily Habits în catalog.',
      colColor: 'Culoare',
      colNameEs: 'Nume (ES)',
      colNameEn: 'Nume (EN)',
      colParent: 'Fundamental părinte',
      colOuVisibility: 'Vizibilitate pe OU',
      ouInherited: 'Moștenit de la fundamental',
      habitStatusAll: 'Toate',
      habitStatusActive: 'Active',
      habitStatusInactive: 'Inactive',
      deleteHabitConfirm: 'Ștergi acest Daily Habit din catalog?',
      newHabitTitle: 'Daily Habit nou',
      editHabitTitle: 'Editează Daily Habit',
      new: 'Fundamental nou',
      searchPlaceholder: 'Caută după cod sau nume…',
      empty: 'Catalogul este gol.',
      colCode: 'Cod',
      colName: 'Nume',
      colHabits: 'Obiceiuri',
      colBrillamos: 'Strălucim',
      colMicrosite: 'Microsite',
      colStatus: 'Stare',
      inBrillamos: 'În Strălucim',
      notInBrillamos: 'În afară',
      openMicrosite: 'Deschide',
      edit: 'Editează',
      deleteConfirm: 'Trimiți acest Fundamental la coșul de gunoi?',
      trashEmpty: 'Coșul de gunoi este gol.',
      newTitle: 'Fundamental nou',
      editTitle: 'Editează {{code}}',
      needAllLangs: 'Completează numele în toate cele 7 limbi.',
      fieldCode: 'Cod',
      fieldOrder: 'Ordine',
      fieldName: 'Nume',
      fieldShortName: 'Nume scurt',
      fieldColor: 'Culoare',
      fieldMicrosite: 'URL-ul microsite-ului',
      fieldCampaignScope: 'Campanie legată',
      campaignScopeHint: 'Id de campanie (gol = catalog global)',
      fieldBrillamos: 'Participă la Strălucim Împreună',
      legacyCatalogWarning: 'Acest catalog este temporar: modificările de aici încă nu se reflectă în ce văd persoanele atunci când oferă o recunoaștere (P2-010).',
    },
    moderation: {
      desc: 'Cuvinte blocate și cutia de raportări.',
      title: 'Moderare',
      descLong: 'Cutia de raportări cu direcționare, catalog de cuvinte blocate și comutatoare de moderare.',
      contentTitle: 'Moderarea Conținutului',
      wordsTitle: 'Cuvinte Blocate',
      wordsDesc: 'Sunt detectate și blocate automat la trimiterea unei recunoașteri.',
      wordsCounted: 'cuvinte blocate',
      manageWords: 'Gestionează',
      wordsManagerDesc: 'Adaugă, editează sau șterge cuvinte pe limbă. Compatibil cu peste 100 de cuvinte.',
      newWord: 'Cuvânt nou',
      region: 'Țară/Regiune',
      regionGlobal: 'Global (toate)',
      regionHint: 'Aceeași limbă poate avea cuvinte diferite în funcție de țară sau regiune.',
      allRegions: 'Toate regiunile',
      searchWord: 'Caută…',
      editWord: 'Editează cuvântul',
      word: 'Cuvânt',
      wordPlaceholder: 'Ex.: nepotrivit…',
      language: 'Limbă',
      addWord: 'Adaugă',
      wordsEmpty: 'Niciun cuvânt nu corespunde filtrului.',
      langOther: 'Altele',
      // RF-082 — tabelul tara→limbi care stabileste ce catalog se aplica fiecarui expeditor.
      countryLanguagesTitle: 'Țări și limbi',
      countryLanguagesDesc: 'Stabilește ce limbi se vorbesc în fiecare țară. O țară multilingvă (Belgia: nl și fr) aplică cuvintele din toate limbile sale fără a le introduce de două ori. Țări în ISO-3166 (MX, ES, BE) și limbi dintre cele 7 ale platformei (es, en, pt, fr, de, nl, ro). Pentru a limita un cuvânt la o singură țară, folosește câmpul său Țară/Regiune.',
      countryLanguagesEmpty: 'Tabelul cu țări și limbi este gol.',
      regionsTitle: 'Regiuni',
      regionMembers: 'Țările care o compun',
      countryLanguagesInvalid: 'Verifică aceste coduri înainte de salvare: {{codes}}. Țara se scrie în ISO din 2 litere (MX), iar limba trebuie să fie una dintre cele 7 ale platformei (es, en, pt, fr, de, nl, ro), fără variantă de țară.',
      countryLanguagesUnreadable: 'Tabelul nu a putut fi citit, deci nu se poate salva: salvarea îl înlocuiește în întregime și s-ar pierde ce nu se vede.',
      country: 'Țară',
      languages: 'Limbi',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Adaugă țară',
      countryPlaceholder: 'MX',
      autoTitle: 'Configurarea Auto-Moderării',
      aiAutoBlock: 'Blocare automată prin IA',
      aiAutoBlockHint: 'Când este activă, fiecare mesaj de recunoaștere este verificat prin IA (Azure AI Content Safety) la trimitere și blocat dacă este ofensator.',
      helpAria: 'Ajutor',
      aiHelp: 'Verifică fiecare mesaj cu IA (Azure AI Content Safety) la trimitere și detectează toxicitatea în context (ură, amenințări, hărțuire). Se adaugă catalogului de cuvinte blocate: ambele pot fi active în același timp. Necesită ca „Moderare activă (globală)" să fie pornită; cu întrerupătorul global oprit, acest strat nu se aplică.',
      globalHelp: 'Întrerupătorul principal al moderării. Dacă este oprit, NIMIC nu este moderat: nici blocarea prin IA, nici catalogul de cuvinte blocate și nu se acceptă raportări. Pornește-l pentru ca celelalte straturi să funcționeze.',
      wordsHelp: 'Blochează cuvinte exacte la trimitere, indiferent de context. Completează blocarea prin IA (care detectează toxicitatea în context). Ambele straturi necesită ca „Moderare activă (globală)" să fie pornită.',
      hideThreshold: 'Pragul de raportări pentru ascundere',
      notifyReporter: 'Notifică persoana care a raportat',
      aiPendingNote: 'Cu blocarea automată prin IA activată, mesajele de recunoaștere sunt validate de Azure AI Content Safety la trimitere și respinse dacă încalcă normele de conviețuire. Funcționează împreună cu catalogul de cuvinte blocate.',
      hideThresholdHint: 'Câte raportări sunt necesare pentru a ascunde automat o recunoaștere. Valoarea 1 este regula în vigoare: se ascunde la prima raportare.',
      notifyReporterHint: 'Salvează preferința și o trimite odată cu evenimentul de moderare. E-mailul către raportor va fi trimis de NotificationService când acea notificare va exista.',
      advanced: 'Configurare avansată',
      globalEnabled: 'Moderare activă (globală)',
      reportEnabledGlobal: 'Raportare activată implicit',
      dailyReportLimit: 'Limită zilnică de raportări',
      // RF-084 — exceptii pentru "permite raportarea" pe nod, in cascada Site -> BU -> OU -> global.
      overridesTitle: 'Raportare pe unitate (cascadă)',
      overridesDesc: 'Excepții de la valoarea globală. Câștigă nodul cel mai specific: Site, apoi BU, apoi OU și unitățile superioare. O unitate fără excepție o moștenește pe cea a unității părinte.',
      overridesNode: 'Unitate, BU sau Site',
      overridesNodePlaceholder: 'Alege o OU sau scrie un id de BU/Site',
      overridesAllow: 'Permis',
      overridesBlock: 'Blocat',
      overridesEmpty: 'Fără excepții: toate unitățile folosesc valoarea globală.',
      overridesDuplicate: 'Există deja o excepție pentru „{{node}}”. Identificatorii nu fac distincție între majuscule și minuscule: modific-o sau elimin-o pe cea existentă.',
      inboxTitle: 'Cutia de Raportări',
      inboxDesc: 'Raportări ale utilizatorilor. La ascundere, recunoașterea dispare de pe peretele celui care a primit-o și din recunoașterile trimise de cel care a emis-o; este eliminată și din clasamentul cu medalii, iar punctele sunt anulate.',
      searchName: 'Caută după nume…',
      filterAll: 'Toate',
      filterOu: 'OU: Toate',
      filterBu: 'BU: Toate',
      filterSite: 'Site: Toate',
      filterFrom: 'De la',
      filterTo: 'Până la',
      filterType: 'Tip: Toate',
      type: { fundamentales: 'Fundamentale', brillamos: 'Strălucim Împreună', diario: 'Recunoaștere Zilnică' },
      uiStatus: { pendiente: 'În așteptare', restaurado: 'Restaurat', eliminado: 'Șters' },
      uiStatusPlural: { pendiente: 'În așteptare', restaurado: 'Restaurate', eliminado: 'Șterse' },
      status: { Publicado: 'Publicat', Pendiente: 'În așteptare', Resuelto: 'Rezolvat', Desestimado: 'Respins' },
      reportsEmpty: 'Nicio raportare nu corespunde filtrului.',
      colReportedBy: 'Raportat de',
      colRecognitionFrom: 'Recunoaștere de la',
      colTo: 'Pentru',
      colDetail: 'Detaliu',
      colReason: 'Motiv',
      colDate: 'Dată',
      colStatus: 'Stare',
      colActions: 'Acțiuni',
      // RF-090 — butonul plic: escaladeaza cazul catre adminul OU/tarii, fara sa astepte rezumatul.
      notifyAdmin: 'Anunță adminul',
      notifyAdminHint: 'Trimite acum o înștiințare administratorului unității acestei recunoașteri, fără să aștepte rezumatul săptămânal.',
      notifyAdminConfirm: 'Trimiți o înștiințare administratorului unității lui {{name}}? Un e-mail pleacă imediat.',
      notifyAdminSent: 'Înștiințare trimisă administratorului.',
      notifyAdminError: 'Înștiințarea către administrator nu a putut fi trimisă.',
      // RF-090 — previzualizarea destinatarilor: butonul plic spunea „trimis” chiar dacă nu ajungea la nimeni.
      notifyPreviewTitle: 'Această înștiințare va ajunge la:',
      notifyPreviewLoading: 'Se determină destinatarii…',
      notifyPreviewEmpty: 'Nu s-a putut determina niciun destinatar.',
      notifyPreviewError: 'Nu s-a putut verifica la cine ar ajunge înștiințarea.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Această unitate nu are niciun administrator înregistrat și nu există administratori globali către care să se escaladeze cazul.',
        'escalado-a-globales': 'Unitatea nu are administrator propriu: cazul este escaladat către administratorii globali.',
        'admin-sin-correo': 'Administratorul nu are o adresă de e-mail utilizabilă în director, așa că nu i se poate scrie.',
        'directorio-no-responde': 'Directorul de utilizatori nu a răspuns: nu se poate ști cine ar trebui înștiințat.',
        'suprimido-por-allowlist': 'Trimiterea ar fi eliminată: această adresă nu se află pe lista destinatarilor permiși ai serviciului de notificări.',
        'allowlist-desconocida': 'Lista destinatarilor permiși nu a putut fi verificată; trimiterea ar putea fi eliminată fără urmă.',
        desconocido: 'Înștiințarea nu poate fi trimisă dintr-un motiv pe care serviciul nu l-a putut explica.',
      },
      deleteLabel: 'Șterge',
      hideHint: 'Ascunde recunoașterea de pe perete, o elimină din clasamentul cu medalii și îi anulează punctele.',
      restore: 'Restaurează',
      reopen: 'Redeschide',
      reopenHint: 'Readuce cazul în coadă ca În așteptare și ascunde din nou recunoașterea.',
      viewDetail: 'Vezi detaliile',
      detailTitle: 'Detaliile raportării',
      whoReported: 'Cine a raportat',
      whoWasReported: 'Cine a fost raportat',
      reportedRecognition: 'Recunoaștere raportată',
      messageUnavailable: 'Text indisponibil.',
      // RF-087 — direcționarea cazului: e-mailul și OU se afișează mereu, cu marcaj dacă lipsesc.
      dataUnavailable: 'Indisponibil',
      detailLoading: 'Se încarcă…',
      detailError: 'Nu s-au putut încărca datele de contact actualizate; se afișează cele salvate în momentul raportării.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
      colCampaign: 'Campanie',
      filterCampaign: 'Campanie: Toate',
    },
    winners: {
      // Task 2.5 — grilă de carduri pentru Insigne de campanie în Câștigători (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Insigne de campanie',
        permanenceNote: 'Aceste insigne sunt permanente: nu se activează sau dezactivează ca insignele de serie; rămân legate de campania și anul pentru care au fost acordate.',
        empty: 'Încă nu există insigne de campanie.',
        edit: 'Editează',
        delete: 'Șterge',
        deleteConfirm: 'Ștergi insigna de campanie „{{name}}”? Se pierd numele în cele 7 limbi, iconița și anul. Această acțiune nu poate fi anulată.',
        add: '+ Adaugă insignă',
        editTitle: 'Editează insigna de campanie',
        fieldTitle: 'Titlu',
        fieldYearSubtitle: 'An / Subtitlu',
        fieldYear: 'Anul premiului',
        yearNone: 'Fără an',
        fieldYearHint: 'Se verifică la acordare: o insignă dintr-un an nu poate fi acordată într-o campanie din alt an. „Fără an” dezactivează verificarea.',
        fieldImage: 'Imagine',
        imageUploadHintNew: 'Salvează mai întâi insigna pentru a putea încărca imaginea acesteia.',
        imageFormatInvalid: 'Formatul imaginii nu este valid. Folosește PNG, JPG, WEBP sau SVG.',
        previewTitle: 'Previzualizare',
      },
      bulkTitle: 'Confirmare în lot',
      bulkSelected: '{{count}} selectate',
      bulkConfirm: 'Confirmă {{count}}',
      bulkConfirming: 'Se confirmă…',
      bulkClear: 'Anulează selecția',
      bulkSelectAll: 'Selectează toate cele în așteptare de pe această pagină',
      bulkSelectOne: 'Selectează {{name}}',
      bulkFailed: '{{count}} nu au putut fi confirmate. Restul da; reîncearcă doar cu acelea.',
      editTitle: 'Editează câștigătorul — {{nombre}}',
      actionError: 'Acțiunea nu a putut fi finalizată.',
      badExtension: 'Format neacceptat. Se acceptă: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Funcție',
      colDepto: 'Departament',
      colFundamental: 'Fundamental',
      colStatus: 'Stare',
      colUser: 'Utilizator',
      colUserNomina: 'Număr de marcă: {{nomina}}',
      colSite: "Site",
      colEmail: "E-mail",
      exportSheetName: "Câștigători",
      exportTitle: "Câștigători",
      exportSubtitle: "Câștigători înregistrați cu filtrele aplicate",
      colYear: 'An',
      colBadge: 'Insignă',
      badgeNone: 'Fără insignă',
      exportFiltered: 'Descarcă în Excel câștigătorii afișați de filtrele curente',
      exportEmpty: 'Nu există câștigători de exportat cu aceste filtre',
      exporting: 'Se exportă…',
      exportError: 'Descărcarea nu a putut fi finalizată. Încearcă din nou.',
      confirmAction: 'Confirmă drept câștigător',
      confirmDelete1: 'Elimini {{nombre}} din lista câștigătorilor?',
      confirmDelete2: 'Această acțiune nu poate fi anulată și este înregistrată. Confirmi?',
      deleteTitle: 'Elimină câștigătorul',
      deleteConfirm: 'Elimină',
      countryAll: 'Țară: toate',
      editAction: 'Editează',
      editClosed: 'În afara perioadei de editare.',
      editWindowNote: 'Poți edita un câștigător timp de până la 1 lună după încărcare. Administratorul General poate edita orice câștigător din ultimii 3 ani.',
      exportNominations: 'Exportă nominalizările',
      exportWinners: 'Exportă câștigătorii',
      exportNominationsEmpty: 'Nu există nominalizări de exportat pentru această campanie.',
      exportPending: 'Exportul va fi conectat în pachetul următor.',
      filterCountry: 'Țară',
      filterFundamental: 'Fundamental',
      filterYear: 'An',
      filtersToggle: 'Filtre',
      flowHint: 'Câștigătorii se încarcă din fișier. Fluxul este: încarci șablonul → apare aici → confirmi câștigătorul final.',
      fundamentalAll: 'Fundamental: toate',
      fundamentalNone: 'Fără fundamental',
      importErrorsTitle: 'Rânduri respinse',
      importSummary: '{{importados}} din {{total}} rânduri importate · {{rechazados}} respinse.',
      manageTitle: 'Gestionarea câștigătorilor',
      moduleHint: 'Activează pentru a permite încărcarea câștigătorilor și atribuirea insignelor.',
      moduleOffWarn: 'Modulul Câștigători a fost dezactivat. Deocamdată această setare este doar salvată și nu schimbă încă nimic pentru utilizatori.',
      moduleSaveError: 'Modificarea modulului Câștigători nu a putut fi salvată. Încearcă din nou.',
      moduleTitle: 'Modulul Câștigători',
      needsCsv: 'Este un registru Excel binar și nu poate fi citit. Deschide-l și salvează-l ca CSV (UTF-8) înainte de încărcare.',
      noResults: 'Niciun câștigător nu corespunde filtrului.',
      ouAll: 'OU: toate',
      pagerInfo: 'Pagina {{page}} din {{paginas}} · {{total}} câștigători',
      searchByName: 'Caută după nume…',
      statusConfirmed: '✓ Confirmat',
      statusPending: '⏳ În așteptare',
      uploadFile: 'Încarcă Excel',
      uploadCampaign: 'Campania listei',
      uploadMode: 'Ediția listei',
      uploadModeCurrent: 'Curentă',
      uploadModeHistoric: 'Istorică',
      uploadOpen: 'Încarcă lista',
      uploadOpenHint: 'Deschide asistentul pentru încărcarea listei câștigătorilor, curentă sau istorică.',
      uploadModalTitle: 'Încarcă lista câștigătorilor',
      uploadModalToggleHint: 'Alege „Curentă” dacă lista aparține unei campanii active pe site. Alege „Istorică” pentru a încărca premii din ani anteriori care nu sunt înregistrate ca o campanie.',
      uploadBadge: 'Insignă',
      uploadBadgeHint: 'Fiecare rând din fișier va primi ACEASTĂ insignă. Alege-o înainte de a încărca fișierul.',
      uploadBadgePick: 'Alege insigna…',
      uploadBadgeClarify: 'Insigna nu este o campanie: este imaginea pe care persoana o va vedea drept premiu câștigat (de exemplu, o medalie sau un trofeu).',
      pickBadgeFirst: 'Alege mai întâi insigna pe care o vor primi câștigătorii din acest fișier.',
      uploadHistoricWarning: 'Datele istorice se salvează direct, fără să se lege de nicio campanie. Verifică numele, e-mailul și insigna înainte de a încărca.',
      helpOpen: 'Ajutor pentru încărcarea listei',
      helpModalTitle: 'Cum încarc lista câștigătorilor?',
      helpIntroVigente: 'Curentă: folosește acest mod când premiul aparține unei campanii care există pe site și este activă chiar acum. Alegi campania și insigna (imaginea afișată drept premiu câștigat) și descarci șablonul: acesta cere doar e-mailul sau numărul de angajat al persoanei. Numele, anul și UO/locația le știe deja sistemul — nu trebuie să le scrii.',
      helpIntroHistorico: 'Istorică: folosește acest mod când premiul este dintr-o campanie veche care nu mai există pe site, sau despre care nu ai nicio evidență. NU alegi o campanie: în schimb alegi O SINGURĂ insignă (imaginea afișată drept premiu câștigat, nu numele unei campanii), care va fi dată TUTUROR persoanelor din fișier. Descarcă șablonul cu 2 coloane (Nume și E-mail sau număr de angajat), completează-l și încarcă-l.',
      helpDirectorio: 'E-mailul sau numărul de angajat trebuie să existe în baza de date a companiei. Dacă nu se găsește niciunul dintre cele două, rândul respectiv este respins, iar restul fișierului se încarcă oricum. Dacă persoana nu are e-mail (de exemplu, personalul din fabrică), scrie numărul de angajat în aceeași coloană — nu mai este nevoie de e-mail dacă ai completat numărul de angajat.',
      helpNoDownload: 'Dacă încerci să descarci un fișier și nu există date de afișat, nu se descarcă nimic: primești un mesaj pe ecran în schimb.',
      downloadTemplateHint: 'Descarcă un Excel gol cu coloanele potrivite pentru acest mod, în limba ta.',
      downloadTemplateCurrent: 'Descarcă șablonul curent',
      downloadTemplateHistoric: 'Descarcă șablonul istoric',
      uploadFileHint: 'Încarcă Excelul completat cu datele listei.',
      importWizard: {
        subtitle: 'Încarcă lista, verifică rezultatul înainte de a confirma și descarcă erorile dacă ceva nu merge.',
        colNombreDesc: 'Numele câștigătorului, așa cum va fi afișat.',
        colNombreDescVigente: 'Numele câștigătorului. Poți lăsa câmpul gol: dacă nu îl completezi, se folosește numele deja înregistrat pentru acea persoană.',
        colEmailDesc: 'E-mail SAU număr de angajat al persoanei — unul dintre cele două este suficient; identifică cine primește premiul.',
        colFundamentalDesc: 'Fundament recunoscut (nume în orice limbă sau cod din catalog). Este ignorat dacă nu corespunde niciunuia.',
        badgePreviewHint: 'Așa arată insigna — exact ce va primi fiecare câștigător din acest fișier.',
        dropHint: 'Trage fișierul Excel sau CSV aici, sau apasă pentru a-l alege.',
        reviewHint: 'Aceasta este doar o VALIDARE: nimic nu este încă salvat. Verifică rezumatul și, dacă e nevoie, revino pentru a alege un fișier corectat.',
        previewPending: 'Se validează fișierul…',
        noErrors: 'Fără erori — toate rândurile sunt valide.',
        fileLevelError: 'Fișier/selecție',
        confirmPending: 'Se salvează…',
      },
      filterEstado: 'Stare',
      estadoAll: 'Stare: toate',
      uploadCampaignPick: 'Alege campania…',
      pickCampaignFirst: 'Alege mai întâi campania căreia îi aparține lista.',
      exportNominationsCatalogError: 'Catalogul de Fundamente/Obiceiuri nu a putut fi încărcat: exportul ar putea ieși incomplet. Încearcă din nou.',
      yearAll: 'An: toți',
      desc: 'Registrul câștigătorilor de la Strălucim Împreună.',
      title: 'Câștigători',
      descLong: 'Câștigători pe campanie/OU. Creare manuală și import CSV al istoricului cu feedback pe rând.',
      filterCampaign: 'Campanie',
      campaignIdHint: 'Id de campanie',
      filterOu: 'OU',
      ouHint: 'Id de OU',
      add: 'Adaugă câștigător',
      addTitle: 'Câștigător nou',
      fieldCampaign: 'Campanie',
      fieldUser: 'Utilizator',
      fieldName: 'Nume',
      fieldOuName: 'OU',
      fieldCountry: 'Țară',
      fieldPosition: 'Poziție',
      save: 'Salvează',
      importTitle: 'Import CSV',
      importHint: 'Descarcă șablonul, completează-l și încarcă-l. Importul este idempotent pe campanie + utilizator.',
      downloadTemplate: 'Descarcă șablonul',
      uploadCsv: 'Încarcă CSV',
      templateError: 'Șablonul nu a putut fi descărcat.',
      importError: 'Importul nu a putut fi procesat.',
      deleteError: 'Acest câștigător nu a putut fi eliminat.',
      totalRows: 'Rânduri totale',
      imported: 'Importate',
      rejected: 'Respinse',
      row: 'Rând',
      reason: 'Motiv',
      empty: 'Nu există câștigători pentru aceste filtre.',
      colPosition: 'Poziție',
      colName: 'Nume',
      colOu: 'OU',
      colCountry: 'Țară',
      colCrossed: 'Origine încrucișată',
      colDate: 'Înregistrat',
      // Task 16 — anteturile exportului brut de nominalizări (i18n, nu mai e spaniolă fixă).
      nominationsExport: {
        // Cheile `nominee*` conțin persoana care A NOMINALIZAT (blocul Nominee_* din DTO provine din
        // Recognition.EmisorSnapshot). Persoana nominalizată este blocul `candidate*` de mai jos.
        nomineeName: 'Propunător: Nume',
        nomineeEmail: 'Propunător: E-mail',
        nomineeEmployeeId: 'Propunător: Nr. marcă',
        nomineeOu: 'Propunător: OU',
        nomineeBu: 'Propunător: BU',
        nomineeSite: 'Propunător: Site',
        nomineeDepartment: 'Propunător: Post',
        onBehalfOfName: 'În numele: Nume',
        onBehalfOfEmail: 'În numele: E-mail',
        onBehalfOfEmployeeId: 'În numele: Nr. marcă',
        onBehalfOfOu: 'În numele: OU',
        onBehalfOfBu: 'În numele: BU',
        onBehalfOfSite: 'În numele: Site',
        onBehalfOfDepartment: 'În numele: Post',
        candidateName: 'Candidat: Nume',
        candidateEmail: 'Candidat: E-mail',
        candidateEmployeeId: 'Candidat: Nr. marcă',
        candidateOu: 'Candidat: OU',
        candidateBu: 'Candidat: BU',
        candidateSite: 'Candidat: Site',
        candidateDepartment: 'Candidat: Post',
        date: 'Dată',
        year: 'An',
        month: 'Lună',
        habitPrefix: 'Obicei',
        comment: 'Comentariu',
        streakBadge: 'Insignă de serie',
        fromDayToDay: 'Provine din recunoașterea zilnică',
        status: 'Stare',
        type: 'Tip',
        audienceNominee: 'Audiența propunătorului',
        audienceCandidate: 'Audiența candidatului',
        points: 'Puncte',
        retiredHabitsGroup: 'Altele / obiceiuri retrase',
      },
    },
    campaigns: {
      desc: 'Asistent pentru campanii de recunoaștere.',
      statusDivider: 'Starea campaniilor',
      title: 'Campanii',
      descLong: 'Lista campaniilor și asistent în 5 pași: Info, Audiență, Configurare, Documente și Publicare.',
      filterAll: 'Toate',
      status: {
        Borrador: 'Ciornă', Activa: 'Activă', Finalizada: 'Încheiată', PendienteAprobacion: 'În așteptarea aprobării',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Activă · în afara perioadei',
        ActivaPorIniciar: 'Activă · încă nu a început',
        // ADR 0014 — estado visible de la pestaña Brillamos (Activa con inicio futuro).
        PorIniciar: 'Neîncepută',
        ActivaVencidaHint: 'Campania este încă marcată ca activă, dar perioada sa s-a încheiat: colegii din domeniul său nu o văd.',
        ActivaPorIniciarHint: 'Campania este activă, dar data de început nu a sosit încă.',
      },
      approvals: 'Aprobări',
      new: 'Campanie nouă',
      empty: 'Nu există campanii.',
      colName: 'Nume',
      colType: 'Tip',
      colStatus: 'Stare',
      colScope: 'Arie',
      allScopes: 'Toate OU-urile',
      editBtn: 'Editează',
      duplicate: 'Duplică',
      panic: 'Oprește campania',
      deactivateConfirmTitle: 'Oprește campania pe OU',
      deactivateConfirmMsg: 'Oprești această excepție pe OU acum? Va înceta imediat să se aplice domeniului său.',
      panicConfirm: 'Oprești imediat această campanie?',
      type: { Fundamentales: 'Fundamentale', Brillamos: 'Strălucim', Personalizada: 'Personalizată' },
      wizardEditTitle: 'Editează campania',
      wizardNewTitle: 'Campanie nouă',
      wizardSub: 'Parcurge cei 6 pași pentru a crea sau edita campania.',
      backToList: 'Înapoi la listă',
      step: { info: 'Info', design: 'Design', audience: 'Audiență', config: 'Configurare', documents: 'Documente', publish: 'Publică' },
      tabFundamentales: 'Fundamentals',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Personalizate',
      fundActiveTitle: 'Mereu activ',
      fundRules: 'Reguli de trimitere',
      fundActiveDesc: 'Fundamentals este baza programului de recunoaștere. Nu poate fi dezactivat, doar configurate regulile sale.',
      fundConfigNote: 'Regulile de trimitere și limitele detaliate se administrează în secțiunea Gestionare.',
      globalPanic: 'Oprește toate campaniile',
      globalPanicConfirm: 'Închizi imediat TOATE campaniile Shine Together active? Această acțiune nu poate fi anulată.',
      globalPanicDone: '{{count}} campanie(campanii) încheiate.',
      docCategoria: 'Categorie',
      docCatNone: 'Fără categorie',
      fieldType: 'Tip de campanie',
      fieldName: 'Nume',
      fieldDescription: 'Descriere',
      fieldSlug: 'Slug-ul paginii de destinație',
      fieldScope: 'Arie (OU-uri)',
      fieldExclusions: 'Excluderi',
      fieldStart: 'Data de început',
      fieldEnd: 'Data de sfârșit',
      fieldTimezone: 'Fus orar',
      fieldStreakMinimum: 'Minimul de serie al campaniei',
      streakMinimumInherit: 'Folosește valoarea globală',
      streakMinimumHint: 'Trimiteri cerute de această campanie pentru a acumula serie în perioadă (1-20). Gol = se aplică minimul global din Gestiune.',
      streakMinimumLocked: 'Campania a început deja: minimul de serie nu poate fi schimbat fără a recalifica perioada în curs.',
      fieldRecognitionsLimitOwn: 'Limita de trimiteri a campaniei',
      recognitionsLimitOwnInherit: 'Folosește valoarea globală',
      recognitionsLimitNotApplicable: 'Nu se aplică (fără limită de trimiteri)',
      recognitionsLimitNotApplicableShort: 'Fără limită',
      fieldSameFundamentalLimit: 'Ori același fundamental către aceeași persoană',
      sameFundamentalInherit: 'Folosește valoarea globală',
      sameFundamentalNotApplicable: 'Nu se aplică (fără limită)',
      sameFundamentalNotApplicableShort: 'Fără limită',
      recognitionsLimitOwnHint: 'Recunoașteri permise de această campanie pe perioadă. Gol = se aplică limita globală din Gestión. Editabilă oricând, chiar dacă campania este deja activă.',
      visibility: 'Vizibilitate',
      postSendTitle: 'Editare și Anti-Spoiler',
      visSender: 'Arată expeditorul',
      visFundamental: 'Arată fundamentalul',
      visText: 'Arată textul',
      visHabit: 'Arată obiceiul',
      visSent: 'Contor de trimise',
      visReceived: 'Contor de primite',
      visAnonymous: 'Permite anonime',
      visBulk: 'Încărcare în masă CSV',
      visReactions: 'Reacții (👏❤️😊🎉👍)',
      visCampaignTag: 'Afișează eticheta campaniei',
      visFromFundamentals: 'Permite trimiterea din Fundamentale',
      visSendingDisabled: 'Dezactivează trimiterea de recunoașteri',
      anonymousOverrideLabel: 'Recunoașteri anonime',
      anonymousOverrideInherit: 'Moștenește din Gestión',
      anonymousOverrideAllow: 'Permite',
      anonymousOverrideDeny: 'Nu permite',
      anonymousOverrideHint: 'Se aplică DOAR acestei campanii. Lăsat pe "Moștenește din Gestión", această campanie folosește setarea globală.',
      points: 'Puncte',
      pointsLocked: 'Punctele sunt imuabile: campania a început deja.',
      pointsHint: 'Doar Europa; frontend-ul nu arată niciodată punctele.',
      applyPoints: 'Campania acordă puncte',
      brillamosRecurringDesc: 'Campanie recurentă de nominalizare pe baza Fundamentelor.',
      paisScheduleTitle: 'Orare și Date pe Țară',
      paisScheduleIntro: 'Configurează orare sau date diferite pe țară. Dacă nu este specificat, moștenește globalul.',
      paisScheduleInfoIntro: "Afișează datele și orele în vigoare ale campaniilor active din fiecare OU, pentru a ști când se poate recunoaște între OU-uri. Doar informativ.",
      paisStateOn: "Activ",
      paisStateOff: "Oprit",
      paisStateNoCampaign: "Fără campanie",
      paisCol: 'Țară',
      paisOpen: 'Ora de deschidere',
      paisClose: 'Ora de închidere',
      paisActive: 'Activ',
      paisClearHours: 'Șterge orarul',
      paisOverrideBadge: 'Campanie de UO',
      paisOverrideWins: 'Are prioritate față de acest rând: {{alcance}}.',
      paisOverrideNoSend: 'Trimitere dezactivată',
      paisOverrideDates: 'Date {{inicio}} → {{fin}}',
      paisOverrideHours: 'Orar {{inicio}}–{{fin}}',
      paisScheduleNoActive: "Nu există nicio campanie Brillamos Juntos activă: când va exista una, aici vor apărea datele și orele ei pe țări.",
      saveDraftFirst: 'Salvează ciorna pentru a-i gestiona documentele.',
      saveDraft: 'Salvează ciorna',
      saveDraftLater: 'Ciorna se salvează după finalizarea configurării. Folosiți „Următorul” pentru a parcurge pașii.',
      dates: 'Date',
      publishRequirements: 'Necesită nume în toate cele 7 limbi, cel puțin o OU în arie și date de început și de sfârșit. Salvarea se activează după completarea configurării.',
      valNameAllLangs: 'Introduceți numele în toate cele 7 limbi.',
      valScope: 'Selectați cel puțin o unitate organizatorică în arie.',
      scopeConflict: "Aceste unități sunt deja într-o campanie activă: {{campanas}}. Scoateți-le din arie sau încheiați acea campanie.",
      valScopeConflict: "Aria intră în conflict cu o campanie activă: {{campanas}}.",
      scopeConflictPartial: "Există mai multe campanii active decât au putut fi verificate: verificarea conflictelor poate fi incompletă.",
      scopeEmpty: "Nu aveți unități organizaționale în domeniul dvs. pentru a crea campanii. Cereți unui administrator global să vă atribuie un domeniu.",
      outOfScopeHint: "Această campanie include unități organizatorice în afara ariei dvs.: doar un administrator care le acoperă pe toate o poate edita.",
      valScopeExcludesOwn: "Nu vă puteți exclude propria unitate organizatorică din arie.",
      valStart: 'Introduceți data de început a campaniei.',
      valEnd: 'Introduceți data de sfârșit a campaniei.',
      valTimezone: 'Selectați fusul orar al campaniei.',
      valDateOrder: 'Data de sfârșit trebuie să fie ulterioară datei de început.',
      valPastDate: "Datele campaniei nu pot fi anterioare zilei de astăzi.",
      designMenu: 'Pictogramă și titlu în meniul lateral',
      designMenuHint: 'Așa va apărea campania în bara laterală a platformei pentru utilizatori.',
      designIcon: 'Pictogramă',
      designMenuTitle: 'Titlu meniu',
      designMenuTitlePh: 'ex.: Inovație LATAM',
      designSections: 'Secțiunile paginii',
      designSectionsHint: 'Bannerul și formularul de nominalizare sunt mereu prezente. Activați secțiunile opționale.',
      designShowStreak: 'Serie de recunoașteri',
      designShowRecent: 'Recunoașteri recente',
      designBrillamosLocked: 'Identitatea Shine Together este imuabilă: designul său nu poate fi editat.',
      approvalSent: 'Cerere de aprobare trimisă.',
      submitApproval: 'Trimite spre aprobare',
      submitApprovalConfirmTitle: 'Trimite spre aprobare',
      submitApprovalConfirmMsg: 'Trimiți această campanie spre aprobare? Admin General trebuie să o revizuiască înainte să devină activă.',
      prev: 'Anterior',
      next: 'Următorul',
      docLang: 'Limbă',
      docUrl: 'URL-ul documentului',
      docTitle: 'Titlu',
      addDoc: 'Adaugă document',
      docCategoryRequired: 'Selectează o categorie înainte de a adăuga documentul.',
      docTitleRequired: 'Completează titlul în toate cele 7 limbi înainte de a adăuga documentul.',
      docsEmpty: 'Nu există documente.',
      docsFallbackNote: 'Dacă nu se încarcă documente aici, această campanie afișează cele din secțiunea Documentație a administrării.',
      approvalsTitle: 'Aprobări în așteptare',
      approvalsSub: 'Campanii care așteaptă aprobarea ta (AdminGlobal).',
      approvalsEmpty: 'Nu există aprobări în așteptare.',
      colCampaign: 'Campanie',
      requestedBy: 'Solicitată de',
      approve: 'Aprobă',
      approveConfirmTitle: 'Aprobă campania',
      approveConfirmMsg: 'Aprobi această campanie? Va deveni activă și vizibilă pentru domeniul ei.',
      reject: 'Respinge',
      rejectReason: 'Motivul respingerii (obligatoriu)',
      rejectConfirm: 'Confirmă respingerea',
      viewDetail: 'Vezi detalii',
      bannerDesign: 'Designul bannerului',
      bannerScopeLabel: 'Acest banner se aplică doar acestei campanii; dacă nu este configurat, moștenește bannerul global al programului.',
      bannerDesignHint: 'Schimbă limba de mai sus pentru a edita titlul, subtitlul și logoul acelei limbi — previzualizarea se actualizează în timp real.',
      bannerTitle1: 'Titlu (rândul 1)',
      bannerTitle2: 'Titlu (rândul 2)',
      bannerSubtitle: 'Subtitlu',
      bannerLogoNote: 'Încărcarea imaginii logoului (PNG per limbă) va fi disponibilă în curând.',
      bannerLogo: 'Logo (imagine pentru această limbă)',
      bannerLogoUpload: 'Încarcă PNG',
      bannerLogoReset: 'Revino la implicit',
      bannerLogoHint: 'Recomandat: PNG transparent ~4:3. Implicit se afișează logoul Fundamentals.',
      bannerLogoErrPng: 'Logoul trebuie să fie un PNG.',
      bannerLogoErrSize: 'PNG-ul nu trebuie să depășească 500 KB.',
      bannerPreview: 'Previzualizare',
      bannerPreviewEmpty: 'Titlul bannerului',
      bannerCta: 'Recunoaște pe cineva',
      brillamosBannerTitle: 'Banner Strălucim Împreună',
      brillamosBannerHint: 'Personalizează subtitlul și logoul eroului Strălucim Împreună pentru fiecare limbă. Previzualizarea se actualizează în timp real.',
      brillamosBannerLogoHint: 'Recomandat: PNG transparent. Implicit se afișează logoul Shine.',
      entryPoints: 'Modalitate de recunoaștere (entry points)',
      entry: { A: 'Entry A — Formular clasic', B: 'Entry B — Post-it interactiv (Word Builder)', both: 'Ambele vizibile (test A/B)' },
      commentRequired: 'Comentariu obligatoriu',
      vista: 'Vizualizare:',
      vistaGlobal: 'Admin Global',
      vistaOu: 'Admin OU / Ambasador',
      rulesTitle: 'Reguli de Trimitere',
      brillamosRulesIntro: 'Aceste reguli se aplica doar pentru Shine Together. Un camp gol mosteneste valoarea globala din Gestiune.',
      ruleMultiPersona: 'Multi-persoană',
      ruleMultiFundamental: 'Multi-fundamental',
      ruleBulkCsv: 'Încărcare masivă CSV',
      ruleReactions: 'Reacții pe perete',
      ruleSendingDisabled: 'Dezactivează trimiterea',
      ruleAnonymousEnabled: 'Permite recunoașteri anonime',
      anonymousGestionHint: 'Se aplică la tot (Fundamentale, Brillamos și campanii personalizate), cu excepția cazului în care o campanie își definește propria configurație în pasul Configurare al asistentului. Nu afectează anonimizarea automată GDPR din Europa.',
      ruleMinChars: 'Min. caractere',
      moderationTitle: 'Moderare',
      modPostEdit: 'Editare după trimitere',
      modPostEditDescription: 'Editare după trimitere: cine trimite își poate edita sau șterge recunoașterile cât timp campania este deschisă.',
      moderationNote: 'Butonul Raportează și Filtrul de cuvinte se administrează în secțiunea Moderare.',
      postEditPerCampaignNote: '„Editare după trimitere” se configurează în fiecare campanie (pasul 5 al asistentului) și, pentru Fundamentale, în fila lor. Nu mai are termen limită.',
      modAntiSpoiler: 'Modul Anti-Spoiler',
      modAntiSpoilerDescription: 'Modul Anti-Spoiler: ascunde recunoașterile primite până la încheierea campaniei. Doar cine le-a trimis le vede.',
      antiSpoilerPerCampaignNote: '„Modul Anti-Spoiler” se configurează în fiecare campanie (pasul 5 al asistentului) și nu mai protejează după închiderea campaniei. Pentru Fundamentale, în fila lor; se dezactivează manual.',
      multiEnvioPerCampaignNote: '„Multi-persoană”, „Multi-fundamental” și „Fundamentale pe rec.” se configurează în fiecare campanie (pasul 5 al asistentului).',
      multiEnvioEuropaAviso: 'Această campanie include OU-uri din Europa (GDPR): permiterea mai multor persoane sau a mai multor Fundamentale este responsabilitatea celui care configurează campania.',
      multiEnvioNoLimitHint: 'Cu „Fundamentale pe rec.” dezactivat, nu există limită de Fundamentale.',
      entryPointsPerCampaignNote: 'Modalitatea de recunoaștere se configurează în fiecare campanie (pasul 5 al asistentului).',
      resetToGlobal: 'Resetează (moștenește din global)',
      streakTitle: 'Configurare Serie (Fundamente)',
      streakActive: 'Serie activă',
      streakSentNote: 'Seria se calculează pe baza recunoașterilor TRIMISE.',
      streakInProfile: 'Arată seria în profil',
      badgesActive: 'Insigne active',
      streakPeriod: 'Perioadă',
      periodWeekly: 'Săptămânal',
      periodMonthly: 'Lunar',
      periodDaily: 'Zilnic',
      limitsTitle: 'Plafoane (Gestionarea limitelor)',
      limitsActive: 'Plafoane active',
      limitName: 'Nume',
      limitDescription: 'Descriere',
      limitRecognitionsDesc: 'Recunoașteri maxime',
      limitFundamentalsDesc: 'Max selectabile per trimitere',
      limitValue: 'Limită',
      limitFrequency: 'Frecvență',
      limitActiveCol: 'Activ',
      limitRecognitions: 'Recunoașteri pe perioadă',
      limitFundamentals: 'Fundamentale pe rec.',
      perSubmission: 'Per trimitere',
      readonlyTitle: 'Configurație generală — Fundamentale (aplicată implicit)',
      readonlyBadge: 'Doar citire',
      readonlyNote: 'Dacă dorești să adaugi o excepție pe OU, va trece prin aprobarea Admin Global.',
      colDate: 'Dată',
      exc: {
        title: 'Excepții pe OU',
        intro: 'Excepții punctuale la configurația de bază pentru un domeniu OU/BU/Site specific. Fiecare trece prin aprobarea Adminului Global.',
        new: 'Campanie nouă pe OU',
        colException: 'Excepție',
        colScope: 'OU / BU / Site',
        colState: 'Stare campanie',
        fullOu: 'Toată OU',
        sites: '{{count}} site-uri',
        scopePopTitle: 'Site-uri din domeniu',
        stateActive: 'Activă',
        stateInactive: 'Inactivă',
        toggleHint: 'Doar o excepție aprobată poate fi activată sau dezactivată.',
        edit: 'Editează',
        delete: 'Șterge',
        empty: 'Încă nu există excepții pe OU.',
        deleteTitle: 'Șterge excepția',
        deleteMsg: 'Această excepție pe OU va fi eliminată definitiv. Această acțiune nu poate fi anulată.',
        deleteConfirm: 'Șterge',
        summaryTope: 'Plafon: {{max}} recos / {{freq}}',
        summaryDisable: 'Dezactivează trimiterea',
        disableTitle: 'Dezactivează trimiterea (override)',
        disableNote: 'Blochează temporar trimiterea recunoașterilor pentru domeniul selectat, fără a dezactiva programul. Necesită aprobarea administratorului global.',
        summarySchedule: 'Program restricționat',
        summaryVisibility: 'Vizibilitate',
        summaryBanner: 'Banner',
        approvalsTitle: 'Aprobări',
        approvalsColSolicitante: 'Solicitant',
        approvalsColAprobador: 'Aprobator',
        approvalsColFecha: 'Dată',
        approvalsColEstado: 'Stare',
        approved: 'Aprobată',
        pending: 'În așteptare',
        rejected: 'Respinsă',
        approvalsEmpty: 'Încă nu există excepții de aprobat.',
        pendingBanner: 'Ai {{count}} excepție(i) care așteaptă aprobarea ta.',
        approve: 'Aprobă',
        reject: 'Respinge',
        rejectReason: 'Motivul respingerii (obligatoriu)',
        rejectConfirm: 'Confirmă respingerea',
        back: 'Excepții pe OU',
        wizardTitle: 'Excepție pe OU — Fundamentals',
        wizardTitleBrillamos: 'Excepție pe OU — Strălucim Împreună',
        stepScope: 'Domeniu',
        stepSchedule: 'Program',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Campanie de bază',
        baseCampaignHint: 'O excepție pe OU nu funcționează singură: SUPRASCRIE părți dintr-o campanie activă pentru domeniul tău. Dacă nicio campanie activă nu acoperă acele OU-uri, această excepție nu va avea niciun efect. Dacă ai nevoie de o campanie proprie și completă pentru OU, creează-o din Campanii, nu aici.',
        baseCampaignLabel: 'Campania suprascrisă',
        baseCampaignNone: 'Nedeclarată (se aplică campaniei active care acoperă domeniul)',
        baseCampaignNinguna: 'Nu există nicio campanie Strălucim Împreună activă. Creează și activează una mai întâi, altfel această excepție nu se va aplica nimănui.',
        baseCampaignRequerida: 'Alege campania de bază pentru a putea salva: fără ea, excepția nu s-ar aplica nimănui.',
        baseCampaignVentana: 'Campania de bază este valabilă din {{inicio}} până la {{fin}}. Aceste date aparțin campaniei și nu se modifică aici.',
        baseCampaignSinVentana: 'Campania de bază nu are o perioadă de valabilitate definită.',
        scheduleWindow: 'Data și ora locale ale excepției',
        scheduleStart: 'Început excepție',
        scheduleEnd: 'Sfârșit excepție',
        scheduleTz: 'Fus orar',
        scheduleRestrictTitle: 'Dezactivează recunoașterile',
        scheduleRestrictNote: 'Când este activ, recunoașterile nu pot fi trimise în afara datei și orei configurate pentru acest domeniu. Necesită aprobarea administratorului global.',
        scheduleWindowNota: 'Dacă setezi un interval, trimiterile din acest domeniu vor fi limitate la el. Lasă-l gol pentru a nu restricționa nimic.',
        scheduleInvalid: 'Fereastra de program necesită dată/oră de început și sfârșit, iar sfârșitul trebuie să fie după început.',
        bannerTitle: 'Banner Strălucim Împreună (excepție)',
        bannerIntro: 'Suprascrie subtitlul și logo-ul bannerului Strălucim Împreună doar pentru domeniul acestei excepții. Dacă nu editezi nicio limbă aici, bannerul global rămâne neschimbat.',
        bannerScopeLabel: 'Acest banner se aplică doar domeniului acestei excepții, nu bannerului global Strălucim Împreună.',
        stepDocs: 'Documente',
        stepVisibility: 'Vizibilitate',
        scopeIntro: 'Definește domeniul organizațional.',
        docsIntro: 'Atașează documente specifice acestei excepții pe OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Căi de trimitere activate (override)',
        entryPointModeApp: 'Doar formular',
        entryPointModePostit: 'Doar post-it interactiv',
        entryPointModeAmbos: 'Ambele',
        reglasEnCampanaNote: 'În Brillamos, „Modalitate de recunoaștere”, „Multi-persoană” și „Multi-fundamental” se configurează în fiecare campanie (pasul 5 al asistentului) și au prioritate față de această excepție.',
        visTitle: 'Vizibilitatea recunoașterii (override)',
        visIntro: 'Configurează ce informații sunt afișate utilizatorului când primește sau consultă o recunoaștere.',
        visText: 'Afișează textul/comentariul recunoașterii',
        visFundamental: 'Afișează fundamentalul atribuit',
        visSender: 'Afișează numele expeditorului',
        visHabit: 'Afișează Daily Habit selectat',
        visRanking: 'Afișează clasamentul altor OU',
        visMultiFund: 'Permite mai multe Fundamentals per recunoaștere',
        maxFundamentales: 'Max. Fundamentals per recunoaștere',
        rulesTitle: 'Reguli de trimitere (override)',
        ruleMultiPersona: 'Multi-persoană',
        ruleComment: 'Comentariu obligatoriu',
        ruleMinChars: 'Min. caractere',
        ruleCsv: 'Încărcare CSV',
        modTitle: 'Moderare (override)',
        modReport: 'Buton Raportează',
        modEditDelete: 'Butoane Editează și Șterge (doar trimise)',
        streakTitle: 'Serie (override)',
        streakMin: 'Min. trimiteri/săptămână',
        streakPeriod: 'Perioadă',
        limitsTitle: 'Plafoane (override)',
        limitMax: 'Max. recos',
        limitFreq: 'Frecvență',
        approvalRequiredTitle: 'Aprobare necesară',
        approvalRequiredMsg: 'Toate modificările vor trebui aprobate de Adminul Global înainte de a fi aplicate.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frecventa',
      frecuenciaPlaceholder: 'Ex. Lunar, La fiecare 3 sedinte…',
      frecuencia: {
        mensual: 'Lunar',
        trimestral: 'Trimestrial',
        cadaNReuniones: 'La fiecare 3 sedinte',
        porEvento: 'Per eveniment',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Reactivează campania',
      // Ticket 04 — borrar borradores y pendientes de aprobación (Brillamos).
      deleteBtn: 'Șterge',
      deleteConfirmTitle: 'Ștergi campania?',
      deleteConfirm: '„{{name}}” va fi ștearsă. Acțiunea nu poate fi anulată.',
      deleteConfirmPending: '„{{name}}” va fi ștearsă, iar cererea de aprobare retrasă. Acțiunea nu poate fi anulată.',
      deleteDone: 'Campanie ștearsă.',
      approvalCampaignGone: 'Această campanie nu mai există.',
      undoPanicConfirm: 'Aceasta campanie va fi reactivata si va redeveni vizibila in aria sa. Posibil doar in 24 h. Continuati?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Obiectiv de participanți",
      metaParticipantesInherit: "Fără obiectiv",
      metaParticipantesHelp: "Persoane distincte care participă, recunoscând sau fiind recunoscute. Gol = fără obiectiv.",
      tooltip: {
        entryPoints: 'Cum poate cineva să recunoască un coleg: formular clasic, post-it interactiv, sau ambele simultan.',
        ruleMultiPersona: 'Permite includerea mai multor persoane ca destinatari în aceeași recunoaștere.',
        ruleMultiFundamental: 'Permite marcarea mai multor Fundamentale în aceeași recunoaștere.',
        commentRequired: 'Necesită scrierea unui comentariu pentru a putea trimite recunoașterea.',
        ruleBulkCsv: 'Activează încărcarea în masă a recunoașterilor printr-un fișier CSV.',
        ruleReactions: 'Permite altor persoane să reacționeze cu emoji la o recunoaștere.',
        ruleSendingDisabled: 'Dezactivează complet trimiterea recunoașterilor pentru acest domeniu, fără a afecta cele deja trimise.',
        ruleAnonymousEnabled: 'Permite trimiterea unei recunoașteri fără a afișa numele expeditorului.',
        modPostEdit: 'Permite celui care a trimis o recunoaștere să o editeze sau să o șteargă. Într-o campanie, doar cât timp este deschisă; administratorii pot oricând. Util pentru a corecta o greșeală din text fără a cere ajutor.',
        modAntiSpoiler: 'Cât timp campania este deschisă, recunoașterile primite de participanții ei sunt vizibile doar pentru cine le-a trimis: nici pentru destinatar, nici pentru colegii săi, indiferent din ce campanie vin. Se încheie la închiderea campaniei. Folosește-l când campania premiază pe cei mai recunoscuți: nimeni nu află câte are înainte de premiere.',
        antiSpoiler: 'Cât timp este activat, recunoașterile fără campanie sunt vizibile doar pentru cine le-a trimis. Nu se oprește singur: trebuie dezactivat manual.',
        streakActive: 'Activează numărătoarea seriei săptămânale de recunoașteri pentru această campanie.',
        dailyHabitsMandatory: 'Necesită marcarea unui obicei zilnic pentru ca recunoașterea să conteze în serie.',
        streakInProfile: 'Afișează seria curentă în profilul public al utilizatorului.',
        badgesActive: 'Activează acordarea de insigne pentru atingerea obiectivelor de serie.',
        limitsActive: 'Activează plafoanele de trimitere configurate mai jos, pentru recunoașteri și pentru Fundamentale.',
        recognitionsLimitActive: 'Aplică plafonul de recunoașteri pe perioadă pentru acest domeniu.',
        recognitionsLimitDisabled: 'Bifează „Nu se aplică” pentru ca această campanie să NU aibă o limită totală de trimiteri: o persoană poate trimite câte recunoașteri dorește în perioadă, indiferent de limita globală din Gestiune. Lasă nebifat (și câmpul gol) pentru a folosi limita globală.',
        streakMinimum: 'Numărul minim de recunoașteri pe care o persoană trebuie să le TRIMITĂ în perioadă pentru ca aceasta să conteze pentru seria sa (1-20). Suprascrie minimul global din Gestiune doar pentru această campanie; gol = se aplică globalul. Nu poate fi modificat după ce campania a început.',
        recognitionsLimitOwn: 'Numărul TOTAL maxim de recunoașteri pe care o persoană le poate trimite în perioadă (către oricine, orice fundamental). Suprascrie limita globală din Gestiune doar pentru această campanie; gol = se aplică globalul. Editabil oricând, chiar și după ce campania a început.',
        sameFundamentalLimit: 'De câte ORI o persoană poate recunoaște o alta pe ACELAȘI fundamental în perioadă (aceleiași persoane). Suprascrie valoarea globală din Gestiune doar pentru această campanie; gol = se aplică globalul. În Europa se menține minimul legal (GDPR).',
        sameFundamentalLimitDisabled: 'Bifează „Nu se aplică” pentru a permite repetarea aceluiași fundamental către aceeași persoană FĂRĂ limită, indiferent de global. Lasă nebifat (și câmpul gol) pentru a folosi globalul. În Europa limita legală se menține chiar dacă bifezi.',
        fundamentalsLimitActive: 'Aplică plafonul de Fundamentale per trimitere pentru acest domeniu.',
        designShowStreak: 'Afișează blocul de serie pe pagina de destinație a acestei campanii.',
        designShowRecent: 'Afișează recunoașterile recente pe pagina de destinație a acestei campanii.',
        visSender: 'Afișează numele persoanei care trimite recunoașterea.',
        visFundamental: 'Afișează Fundamentalul atribuit în recunoaștere.',
        visText: 'Afișează textul sau comentariul recunoașterii.',
        visHabit: 'Afișează Daily Habit-ul selectat, dacă este cazul.',
        visSent: 'Afișează fila cu recunoașterile trimise.',
        visReceived: 'Afișează fila cu recunoașterile primite.',
        visBulk: 'Activează încărcarea în masă prin CSV doar pentru această campanie.',
        visReactions: 'Activează reacțiile cu emoji doar pentru această campanie.',
        visCampaignTag: 'Afișează eticheta cu numele campaniei pe fiecare post-it.',
        visFromFundamentals: 'Permite inițierea acestei recunoașteri din ecranul Fundamentale.',
        visSendingDisabled: 'Dezactivează trimiterea recunoașterilor doar pentru această campanie.',
        applyPoints: 'Recunoașterile din această campanie acordă puncte care pot fi schimbate. Nu se poate dezactiva după ce campania a început deja.',
        visRanking: 'Afișează clasamentul comparativ cu alte OU-uri.',
        visMultiFund: 'Permite marcarea mai multor Fundamentale, ca excepție pentru această OU.',
        modReport: 'Permite raportarea unei recunoașteri necorespunzătoare.',
        modEditDelete: 'Activează editarea și ștergerea unei recunoașteri deja trimise, doar pentru această OU. Backend-ul tratează ambele permisiuni ca un singur comutator.',
        scheduleEnabled: 'Restricționează trimiterea recunoașterilor la intervalul orar definit mai sus.',
        disableSend: 'Blochează trimiterea recunoașterilor pentru acest domeniu specific.',
        paisActive: 'Dacă este dezactivat, campania nu mai este activă pentru această țară, chiar dacă data și intervalul orar configurate sunt încă valabile.',
        paisApplySchedule: 'Dacă este oprit, data și ora din acest rând rămân salvate, dar NU se aplică: țara nu are nicio restricție de orar. Util pentru a pregăti un interval și a-l activa mai târziu fără a-l reintroduce.',
        gestStreakEnabled: "Valoare globală: activează numărarea seriei de recunoașteri. Fiecare program sau campanie își poate defini propria valoare.",
        gestWrappedByOu: "Comutator principal al rezumatului anual (Wrapped). Oprit, nimeni nu îl vede; pornit, fiecare OU îl vede în fereastra de vizibilitate a configurației sale din Rezumat.",
        gestAllowPromote: "Permite trimiterea unei recunoașteri din Fundamentale și către Brillamos: afișează caseta din Recunoaște și ⭐ de pe perete și din profil.",
        gestStreakPerPersonCap: "Limitează câte recunoașteri 1:1 către aceeași persoană contează pentru serie (anti-abuz). Cele de grup contează întotdeauna. Maximul se definește mai jos.",
        gestAvatarEnabled: "Permite celor care intră prin webapp să personalizeze un avatar colorat. Cei care intră prin Teams își păstrează fotografia de profil.",
        gestAvatarSelector: "Afișează selectorul de avatar imediat după înregistrare. Necesită ca avatarul personalizabil să fie activ.",
        gestPanic: "Kill switch global: oprește imediat trimiterea de recunoașteri în toate campaniile active (Brillamos Juntos și Fundamentale), fără a le afecta pe cele deja trimise. Poate fi pornit doar dacă există cel puțin o campanie Brillamos activă.",
      },
      tooltipAria: 'Ajutor',
    },
    reports: { desc: 'Rapoarte și analytics ale programului.' },
    translate: {
      button: 'Tradu în celelalte limbi',
      buttonFrom: 'Tradu din {{lang}} în celelalte limbi',
      loading: 'Se traduce…',
      hint: 'Completează cel puțin o limbă pentru a traduce.',
      error: 'Traducerea automată a eșuat.',
      sessionExpired: 'Sesiunea ta a expirat. Reîncarcă pagina și autentifică-te din nou.',
    },
    misSolicitudes: {
      title: "Solicitările mele de campanie",
      desc: "Starea a ceea ce ați propus. Puteți retrage o solicitare cât timp este în așteptare și o puteți retrimite dacă a fost respinsă.",
      empty: "Nu ați trimis încă nicio solicitare.",
      colCampana: "Campanie",
      colFecha: "Data solicitării",
      colEstado: "Stare",
      colComentario: "Comentariu",
      colAcciones: "Acțiuni",
      editar: "Editare",
      retirar: "Retrage solicitarea",
      reenviar: "Retrimite",
      estado: {
        pendiente: "În așteptare",
        aprobada: "Aprobată",
        rechazada: "Respinsă",
      },
    },
    management: {
      desc: 'Reguli de trimitere, plafoane și serie.',
      title: 'Gestiune',
      descLong: 'Setări globale: descrierea seriei ×7, insigne, comutatoare globale și freeze. Salvare atomică.',
      fixValidation: 'Corectează validările înainte de a salva.',
      streakDescription: 'Descrierea seriei',
      fundamentalsTitle: 'Fundamentale disponibile',
      fundamentalsDesc: 'Ce Fundamentale sunt oferite la recunoaștere. Retragerea unuia nu îl șterge din catalog: doar nu mai apare în acest program.',
      fundamentalsLastOne: 'Este ultimul disponibil: dacă îl retrageți, nimeni nu ar mai putea trimite o recunoaștere.',
      avatarTitle: 'Configurare avatar (Frontline)',
      avatarDesc: 'Utilizatorii frontline care intră prin webapp își pot personaliza un avatar colorat. Cei care intră prin Teams își păstrează fotografia de profil.',
      avatarEnabled: 'Avatar personalizabil activ',
      avatarSelector: 'Afișează selectorul după înregistrare',
      avatarColors: 'Avatare disponibile:',
      placeholderTitle: 'Descriere configurabilă a câmpului de text',
      placeholderDesc: 'Textul de ajutor al câmpului de mesaj la recunoaștere. Fiecare limbă lăsată goală folosește textul implicit al produsului.',
      placeholderLabel: 'Text de ajutor al mesajului',
      panicTitle: 'Buton de panică — Brillamos Juntos',
      panicDesc: 'Dezactivează imediat trimiterea recunoașterilor în toate campaniile active. Se aplică atât pentru Shine Together, cât și pentru Recunoaște (Fundamentale). Doar Admin General.',
      panicToggle: 'Kill Switch global Brillamos',
      panicActiveHint: 'Trimiterea este DEZACTIVATĂ: nimeni nu poate trimite recunoașteri chiar acum.',
      panicSameSwitchHint: 'Este un comutator global: cât timp este activ, nicio configurare pe program sau pe campanie nu poate reactiva trimiterea.',
      panicNoActiveCampaign: 'Acest comutator devine disponibil când există cel puțin o campanie Strălucim Împreună activă (RN-C08). Momentan nu există niciuna, deci nu există trimiteri de campanie de oprit.',
      needAllLangs: 'Completează toate cele 7 limbi.',
      globalToggles: 'Comutatoare globale',
      streakEnabled: 'Serie activă',
      multinomination: 'Multinominalizare',
      dailyHabitsMandatory: 'Obiceiuri zilnice obligatorii',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Mod Anti-Spoiler (premiere)',
      antiSpoilerDesc: 'Ascunde temporar profilurile și aprecierile altor persoane în timpul premierii anuale, ca să nu fie dezvăluiți câștigătorii.',
      antiSpoilerActivo: 'Anti-spoiler activ',
      antiSpoilerFrom: 'De la',
      antiSpoilerTo: 'Până la',
      antiSpoilerHint: 'Cât timp este activ, angajații nu pot vedea profilurile colegilor și nici detaliile aprecierilor altor persoane.',
      antiSpoilerSinVentana: 'Fără date, protejează atât timp cât comutatorul este pornit.',
      antiSpoilerVentanaInvertida: '„De la” este ulterior lui „Până la”: o astfel de fereastră nu protejează niciodată. Corectează pentru a putea salva.',
      wrappedByOu: 'Rezumat pe OU',
      reactionsEnabled: 'Reacții (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Permite trimiterea către Brillamos',
      allowPostEdit: 'Editare după trimitere',
      postEditTitle: 'Editarea aprecierilor trimise',
      postEditDesc: 'Permite expeditorului să editeze mesajul unei aprecieri deja trimise. Dezactivat implicit.',
      postEditWindow: 'Fereastră de editare',
      postEditWindowOpt: { '24h': '24 de ore', '48h': '48 de ore', '7d': '7 zile', unlimited: 'Fără limită' },
      streakPerPersonCapEnabled: 'Plafon per persoană (serie)',
      streakPerPersonCap: 'Max. per persoană (serie)',
      weeklyMinimum: 'Minim pe perioadă',
      periodicity: 'Periodicitate',
      period: { weekly: 'Săptămânal', monthly: 'Lunar' },
      periodicityHint: 'Minimul se aplică perioadei alese: la Lunar, seria crește sau se rupe pe lună calendaristică, nu pe săptămână.',
      periodicityMonthlyWarning: 'La Lunar seria numără LUNI consecutive, iar aplicația reflectă deja asta (widget, Profil, Rezumat și praguri). Rămân DOUĂ decizii de Produs înainte de activarea în producție: RF-038 definește pragurile insignelor în săptămâni (1/4/8/12/20), deci cea de 4 s-ar obține după 4 luni; iar plafonul anti-abuz de 2 recunoașteri per persoană se aplică lunar în loc de săptămânal, ceea ce poate face imposibil un minim ridicat în echipe mici.',
      freezeFrom: 'Freeze de la',
      freezeTo: 'Freeze până la',
      badges: 'Insigne',
      noBadges: 'Nu există insigne configurate.',
      badge: 'Insignă',
      weeksRequired: '{{count}} săptămâni',
      weeksRequiredOne: '{{count}} săptămână',
      weeksRequiredMany: '{{count}} de săptămâni',
      badgeName: 'Numele insignei',
      badgeIcon: 'Pictogramă',
      badgeColor: 'Culoare',
      weeks: 'Săptămâni necesare',
      notApplicable: 'Nu se aplică',
      iconFormatInvalid: 'Format de imagine invalid. Folosește PNG, JPG, WEBP sau SVG.',
      addBadge: '+ Adaugă insignă',
      editBadge: 'Editează',
      deleteBadge: 'Șterge',
      deleteBadgeConfirm: 'Ștergi insigna „{{name}}”? Se pierd numele în cele 7 limbi, pictograma și pragul. Ștergerea se aplică la salvare.',
      badgeActive: 'Activă',
      badgeInactive: 'Inactivă',
      imageUploadHintNew: 'Salvează insigna mai întâi pentru a putea încărca pictograma.',
      previewTitle: 'Previzualizare',
      saveBadgeChanges: 'Salvează modificările',
    },
    // FAZA 7 (paritate demo, H-93/H-94/H-95) — Admin › Notificări (REQ-135).
    notifications: {
      title: 'Configurarea notificărilor',
      desc: 'Configurează ce notificări prin e-mail se trimit și la ce nivel al organizației. Valorile nedefinite la acest nivel se moștenesc de la următorul.',
      precedenceTitle: 'Cum se rezolvă configurarea',
      precedence1: 'Precedență: Site > BU > OU > Global. Câștigă valoarea definită la nivelul cel mai specific.',
      precedence2: 'Un comutator «Moștenit» nu este oprit: preia valoarea de la nivelul inferior. Se salvează doar ce definești aici.',
      precedence3: 'Fiecare persoană își poate dezactiva propriile e-mailuri din profil; acea preferință nu reactivează niciodată ce se oprește aici.',
      scopeTitle: 'Nivel de configurare',
      scopeUnit: 'Unitate',
      scopePick: 'Selectează o unitate…',
      scopeRequired: 'Selectează o unitate pentru a vedea și edita configurarea ei.',
      scopeOuContext: 'OU a unității',
      scopeOuFirst: 'Selectează mai întâi o OU…',
      unsavedLock: 'Ai modificări nesalvate; nivelul rămâne fix până salvezi sau renunți la ele.',
      discard: 'Renunță la modificări',
      scope: { global: 'Global (întregul tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-mail', categories: 'Tipuri de notificare', summary: 'Rezumat periodic', blocked: 'E-mailuri blocate' },
      blocked: {
        desc: 'Adrese care nu vor primi niciun e-mail al programului, indiferent de setările lor personale.',
        scopeWarning: 'Blocarea se aplică ÎNTREGULUI tenant, nu doar acestui nivel: un e-mail blocat aici este blocat în toate OU-urile. Are prioritate și față de comutatorul principal.',
        placeholder: 'nume@companie.com',
        add: 'Blochează',
        remove: 'Deblochează {{email}}',
        empty: 'Nu există e-mailuri blocate.',
      },
      design: {
        title: 'Designul e-mailurilor',
        desc: 'Așa arată astăzi: Fundamentele folosesc un stil cald, iar Shine Together unul întunecat cu stele. Designul fiecărui e-mail se stabilește direct în șablon, nu de aici.',
        fund: { name: 'Fundamente', style: 'Stil cald · Crem/Portocaliu' },
        shine: { name: '✨ Shine Together', style: 'Stil întunecat · Stele/Violet' },
      },
      broadcast: {
        title: 'Anunțuri de sistem',
        desc: 'Pentru mentenanțe, întreruperi sau orice anunț punctual. Se trimite cu șablonul deja proiectat: scrie doar mesajul.',
        overridesHint: '🔴 Acest anunț ajunge la TOATĂ LUMEA, chiar și la cine și-a oprit notificările. Nu este conținut al programului, ci informație despre unealtă.',
        kindLabel: 'Tipul anunțului',
        kind: { maintenance: 'Mentenanță programată', suspension: 'Întrerupere temporară', restored: 'Serviciu restabilit', general: 'Anunț general' },
        subject: 'Subiect',
        subjectPlaceholder: 'Mentenanță programată — sâmbătă la 2',
        message: 'Mesaj',
        messagePlaceholder: 'Mesaj pentru utilizatori...',
        everyone: 'Toată lumea',
        singleOu: 'O anumită OU',
        chooseOu: 'Alege o OU',
        send: 'Trimite anunțul acum',
        error: 'Anunțul nu a putut fi trimis.',
        sentSummary: 'Trimis la {{sent}} din {{recipients}} persoane.',
        skipped: '· {{count}} fără identitate rezolvabilă nu l-au primit.',
      },
      channel: { inapp: 'Clopoțel', email: 'E-mail', teams: 'Teams' },
      tables: {
        shine: '✨ Notificări — Shine Together',
        admin: '🛡️ Notificări — Admin',
        colType: 'Tip',
        colSubject: 'Subiect (ES)',
        colLanguages: 'Limbi',
        editSubject: 'Editează subiectul pentru „{{row}}” în toate cele 7 limbi',
        subjectByLanguage: 'Subiect pe limbă',
        close: 'Închide',
        saveSubject: 'Salvează subiectul',
        nineRows: 'Nouă rânduri, nu treisprezece: patru dintre cele desenate în machetă nu corespund niciunui aviz pe care sistemul îl trimite azi.',
        rows: {
          'campaign-new': { name: 'Campanie nouă lansată', trigger: 'Un administrator activează o campanie' },
          'campaign-ending': { name: 'Campanie pe terminate', trigger: 'Ultimele zile pentru nominalizare' },
          'recognition-sent': { name: 'Recunoaștere trimisă către Shine Together', trigger: 'Confirmare că a contat pentru campanie' },
          'ranking-position': { name: 'Poziția în clasament', trigger: 'Urci în clasament' },
          'campaign-approval': { name: 'Solicitare de campanie locală', trigger: 'Un admin de OU creează o solicitare → Admin Global' },
          'moderation-case-alert': { name: 'Raportare de moderare', trigger: 'O raportare nouă așteaptă adminul de OU' },
          'moderation-educational': { name: 'Mesaj raportat, anunț către expeditor', trigger: 'Îl anunță pe cel care a trimis recunoașterea că a fost raportată' },
          'low-participation-alert': { name: 'Alertă de participare scăzută', trigger: 'O campanie este sub pragul de participare' },
          'pending-nomination-manager': { name: 'Nominalizare în așteptare (lider)', trigger: 'O nominalizare necesită aprobare' },
        },
      },
      master: {
        label: 'Notificări prin e-mail',
        desc: 'Comutator principal: dacă este oprit, nu se trimite niciun e-mail al programului în acest domeniu. Nu afectează Teams sau clopoțelul.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Recunoașteri primite', desc: 'Notificare către persoană când cineva o recunoaște.' },
        streakAndBadgesEnabled: { label: 'Serii și insigne', desc: 'Mementouri de serie și insigne deblocate.' },
        campaignsEnabled: { label: 'Campanii', desc: 'Campanie nouă, campanie pe terminate, câștigători și aprobări.' },
        digestEnabled: { label: 'Rezumat săptămânal', desc: 'Digest cu activitatea acumulată în cursul săptămânii.' },
      },
      monthly: {
        label: 'Rezumat lunar',
        desc: 'Dezactivat implicit. Activează-l doar dacă această unitate dorește și un rezumat lunar.',
      },
      masterOffHint: 'Tipurile individuale funcționează doar cu comutatorul principal pornit.',
      inherited: 'Moștenit',
      inApp: { label: 'Notificări în aplicație (clopoțel)', desc: 'Clopoțelul din portal. Nu depinde de comutatorul de email: este un canal separat.' },
      teams: { label: 'Activity Feed Teams', desc: 'Anunțul în fluxul de activitate Teams, pentru cine are cont corporativ.' },
      frequency: {
        label: 'Frecvența de trimitere (email)',
        desc: 'Cât de des sunt grupate anunțurile într-un rezumat. Emailurile per eveniment nu sunt afectate.',
        opt: {
          immediate: 'Imediat (per eveniment)',
          daily: 'Rezumat zilnic',
          weekly: 'Rezumat săptămânal',
          biweekly: 'Rezumat bilunar (la 2 săptămâni)',
        },
        immediateHint: 'Cu „Imediat” nu se trimite niciun rezumat, chiar dacă rămâne activată categoria: fiecare anunț pleacă separat.',
      },
      resetToInherited: 'Înapoi la moștenit',
      active: 'active',
      saved: 'Modificări salvate!',
      loadError: 'Configurarea acestui nivel nu a putut fi încărcată.',
      saveError: 'Configurarea nu a putut fi salvată. Încearcă din nou.',
    },
    views: {
      title: 'Vizualizări utilizator',
      desc: 'Vizualizări vizibile pentru angajat și microsite-uri.',
      descLong: 'Ce vizualizări oferă fiecare OU colaboratorilor săi. Compatibil desktop + mobil.',
      scope: 'Nivel de configurare',
      scopeGlobal: 'Global (toate OU-urile)',
      unsavedLock: 'Salvați sau renunțați la modificări înainte de a schimba nivelul.',
      cancelChanges: 'Anulează modificările',
      infoAria: 'Ajutor despre {{label}}',
      micrositesTitle: 'URL-uri de microsite pe Fundamental',
      micrositesDesc: 'Legătură externă cu mai multe informații despre fiecare Fundamental. Lăsați gol dacă nu există microsite.',
      card: {
        medallero: { label: 'Medalier', desc: 'Trimise + primite' },
        perfilUsuario: { label: 'Profil de utilizator', desc: 'Primite recent→vechi' },
        enviarReconocimiento: {
          label: 'Trimite recunoaștere', desc: 'Conform configurării adminului',
          tooltip: 'Afișează butonul și formularul pentru a recunoaște un coleg. Se combină cu întrerupătorul general de trimitere: dacă acela este oprit, această vizualizare nu apare chiar dacă e pornită aici.',
        },
        historicoPorAnio: {
          label: 'Istoric pe an', desc: 'Anul curent primul',
          tooltip: 'Permite vizualizarea istoricului de recunoașteri grupat pe an, cu anul curent primul. Depinde și de activarea istoricului în campania activă.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Clasament',
          tooltip: 'Afișează clasamentul celor care au trimis sau primit cele mai multe recunoașteri. Este singura vizualizare oprită implicit.',
        },
        feedActividad: { label: 'Flux de activitate', desc: 'Cronologie recentă' },
        resumenMensual: {
          label: 'Rezumat lunar', desc: 'Retrospectivă în stil Spotify',
          tooltip: 'Activează retrospectiva în stil „Wrapped” cu cifrele perioadei pentru fiecare angajat. Apare doar dacă Wrapped este activat pentru OU și campania s-a încheiat deja.',
        },
        busquedaCompaneros: {
          label: 'Căutare colegi', desc: 'Vezi medalierele altora',
          tooltip: 'Permite căutarea și vizualizarea medalierului altor colegi. Se ascunde automat cât timp Modul Anti-Spoiler este activ, pentru a nu strica surprizele înaintea unei premieri.',
        },
        vistaFundamentales: {
          label: 'Vizualizare Fundamentale', desc: 'Informații despre fiecare fundamental',
          tooltip: 'Afișează constelația cu informațiile fiecărui Fundamental al culturii în ecranul Brillamos Juntos.',
        },
        banderaReportar: {
          label: 'Steag de raportare', desc: 'Raportează recunoașteri nepotrivite',
          tooltip: 'Adaugă un buton prin care angajații pot raporta o recunoaștere nepotrivită. Depinde și de activarea steagului de raportare din Moderare.',
        },
        recordatorioDiario: { label: 'Memento zilnic', desc: 'Îndemn zilnic de a recunoaște' },
        verATuEquipo: {
          label: 'Vezi echipa ta', desc: 'Doar pentru lideri/manageri',
          tooltip: 'Permite liderilor și managerilor să vadă recunoașterile persoanelor pe care le coordonează. Se aplică doar celor marcați ca lider în organigramă și cu permisiunea de metrici de echipă.',
        },
      },
      compose: {
        sending: 'Depinde și de butonul de panică: cu trimiterea dezactivată, această vizualizare nu apare nici dacă e activată aici.',
        campaign: 'Depinde și de comutatorul de istoric al campaniei active (RN-PR09).',
        wrapped: 'Depinde și de activarea Rezumatului în OU și de închiderea campaniei sale.',
        antiSpoiler: 'Depinde și de modul Anti-Spoiler: cât timp fereastra sa este activă, această vizualizare este ascunsă.',
        report: 'Depinde și de comutatorul „Buton Raportare” din secțiunea Moderare.',
        manager: 'Depinde și de a fi lider în organigramă și de a avea permisiunea de metrici de echipă.',
      },
    },
    docs: {
      desc: 'Documente corporative și legale.',
      legalTab: 'Termeni legali',
      privacyTab: 'Notă de confidențialitate',
      corpTab: 'Corporativ',
      pillsTab: 'Pills utilizator',
      bibliotecaTab: 'Bibliotecă',
      legalesTab: 'Docs Legale',
      gestionTitle: 'Gestionarea documentației',
      gestionDesc: 'Configurați accesările rapide ale utilizatorilor, gestionați biblioteca de fișiere și documentele legale obligatorii.',
      pills: {
        nueva: 'Adaugă pastilă',
        sectionTitle: 'Accesări rapide (Pills)',
        sectionSubtitle: 'Capsule de acces rapid vizibile în interfața utilizatorului. Definește numele, pictograma, culoarea și conținutul pe care îl deschid la clic.',
        editar: 'Editează pastila',
        titulo: 'Titlu',
        tipo: 'Tip',
        tipos: { documento: 'Document', url: 'Link', video: 'Video' },
        icono: 'Pictogramă',
        color: 'Culoare',
        orden: 'Ordine',
        documento: 'Document corporativ',
        elegirDocumento: 'Alege documentul…',
        sinDocumentos: 'Nu există documente corporative disponibile. Încarcă-le în fila Corporativ.',
        url: 'URL destinație',
        visibilidad: 'Vizibilitate pe UO',
        visibilidadHint: 'Nicio UO selectată = vizibil pentru toate unitățile.',
        activa: 'Pastilă activă (afișată în rail)',
        activaSi: 'Activă',
        activaNo: 'Inactivă',
        estado: 'Stare',
        vistaPrevia: 'Previzualizare',
        nombre: 'Nume',
        tipoContenido: 'Tip de conținut',
        documentoColumna: 'Document asociat',
        documentoNoEncontrado: 'Document negăsit',
        documentoAlcanceIncompleto: 'Nu acoperă toate OU-urile acestei pill',
        sinTitulo: 'Fără titlu',
        todas: 'Toate',
        vacio: 'Încă nu există accesări rapide configurate.',
        eliminar: 'Șterge pastila',
        eliminarConfirm: 'Ștergi această accesare rapidă din rail?',
        errorCargar: 'Nu s-au putut încărca accesările rapide.',
        errorGuardar: 'Nu s-a putut salva accesarea rapidă.',
        errorEliminar: 'Nu s-a putut șterge accesarea rapidă.',
      },
      corp: {
        firstLogin: 'Prima autentificare',
        versionEs: 'Versiune ES',
        versionEn: 'Versiune EN',
        subirVersion: 'Încarcă',
        reemplazar: 'Înlocuiește',
        verVersion: 'Vezi versiunea',
        quitarVersion: 'Elimină versiunea',
        triggerUpdate: 'Declanșează actualiz.',
        ousActivas: 'OU-uri active',
        nombre: 'Numele documentului',
        tipo: 'Tip',
        visibilidad: 'Vizibilitate pe OU',
        idiomas: 'Limbi',
        idiomasHint: 'Fără selecție = toate limbile.',
        versionesPorIdioma: 'Versiuni pe limbă',
        versionesPorIdiomaCount: 'Versiuni ({{count}}/{{total}})',
        archivo: 'Fișier PDF',
        elegirArchivo: 'Alege PDF…',
        subir: 'Încarcă documentul',
        agregarDocumento: 'Adaugă document',
        subirArchivo: 'Încarcă fișier',
        libType: { todos: 'Toate', pdf: 'PDF', video: 'Video', imagen: 'Imagine' },
        filterType: 'Tip',
        nombreArchivo: 'Nume fișier',
        idioma: 'Limbă',
        pillAsignado: 'Pastilă atribuită',
        subido: 'Încărcat',
        documento: 'Document',
        actualizado: 'Actualizat',
        mediaKind: 'Tip fișier',
        externalUrl: 'URL extern',
        externalUrlHint: 'Lipește linkul videoclipului sau al imaginii (Teams, SharePoint etc.).',
        requiereUrl: 'Introdu un URL extern valid.',
        abrir: 'Deschide',
        dropMain: 'Trage fișierele aici sau dă clic pentru a încărca',
        dropSub: 'PDF · Max. 25 MB pe fișier',
        subidoOk: 'Document încărcat.',
        errorSubir: 'Documentul nu a putut fi încărcat.',
        lista: 'Documente încărcate',
        listaCount: '{{count}} documente configurate',
        legalInfo: 'Aceste documente se afișează în fereastra de acceptare obligatorie. Prima autentificare le activează la primul acces. Declanșarea unei actualizări le afișează din nou chiar dacă utilizatorul le-a acceptat deja. Este necesară acceptarea explicită pentru a continua.',
        searchPlaceholder: 'Caută fișier…',
        filterLang: 'Filtrează după limbă',
        filterLangAll: 'Toate limbile',
        noResults: 'Niciun document nu corespunde filtrului.',
        vacio: 'Încă nu există documente corporative.',
        fecha: 'Dată',
        acciones: 'Acțiuni',
        descargar: 'Descarcă',
        editar: 'Editează',
        eliminar: 'Șterge',
        guardar: 'Salvează modificările',
        cancelar: 'Anulează',
        eliminarConfirm: 'Ștergeți acest document din depozit?',
        errorEliminar: 'Documentul nu a putut fi șters.',
        errorActualizar: 'Documentul nu a putut fi actualizat.',
        errorCargar: 'Lista nu a putut fi încărcată.',
        soloPdf: 'Se acceptă doar PDF de până la 25 MB.',
        requiereNombre: 'Introduceți un nume.',
        requiereOu: 'Selectați cel puțin o OU.',
        requiereArchivo: 'Alegeți un fișier PDF.',
        tipos: {
          PoliticaPrivacidad: 'Politică de confidențialitate',
          BasesLegales: 'Termeni legali',
          GuiaUsuario: 'Ghidul utilizatorului',
          Premios: 'Premii',
          CookiesPolicy: 'Politica de cookie-uri',
          LegalNotice: 'Notă legală',
        },
      },
      currentVersion: 'Versiunea curentă',
      noVersionYet: 'Nu a fost publicată încă nicio versiune',
      newVersionLabel: 'Versiune nouă de publicat',
      loadError: 'Ciorna nu a putut fi încărcată.',
      titleLabel: 'Titlu',
      sectionHeading: 'Titlu secțiune',
      sectionBody: 'Conținut',
      addSection: 'Adaugă secțiune',
      removeSection: 'Elimină secțiune',
      saveDraft: 'Salvează ciorna',
      publish: 'Publică',
      publishConfirm: 'Vei publica o versiune nouă. Toți utilizatorii vor trebui să o accepte din nou înainte de a putea oferi o recunoaștere. Continui?',
      missingLanguages: 'Limbi lipsă: {{languages}}',
      draftSaved: 'Ciornă salvată',
      published: 'Versiune publicată',
      saveError: 'Ciorna nu a putut fi salvată.',
      publishError: 'Versiunea nu a putut fi publicată.',
    },
    recap: {
      title: 'Recap Anual',
      desc: 'Configurează experiența Recap pe ediție. Fundalurile și pictogramele sunt configurabile pe slide; datele utilizatorului (recunoașteri, Fundamentalul cel mai primit, fanul nr. 1, seria) sunt injectate automat de platformă.',
      deniedRole: 'Gestionarea Recap-ului este rezervată Admin General și Admin Fundamentale.',
      fixValidation: 'Completează textele obligatorii înainte de a salva.',
      noEditions: 'Încă nu există ediții ale Recap-ului.',
      createFirst: 'Creează prima ediție',
      edition: 'Ediție',
      editionName: 'Nume vizibil pentru utilizator',
      newEdition: 'Ediție nouă',
      newConfig: 'Configurație nouă',
      newConfigName: 'Recap {{year}} · configurație nouă',
      newEditionTitle: 'Ediție nouă a rezumatului',
      newEditionYear: 'Anul ediției',
      newEditionYearRange: 'Alege un an între {{min}} și {{max}}.',
      newEditionFutureWarn: 'O ediție din {{year}} nu o vede nimeni până în acel an.',
      newEditionExisting: 'Există deja configurații pentru {{year}}: se va crea încă una, inactivă.',
      newEditionCreate: 'Creează ediția',
      delete: 'Șterge',
      deleteAria: 'Șterge configurația {{name}}',
      deleteTitle: 'Șterge configurația',
      deleteConfirm: '„{{name}}” ({{year}}) va fi ștearsă: dispare din istoric și din selector. Continui?',
      deleteBlockedActive: 'Se pot șterge doar edițiile în Ciornă. Setează „Recap activ” la Inactiv și salvează mai întâi.',
      deleteError: 'Configurația nu a putut fi ștearsă.',
      vistasOff: 'Rezumatul este oprit în Vizualizări pentru {{ous}}: activează-l ca să se vadă.',
      gestionOff: 'Rezumatul este oprit în Gestionare („Rezumat pe OU”): activează-l ca să se vadă.',
      gestionOffCreate: 'Cât timp Rezumatul este oprit în Gestionare („Rezumat pe OU”), nu se pot crea ediții sau configurații.',
      configsHint: 'Fiecare configurație are propriul domeniu de UO, stare, interval și notificare. Mai multe pot fi active în același timp dacă nu au UO comune; dacă o UO se află în interiorul alteia (MEXICO și una dintre fabricile sale), fiecare colaborator o vede pe cea mai specifică pentru UO sa.',
      openConfig: 'Deschide configurația {{name}}',
      scope: 'Arie OU',
      scopeGlobal: 'Global (toate)',
      active: 'Recap activ',
      activeOn: 'Activ',
      activeOff: 'Inactiv',
      visibleFrom: 'Început de vizibilitate',
      visibleTo: 'Sfârșit de vizibilitate',
      notification: 'Notificare',
      notifiedAt: 'Trimisă {{date}}',
      neverNotified: 'Fără notificare',
      difusionLockHint: 'Acest Recap a fost deja anunțat. Puteți EXTINDE domeniul și fereastra de vizibilitate, dar nu le puteți restrânge: eliminarea unei OU sau scurtarea datelor ar exclude persoane deja anunțate. Restul ediției rămâne editabil.',
      slidesTitle: 'Configurarea slide-urilor ({{count}} slide-uri)',
      slidesHint: 'Pictogramele Fundamentalelor și datele utilizatorului sunt injectate automat. Aici configurezi doar stratul vizual și textele.',
      i18nHint: 'Multilingv: titlul fiecărui slide se completează în toate cele 7 limbi din butonul Editează.',
      slidesFor: 'Configurează slide-urile pentru',
      slidesForGlobal: 'Global (toate OU-urile)',
      slidesForGlobalNote: 'Configurația de bază: o folosesc toate OU-urile care nu au una proprie.',
      slidesForCustomNote: '{{ou}} are propria configurație de slide-uri; se aplică și sub-OU-urilor sale fără configurație proprie.',
      slidesForInheritedNote: '{{ou}} folosește configurația din {{from}}. Dacă activați sau dezactivați un slide, se creează o configurație doar pentru {{ou}}.',
      slidesForRemoveCustom: 'Elimină configurația proprie',
      customizedOus: 'OU-uri cu configurație proprie:',
      customizedOuCount: '{{count}} slide-uri',
      lastSlideOn: 'Trebuie să rămână activ cel puțin un slide.',
      colSlide: 'Slide',
      colPreview: 'Previzualizare',
      colTitle: 'Titlu',
      colActive: 'Activ',
      colActions: 'Acțiuni',
      edit: 'Editează',
      titleMissing: 'Fără titlu',
      needAllLangs: 'Mai lipsesc limbi de completat (sunt necesare toate cele 7).',
      slides: {
        portada:    { name: 'Copertă',                     hint: 'Ecran de bun venit' },
        numeros:    { name: 'Anul tău în cifre',           hint: 'Primite + trimise' },
        define:     { name: 'Ceea ce te definește',        hint: 'Fundamentalul cel mai primit (dată automată)' },
        mensaje:    { name: 'Mesajul',                     hint: 'Cea mai lungă recunoaștere (dată automată)' },
        quienes:    { name: 'Cine te-a recunoscut',        hint: 'Totaluri și persoane (dată automată)' },
        red:        { name: 'Rețeaua ta',                  hint: 'Arii diferite care te-au recunoscut (dată automată)' },
        constancia: { name: 'Constanța ta',                hint: 'Serie de săptămâni (dată automată)' },
        reto:       { name: 'Provocarea ta de anul viitor', hint: 'Fundamentalul cel mai puțin arătat și îndemn la acțiune' },
        ganador:    { name: 'Câștigător Anual',            hint: 'Dacă utilizatorul a câștigat: insigna reală din secțiunea Câștigători' },
      },
      notifyTitle: 'Notificarea Recap-ului',
      notifyDesc: 'Anunță colegii din aria selectată că Recap-ul lor {{year}} este gata.',
      preview: 'Previzualizare',
      send: 'Trimite notificarea',
      notifyNeedsActive: 'Activează ediția pentru a o putea notifica.',
      notifyError: 'Notificarea nu a putut fi trimisă.',
      previewNote: 'Așa se parcurge ediția: doar slide-urile active, cu fundalurile și titlurile lor. Cifrele sunt ale utilizatorului care o deschide.',
      genericTitle: 'Mesaj generic (rezervă)',
      genericDesc: 'Se afișează când utilizatorul nu are recunoașteri în perioadă sau când intră înainte ca Recap-ul să fie vizibil.',
      genericTitleLabel: 'Titlul mesajului generic',
      genericDescLabel: 'Subtitlu / descriere',
      genericNote: 'Acest mesaj este rezerva: cine are date își va vedea Recap-ul personalizat.',
      imageUrlPlaceholder: 'URL-ul imaginii (PNG / JPG)',
      historyTitle: 'Istoricul Recap și câștigătorii anuali',
      historyDesc: 'Ediții înregistrate și câștigătorii anuali asociați fiecăreia.',
      colEdition: 'Ediție',
      colYear: 'An',
      colScope: 'Arie',
      colSlides: 'Slide-uri',
      colWinners: 'Câștigători anuali',
      colStatus: 'Stare',
      winnersCount: '{{count}} câștigători',
      status: { activa: 'Activă', completada: 'Finalizată', borrador: 'Ciornă', programada: 'Programată' },
      editorTitle: 'Editează slide-ul {{index}}',
      editorDescData: 'Configurează titlul (7 limbi), fundalul și textul care însoțește data dinamică. Previzualizarea se actualizează în timp ce scrii.',
      editorDescIcon: 'Configurează titlul (7 limbi), fundalul și pictograma slide-ului. Previzualizarea se actualizează în timp ce scrii.',
      titleLangs: 'Titlu (7 limbi)',
      titlePlaceholder: 'Titlu în {{lang}}',
      autoIcon: 'Pictograma acestui slide este automată: folosește insigna reală a câștigătorului configurată în Câștigători.',
      icon: 'Pictogramă',
      iconPlaceholder: 'Emoji sau URL de imagine',
      numberLabels: 'Text sub cifre',
      numberLabelsHint: 'Cifrele sunt calculate de platformă; aici definești cuvântul de dedesubt.',
      numberLabelPlaceholder: 'Ex.: primite',
      background: 'Fundal',
      uploadPhoto: 'Încarcă fotografie',
      uploadingPhoto: 'Se încarcă…',
      removePhoto: 'Elimină fotografia',
      photoHint: 'PNG · dimensiune recomandată 1080 × 1920 px · max. 5 MB. Fotografia apare peste culoare, care rămâne ca rezervă.',
      photoErrPng: 'Fundalul trebuie să fie o imagine PNG.',
      photoErrSize: 'Imaginea depășește 5 MB.',
      photoErrUpload: 'Imaginea nu a putut fi încărcată. Încearcă din nou.',
      photoErrNotPng: 'Fișierul are extensia .png, dar de fapt este {{formato}}. Salvează-l ca PNG și încarcă-l din nou.',
      photoErrRejected: 'Serverul a respins imaginea: {{motivo}}',
      photoErrUnavailable: 'Încărcarea fundalurilor nu este încă disponibilă în acest mediu (404). Contactează suportul.',
      photoErrForbidden: 'Nu ai permisiunea de a încărca fundaluri pentru Recap.',
      photoErrUploadCode: 'Imaginea nu a putut fi încărcată (cod {{codigo}}). Încearcă din nou; dacă persistă, contactează suportul.',
      previewLabel: 'Previzualizare',
      previewDataNote: 'Cifrele afișate sunt ale utilizatorului care își deschide Recap-ul.',
      apply: 'Aplică',
    },
  },
  // ── WP-16 REQ-140 — Modale legale ──
  legal: {
    privacy: 'Politica de confidențialitate',
    legal: 'Regulamentul Programului',
    reachedEnd: 'Ai ajuns la final!',
    scrollHint: 'Derulează până la final pentru a accepta',
    accept: 'Accept',
    acceptError: 'Nu am putut înregistra acceptul tău. Verifică conexiunea și încearcă din nou; dacă problema persistă, contactează suportul.',
    loadError: 'Documentul nu a putut fi încărcat.',
    pdfError: 'Documentul PDF nu a putut fi afișat.',
    retry: 'Reîncearcă',
    openInNewTab: 'Deschide într-o filă nouă',
  },
  // ── WP-16 REQ-139 — Înregistrare standalone Frontline ──
  register: {
    backToLogin: '← Înapoi la autentificare',
    entraTitle: 'Ai deja e-mail instituțional?',
    entraSub: 'Nu trebuie să te înregistrezi — conectează-te direct cu contul Sigma.',
    title: 'Înregistrare',
    subtitle: 'Creează-ți accesul la Programul de Recunoaștere.',
    fullName: 'Nume complet',
    email: 'Adresă de e-mail',
    ou: 'Unitate organizațională',
    selectOu: 'Selectează unitatea organizațională',
    startDate: 'Data angajării la Sigma',
    employeeId: 'Număr de marcă',
    bu: 'Unitate de afaceri',
    site: 'Locul de muncă',
    department: 'Departament',
    selectBu: 'Selectează Unitatea de afaceri',
    selectSite: 'Selectează locul de muncă',
    selectDepartment: 'Selectează departamentul',
    errName: 'Introdu numele complet.',
    errEmail: 'Introdu o adresă de e-mail validă.',
    errOu: 'Selectează unitatea organizațională.',
    errCatalogs: 'Completează unitatea de afaceri, locul și departamentul.',
    errStartDate: 'Introdu data angajării.',
    errEmployeeId: 'Introdu numărul de marcă.',
    catalogsError: 'Cataloagele nu au putut fi încărcate.',
    submit: 'Înregistrează-mă',
    submitError: 'Înregistrarea nu a putut fi finalizată.',
    checkEmailTitle: 'Verifică-ți e-mailul',
    checkEmailSub: 'Am trimis un link de verificare la {{email}}.',
    verified: 'E-mail verificat',
    allSet: 'Totul este gata!',
    allSetSub: 'Contul tău a fost configurat. Poți începe să-ți recunoști colegii.',
    password: 'Parolă (min. 8 caractere)',
    confirmPassword: 'Confirmă parola',
    errPassword: 'Parola trebuie să aibă între 8 și 256 de caractere.',
    errPasswordMatch: 'Parolele nu coincid.',
    errLegal: 'Trebuie să accepți Regulamentul.',
    errLegalVersion: 'Documentul legal nu a putut fi încărcat. Încearcă din nou.',
    errPrivacy: 'Trebuie să accepți Politica de confidențialitate.',
    errLocalId: 'Introdu numărul de marcă (până la 8 cifre).',
    errDepartment: 'Selectează departamentul.',
    acceptPrivacy: 'Am citit și accept',
    acceptLegalBases: 'Am citit și accept',
    privacyLink: 'Politica de confidențialitate',
    legalLink: 'Regulamentul',
    localId: 'Local ID',
    policyPlaceholder: 'Citește documentul complet. Când ajungi la final, îl vei putea accepta.',
    createdTitle: 'Cont creat',
    createdSub: 'Acum te poți autentifica cu e-mailul și parola ta. După autentificare, îți vei putea alege avatarul.',
    checkEmailHint: 'Deschide linkul pentru a-ți confirma adresa de e-mail și a te putea autentifica. Expiră în 24 de ore.',
    resend: 'Retrimite e-mailul',
    resendDone: 'Dacă contul tău așteaptă verificarea, ți-am trimis un alt link (valabil 24 de ore). Verifică și dosarul de spam. Dacă l-ai verificat deja, autentifică-te cu adresa de e-mail și parola.',
    errOuNotFound: 'Nu am găsit această organizație. Alege alta din listă.',
    errOuUnavailable: 'Înregistrarea nu este disponibilă pentru organizația selectată.',
    errNoMatch: 'Nu am putut valida datele tale cu evidențele companiei. Verifică dacă unitatea ta organizațională și numărul tău de marcă (sau Local ID, dacă ești din Europa) sunt corecte. Dacă te-ai înregistrat deja, autentifică-te sau resetează-ți parola. Dacă problema persistă, contactează Resursele Umane.',
    errEmailInUse: 'Această adresă de e-mail are deja un cont asociat.',
    corporateEmail: 'Aceasta este o adresă de e-mail corporativă și ai deja acces prin autentificarea Sigma (SSO), deci nu poate fi folosită pentru înregistrare. Autentifică-te cu contul tău Sigma.',
    errNetwork: 'Nu ne-am putut conecta. Verifică conexiunea și încearcă din nou.',
    errTooMany: 'Prea multe încercări. Așteaptă un moment și încearcă din nou.',
    errServer: 'A apărut o problemă de partea noastră și nu am putut finaliza înregistrarea. Încearcă din nou în câteva minute. Dacă persistă, comunică suportului această referință: {{referencia}}.',
    verifyConfirmTitle: 'Confirmă-ți adresa de e-mail',
    verifyConfirmSub: 'Apasă butonul pentru a finaliza verificarea adresei de e-mail și a-ți activa contul.',
    verifyConfirmCta: 'Confirmă adresa mea de e-mail',
    verifyAlready: 'Adresa ta de e-mail este deja verificată',
    verifyAlreadySub: 'Nu trebuie să faci nimic altceva: te poți autentifica acum.',
    verifyTemporary: 'Nu am putut verifica adresa ta de e-mail în acest moment',
    verifyTemporarySub: 'Linkul este încă valid. Verifică conexiunea și încearcă din nou.',
    verifyRetry: 'Încearcă din nou',
    errPayrollTaken: 'Acest număr de marcă are deja un cont asociat.',
    payrollTakenAction: 'Dacă te-ai înregistrat deja, te poți autentifica direct în cont sau poți solicita resetarea parolei dacă nu ți-o amintești.',
    payrollTakenRecover: 'Recuperează parola',
    linkInvalidTitle: 'Linkul nu mai este valid',
    linkInvalidBody: 'Ne pare rău, acest link de confirmare a expirat sau a fost invalidat din motive de securitate.',
    linkInvalidHint: 'Dacă ai solicitat acest acces, te rugăm să soliciți unul nou din aplicația noastră. Dacă nu recunoști acest site web, poți ignora în siguranță acest mesaj.',
    linkInvalidCta: 'Mergi la Pagina principală',
    checkEmailWrong: 'Nu este adresa ta de e-mail? Corect-o',
    verifyEmailTaken: 'Această adresă de e-mail este deja înregistrată',
    verifyEmailTakenSub: 'Altcineva a verificat primul aceeași adresă de e-mail. Dacă este a ta, autentifică-te sau resetează-ți parola; dacă nu, înregistrează-te din nou cu adresa ta.',
  },
  // ── Autentificare (RF-002) ──
  login: {
    title: 'Autentificare',
    subtitle: 'Programul de Recunoaștere',
    entraRouteTitle: 'Autentifică-te cu e-mailul instituțional',
    entraRouteSub: 'Folosește contul tău Sigma (Entra ID).',
    entra: 'Autentificare cu e-mail Sigma',
    frontlineRouteTitle: 'Nu ai e-mail instituțional?',
    frontlineRouteSub: 'Autentifică-te cu e-mailul și parola ta.',
    email: 'E-mail',
    password: 'Parolă',
    submit: 'Autentificare',
    submitting: 'Se autentifică…',
    or: 'sau',
    toRegister: 'Nu ai cont? Înregistrează-te',
    noAccountLede: 'Nu ai cont instituțional?',
    noAccountSub: 'Folosește un e-mail personal',
    alreadyRegisteredLede: 'Te-ai înregistrat deja?',
    hasInstitutionalEmailLede: 'Ai un e-mail instituțional?',
    register: 'Înregistrează-te',
    back: 'Înapoi',
    forgot: 'Ai uitat parola?',
    forgotIntro: 'Scrie-ți adresa de e-mail și îți trimitem un link ca să creezi o parolă nouă.',
    forgotSubmit: 'Trimite-mi linkul',
    forgotSent: 'Dacă adresa este înregistrată, ți-am trimis un link. Expiră în 60 de minute.',
    resendVerification: 'Nu ai primit e-mailul de verificare?',
    resendIntro: 'Scrie-ți adresa de e-mail și îți trimitem un alt link de verificare.',
    resendSubmit: 'Retrimite e-mailul',
    resendSent: 'Dacă contul tău așteaptă verificarea, ți-am trimis un alt link (valabil 24 de ore). Verifică și dosarul de spam. Dacă l-ai verificat deja, autentifică-te cu adresa de e-mail și parola.',
    errNotVerified: 'Adresa ta de e-mail nu este încă verificată. Deschide linkul pe care ți l-am trimis sau cere altul cu „Nu ai primit e-mailul de verificare?”.',
    errInactive: 'Contul tău este dezactivat. Contactează Resursele Umane.',
    errTempExpired: 'Parola ta temporară a expirat. Cere una nouă de la Resursele Umane.',
    errNetwork: 'Nu ne-am putut conecta. Verifică conexiunea și încearcă din nou.',
    corporateEmailHint: 'Aceasta este o adresă de e-mail corporativă: autentifică-te cu contul tău Sigma, fără parolă.',
    errRequired: 'Introdu e-mailul și parola.',
    errCredentials: 'E-mail sau parolă incorecte.',
  },
  // ── Landing comună (regula #3) ──
  landing: {
    question: 'Ce Fundamentals vom recunoaște astăzi?',
    subtitle: 'Alege un spațiu pentru a-ți trăi Fundamentals',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Cum a fost echipa ta la ultima ședință? Spune-le ce ai observat 💬',
    shineHover: 'Vrei să vezi cine strălucește și să nominalizezi un coleg?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  activate: {
    errTemporary: 'Nu am putut activa contul tău în acest moment. Verifică conexiunea și încearcă din nou; linkul tău este încă valid.',
  },
  reset: {
    titleTemporary: 'Alege parola ta definitivă',
    subtitleTemporary: 'Te-ai autentificat cu o parolă temporară. Alege una nouă pentru a continua.',
    errTemporary: 'Nu am putut procesa cererea ta în acest moment. Verifică conexiunea și încearcă din nou; linkul tău este încă valid.',
    title: 'Creează-ți parola nouă',
    subtitle: 'Alege o parolă ca să intri din nou.',
    password: 'Parolă nouă (min. 8 caractere)',
    confirmPassword: 'Confirmă parola',
    submit: 'Schimbă-mi parola',
    errPassword: 'Parola trebuie să aibă cel puțin 8 caractere.',
    errPasswordMatch: 'Parolele nu coincid.',
    errInvalidLink: 'Linkul nu este valid sau a expirat. Cere unul nou din pagina de autentificare.',
    doneTitle: 'Parolă actualizată',
    doneSub: 'Acum te poți autentifica cu adresa ta de e-mail și parola nouă.',
    noToken: 'Link invalid',
    noTokenSub: 'Linkul nu este valid sau este incomplet. Verifică e-mailul pe care l-ai primit.',
  },
  auth: {
    retryIn: 'Poți încerca din nou în {{seconds}} s',
    contactHR: 'Dacă întâmpini probleme la înregistrare, contactează echipa Capital Uman.',
    errorTitle: 'Nu am putut continua',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Alege-ți avatarul',
    subtitle: 'Alege imaginea care te reprezintă.',
    loading: 'Se încarcă avatarurile…',
    empty: 'Încă nu există avataruri disponibile.',
    loadError: 'Avatarurile nu au putut fi încărcate.',
    saveError: 'Avatarul tău nu a putut fi salvat.',
    saved: 'Avatar salvat',
    confirm: 'Confirmă',
    required: 'Alege-ți avatarul pentru a continua.',
    unavailable: 'Acest avatar nu mai este disponibil. Alege altul.',
    change: 'Schimbă avatarul',
    continueWithout: 'Continuă fără avatar',
  },
  // ── WP-08 — Rapoarte de Recunoaștere ──
  reports: {
    title: 'Rapoarte',
    subtitle: 'Analitica Programului de Recunoaștere. Nu arată niciodată puncte.',
    emptyScope: 'Nu aveți nicio unitate organizațională atribuită în domeniul dvs.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      heatmap: 'Hartă de căldură',
      network: 'Rețea ONA',
      generational: 'Demografic',
      leaders: 'Lideri',
      moderation: 'Moderare',
      campaigns: 'Istoric',
    },
    common: {
      loading: 'Se încarcă rapoartele…',
      error: 'Raportul nu a putut fi încărcat.',
      empty: 'Nu există date pentru filtrele selectate.',
      retry: 'Reîncearcă',
      suppressedNote: 'Unele agregate au fost ascunse din cauza pragului de anonimat (mai puțin de 5).',
      suppressedNoteHelp: 'Când un grup are mai puțin de 5 persoane, valorile sale dezagregate nu se publică: cu atât de puține, datele ar permite identificarea cuiva prin deducție. Nu este o eroare și nu lipsesc informații.',
      colScope: 'Domeniu (unități)',
      colScopeHelp: 'Unitățile organizaționale către care a fost direcționată campania.',
      colAudienceHelp: 'Numărul de angajați cărora le-a fost adresată campania. Este numitorul ratei de participare.',
      scopeAll: 'Toată organizația',
      scopeMore: '+{{n}} în plus',
      masked: 'Ascuns din motive de anonimat',
      showingRange: 'Se afișează {{desde}}–{{hasta}} din {{total}}',
      pageSize: 'Rânduri pe pagină',
      perPage: '{{n}} pe pagină',
      exportExcel: 'Exportă în Excel',
      yes: 'Da',
      no: 'Nu',
    },
    context: {
      unifiedTitle: 'Metrici unificate',
      unifiedText: '— Recunoaștere Zilnică și Strălucim Împreună folosesc aceeași logică de numărare. Datele sunt consecvente între module.',
      auditTitle: 'Audit activ.',
      auditText: 'Fiecare descărcare este înregistrată cu utilizatorul tău, fila și data.',
      showing: 'Se afișează:',
      wholeOrg: 'întreaga organizație',
    },
    filters: {
      allFundamentals: 'Toate Fundamentele',
      allOus: 'Toate OU-urile',
      site: 'Site',
      allSites: 'Toate site-urile',
      dateFrom: 'De la',
      dateTo: 'Până la',
      reset: 'Șterge',
      ou: 'Unitate',
      fundamental: 'Fundamental',
      dateRange: 'Date',
      remove: 'Elimină filtrul {{filter}}',
      person: 'Persoană',
      personPlaceholder: 'Caută persoană…',
      openCalendar: "Deschide calendarul",
      personClear: 'Elimină persoana selectată',
      personNoResults: 'Nicio potrivire în director',
      personSearching: 'Se caută…',
      personError: 'Directorul nu a putut fi consultat',
    },
    notApplicable: {
      title_one: 'Filtrul {{filtros}} nu se aplică în această secțiune.',
      title_few: 'Filtrele {{filtros}} nu se aplică în această secțiune.',
      title_other: 'Filtrele {{filtros}} nu se aplică în această secțiune.',
      and: 'și',
      reason: {
        embudo: 'Pâlnia împarte întreaga populație în Obișnuiți, Ocazionali și Inactivi; restrânsă la o singură persoană, nu ar mai fi o distribuție.',
        historico: 'Aceste cifre sunt "dintotdeauna", nu ale perioadei alese: numără pe oricine a recunoscut vreodată pe cineva, în toată istoria sa pe platformă.',
        audienciaCampana: 'Acest indicator se calculează pe audiența convocată de campanie, care rămâne aceeași indiferent de Fundamentul sau persoana aleasă.',
        porBanda: 'Distribuția grupează persoanele pe bandă generațională; cu o singură persoană selectată ar rămâne o singură bandă și nu ar mai fi o distribuție.',
        porOu: 'Această vizualizare grupează pe unitate organizațională, nu pe persoană.',
        redOu: 'Nodurile rețelei sunt unități organizaționale, nu persoane.',
        promedioPulso: 'Acest tabel provine din scorurile medii Pulso (1-4) pe generație și Fundament, nu din numărul de recunoașteri sau din recensământul de personal: niciunul dintre cei doi filtri nu îl restrânge.',
        resumenCampana: 'Acest indicator provine din rezumatul întregii campanii: backend-ul nu permite restrângerea la o singură persoană (dar permite restrângerea după Fundament).',
        casosReportados: 'Raportul listează CAZURI raportate, iar motivul raportării este scris de cine raportează: nu este legat de un Fundament al recunoașterii. OU, intervalul de date și persoana restrâng însă acest tabel.',
        campanaFinalizada: "Campania aleasă s-a încheiat: se afișează completă, de la început până la sfârșit.",
      },
    },
    daily: {
      title: 'Recunoaștere Zilnică',
      subtitle: 'Doar recunoașteri din activitatea zilnică, fără campanii: perioada aleasă vs. cea anterioară, pâlnia de participare și topuri.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Perioada selectată',
      prevPeriod: 'Perioada anterioară',
      vsPrev: '{{variacion}} vs. perioada anterioară · {{previo}}',
      fundamentalDistribution: 'Distribuție pe Fundament',
      totalSentTitle: 'Total recunoașteri trimise',
      totalSentHint: 'Suma tuturor recunoașterilor trimise în perioadă',
      retiredFundamental: 'Fundament retras',
      unresolvedFundamental: 'Fundament (catalog indisponibil)',
      retiredFundamentalHint: 'Fundament retras din catalog: rămâne în istoric pentru că au existat recunoașteri cu el, dar nu mai poate fi ales.',
      adoptionStaff: 'Utilizatori Staff',
      adoptionFrontline: 'Utilizatori Frontline',
      adoptionTotal: 'Utilizatori în total',
      noActivity: 'Fără activitate',
      adoptionHint: '{{reconocedores}} din {{plantilla}} au recunoscut pe cineva',
      adoptionTotalHint: '{{pct}} din personalul total ({{plantilla}})',
      noActivityHint: 'Nu au trimis niciodată o recunoaștere',
      variation: 'Variație',
      sparkAria: 'Tendința zilnică pentru {{label}}: {{dias}} zile, de la {{primero}} la {{ultimo}}',
      uniquePeople: 'Persoane unice',
      pares: 'Colegi',
      lideres: 'Lideri',
      groupRecognitions: 'Recunoașteri de grup',
      groupRecognitionsHint: 'din {{total}} trimise · către 2 sau mai multe persoane',
      funnel: 'Pâlnia de participare',
      funnelRange: 'Interval: {{from}} – {{to}}',
      funnelPeople: '{{count}} persoane',
      topPeople: 'Top persoane recunoscute',
      topRecognizers: 'Top recunoscători',
      topFundamentals: 'Top fundamentale',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Exportă Zilnic (6 foi)',
      colStage: 'Etapă',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Nume",
      colDepto: "Departament",
      colOu: "OU",
      colFundamental: "Fundamental",
      colRecos: 'Recunoașteri',
      colEnviados: "Trimise",
      colCrossOu: "Între OU",
      colType: "Tip",
      crossOu: {
        si: "Da",
        no: "Nu",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'E-mail',
      colEmployeeId: 'Număr de marcă',
      colRecognitions: 'Recunoașteri',
      colDominantType: 'Tip dominant',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Rezumat executiv',
        sheetDefinitions: 'Definiții',
        sheetFunnel: 'Pâlnia de adopție',
        sheetTopRecognized: 'Top recunoscuți',
        sheetTopRecognizers: 'Top care recunosc',
        sheetAllRecognitions: 'Toate recunoașterile',
        sheetReceived: 'Recunoașteri primite',
        summaryTitle: 'Recunoaștere Zilnică — Fundamente de zi cu zi',
        summarySubtitle: 'Indicatorii perioadei selectate: cine recunoaște, pe cine și cât de des.',
        definitionsTitle: 'Ce înseamnă fiecare dată?',
        definitionsSubtitle: 'Explicație în limbaj simplu, pentru oricine descarcă acest fișier, fără să fie nevoie de cunoștințe despre date.',
        funnelTitle: 'Pâlnia de adopție',
        funnelSubtitle: 'Segmentare calculată după frecvența recunoașterilor trimise în perioadă ({{rango}}), ca medie lunară.',
        funnelEmpty: 'Fără date: nu există recunoașteri în perioadă.',
        topRecognizedTitle: 'Cei mai recunoscuți',
        topRecognizersTitle: 'Top care recunosc',
        rankingSubtitle: 'Clasament calculat pe baza recunoașterilor din această perioadă.',
        topRecognizersEmpty: 'Fără date: nimeni nu a trimis recunoașteri în perioadă.',
        allRecognitionsTitle: 'Toate recunoașterile',
        allRecognitionsSubtitle: 'Detaliu brut al activității zilnice în perioadă, fără trimiterile de campanie: un rând pentru fiecare candidat recunoscut. Numele coloanelor își păstrează forma originală pentru ca tabelele pivot ale comitetului să funcționeze în continuare.',
        allRecognitionsNoRange: 'Fără date: intervalul exact al perioadei nu a putut fi determinat, deoarece agregatul este suprimat de pragul de anonimat, iar filtrul nu conține date explicite.',
        receivedTitle: 'Recunoașteri primite',
        receivedSubtitle: 'Recunoașterile din perioadă primite de persoane din OU-urile selectate, indiferent de OU-ul celui care recunoaște: un rând pentru fiecare persoană recunoscută. La o recunoaștere de grup apar doar persoanele din acele OU-uri.',
        receivedAllOus: 'Fără înregistrări: cu toate OU-urile, ce s-a primit este același lucru cu ce s-a trimis și se află deja în „Toate recunoașterile”. Selectați unul sau mai multe OU-uri pentru a vedea aici ce au primit.',
        metaPeriod: 'Perioadă',
        metaFilters: 'Filtre aplicate',
        metaFunnelMonth: 'Perioada pâlniei',
        metaGenerated: 'Generat',
        colKpi: 'KPI',
        colValue: 'Valoare',
        colDetail: 'Detaliu',
        colDatum: 'Dată',
        colWhatIs: 'Ce este',
        colHowCalculated: 'Cum se calculează',
        colPercentOfTotal: '% din total',
        colSegment: 'Segment',
        colPeople: 'Persoane',
        colAdministrative: 'Administrativi',
        colOperational: 'Operativi',
        colFundamental: 'Fundament',
        colRank: '#',
        colArea: 'Arie',
        colSite: 'Site',
        headcountTitle: 'Personal',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Persoane',
        kpiPeers: 'Colegi (recunoașteri unice între colegi)',
        kpiLeaders: 'Lideri (recunoașteri unice la care participă un lider)',
        datumTeamRecognitions: 'Recunoașteri acordate echipelor',
        datumAudienceStaff: 'Audiență Staff (administrativi)',
        datumAudienceFrontline: 'Audiență Frontline (operativi)',
        datumComparison: 'Perioada anterioară și variația',
        datumRankings: 'Top recunoscuți / Top care recunosc',
        datumLeader: 'Lider',
        whatRecognitionsMade: 'Câte recunoașteri au fost trimise în total în perioadă, cu filtrele aplicate.',
        calcRecognitionsMade: 'Se adună recunoașterile din activitatea zilnică cu dată în perioada aleasă. Cele care aparțin unei campanii se numără în raportul «Strălucim Împreună».',
        whatUniqueRecognized: 'Câte persoane diferite au primit cel puțin o recunoaștere. Cine a primit cinci se numără o singură dată.',
        calcUniqueRecognized: 'Se numără persoanele diferite care apar ca destinatari în perioadă.',
        whatTeamRecognitions: 'O recunoaștere este de grup atunci când are mai mult de un destinatar.',
        calcTeamRecognitions: 'Coloana «Recognition type» din foaia «Toate recunoașterile» marchează fiecare rând ca Individual sau Grupal.',
        whatPeers: 'Recunoașteri în care nici cel care recunoaște, nici cel care primește nu are oameni în subordine: coleg la coleg, lider la lider, manager la manager.',
        calcPeers: 'Se filtrează recunoașterile între colegi din perioadă.',
        whatLeaders: 'Recunoașteri la care participă cel puțin o persoană cu oameni în subordine.',
        calcLeaders: 'Se filtrează recunoașterile în care cel care trimite sau cel care primește are rol de lider, supervizor sau manager.',
        whatStaffAdoption: 'Din toate persoanele de birou (Staff), ce procent a recunoscut deja pe cineva în perioadă.',
        calcStaffAdoption: 'Persoanele Staff cu cel puțin o recunoaștere trimisă în perioadă, împărțit la totalul persoanelor Staff din domeniu.',
        whatFrontlineAdoption: 'Din toate persoanele din operațiuni sau producție (Frontline), ce procent a recunoscut deja pe cineva în perioadă.',
        calcFrontlineAdoption: 'Persoanele Frontline cu cel puțin o recunoaștere trimisă în perioadă, împărțit la totalul persoanelor Frontline din domeniu.',
        whatTotalUsers: 'Câte persoane din domeniu au trimis cel puțin o recunoaștere vreodată, de când au cont.',
        calcTotalUsers: 'Persoane cu cel puțin o recunoaștere trimisă în tot istoricul lor. Nu depinde de perioada selectată: provine din recensământul zilnic.',
        whatNoActivity: 'Persoane care nu au trimis niciodată nicio recunoaștere de când au cont.',
        calcNoActivity: 'Personalul total al domeniului minus persoanele cu cel puțin o recunoaștere trimisă în tot istoricul lor.',
        whatAudienceStaff: 'Persoane cu cont corporativ Entra ID.',
        whatAudienceFrontline: 'Persoane care se înregistrează pe platformă cu propria adresă de e-mail.',
        whatPrevPeriod: 'Recunoașteri trimise în aceleași zile imediat înainte de perioada selectată.',
        whatVariation: 'Cu cât a crescut sau a scăzut volumul de recunoașteri față de perioada anterioară echivalentă.',
        calcVariation: 'Perioada anterioară cuprinde aceleași zile imediat înainte de cea selectată. Variația este diferența dintre cele două, împărțită la totalul perioadei anterioare.',
        whatFunnel: 'Segmentează domeniul după frecvența de trimitere în perioada aleasă, aceeași de mai sus: Constanți (în medie patru sau mai multe pe lună), Ocazionali (cel puțin una, sub această medie) și Inactivi (niciuna). Pentru perioade mai scurte de o lună se aplică pragul unei luni. Fiecare etapă este defalcată în administrativi și operativi.',
        calcFunnel: 'Procentul și coloana Persoane se calculează pe personalul domeniului. Administrativii și operativii numără aceleași persoane după tipul postului și rămân goale dacă acea clasificare nu este disponibilă.',
        whatRankings: 'Persoanele cele mai recunoscute și cele care recunosc cel mai mult în perioadă, până la 200 în fiecare listă.',
        calcRankings: 'Se ordonează după numărul de recunoașteri primite sau trimise. Cine nu atinge pragul de anonimat apare mascat.',
        whatAllRecognitions: 'Detaliu brut al perioadei, un rând pentru fiecare candidat: blocurile Nominee, OnBehalfOf și Candidate complete, data, matricea de Habits active și indicatorii de audit. Nu maschează persoanele: este sursa de lucru a comitetului, iar pragul de anonimat se aplică rapoartelor agregate. Include și recunoașterile din campaniile Strălucim Împreună în curs, pentru că raportul zilnic le numără pe toate.',
        calcAllRecognitions: 'Lista completă a recunoașterilor din perioadă. Coloanele de Obiceiuri includ doar pe cele active în catalog la momentul exportului. Coloana Reco_ID rămâne goală pentru că sistemul încă nu generează un identificator unic pe rând.',
        whatGroupRecognitions: 'Câte dintre recunoașterile trimise au mers către două sau mai multe persoane. Fiecare recunoaștere de grup contează o singură dată, indiferent câte persoane recunoaște.',
        calcGroupRecognitions: 'Se numără recunoașterile cu două sau mai multe persoane recunoscute. „Toate recunoașterile” are un rând pentru fiecare persoană recunoscută, deci poate avea mai multe rânduri decât totalul recunoașterilor trimise.',
        whatReceived: 'Detaliul a ceea ce au primit persoanele din OU-urile selectate în filtru, chiar dacă cine le-a recunoscut aparține altui OU (recunoașteri Cross-OU).',
        calcReceived: 'Se include fiecare persoană recunoscută al cărei OU este printre cele selectate (cu unitățile subordonate). O persoană fără OU contează cu OU-ul celui care a recunoscut-o. Cu toate OU-urile, foaia rămâne fără înregistrări.',
        noteLeader: 'Un rol este considerat lider atunci când are oameni în subordine.',
        masked: 'Ascuns din motive de anonimat',
      },
    },
    shine: {
      pointsAwarded: 'Puncte acordate',
      pointsAwardedHint: '{{nominaciones}} nominalizări · {{personas}} persoane',
      personaNoFiltraCampanas: 'Filtrul Persoană nu se aplică listei de campanii: aceasta se restrânge după UO și stare.',
      personaEnElReporte: "Cu Persoană, raportul arată ce a trimis sau a primit acea persoană în campanie; „Recunoașteri realizate” și clasamentul numără doar ce a trimis.",
      title: 'Strălucim Împreună',
      subtitle: 'Clasamentul nominalizărilor campaniei și indicatori în timp real.',
      recognitionsMade: 'Recunoașteri realizate',
      uniqueRecognized: 'Persoane unice recunoscute',
      uniqueRecognizers: 'Persoane unice care recunosc',
      participationRate: 'Rata de participare',
      totalHeadcount: 'Totalul angajaților',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Exportă Shine (7 foi)',
      exporting: 'Se exportă…',
      exportError: 'Descărcarea nu a putut fi finalizată. Încearcă din nou.',
      exportTooLarge: 'Raportul depășește 200.000 de rânduri pe foaie. Restrânge perioada sau filtrele și exportă din nou.',
      winnersFormat: 'Formatul exportului de câștigători',
      datesFromCampaign: "Datele au fost ajustate la perioada campaniei alese; le puteți modifica.",
      rankingCountsPeople: "Cardurile numără recunoașteri, iar clasamentul numără persoane: o recunoaștere de grup se adaugă o dată sus și o dată pentru fiecare persoană aici, așa că cifrele pot diferi.",
      winnersOnlyExpired: "Disponibil după expirarea campaniei: înainte nu există câștigători.",
      winnersEmpty: "Această campanie nu are încă câștigători înregistrați.",
      formatRaw: 'Brut',
      formatCascaded: 'În cascadă',
      exportWinners: 'Exportă câștigătorii',
      colPos: 'Poziție',
      kpiTotal: 'Total',
      kpiParticipants: 'Participanți',
      kpiParticipation: 'Participare',
      kpiAvgPerPerson: 'Medie pe persoană',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campanie',
      campaignScope: "Aria de acoperire a campaniei:",
      allCampaigns: "Toate campaniile",
      scopeOnlyCoversAll: "Această campanie acoperă doar {{alcance}}; celelalte OU nu sunt incluse în acest raport.",
      scopeOnlyCoversSome: "Această campanie acoperă doar {{alcance}}. În afara ariei sale: {{fuera}}.",
      campaignStatusLabel: "Starea campaniei",
      campaignStatus: { activa: "Activă", finalizada: "Expirată" },
      noCampaigns: "Nu există campanii cu această stare pentru OU-urile alese",
      campaignsForbidden: 'Nu aveți permisiunea de a consulta campaniile',
      campaignsLoadError: 'Campaniile nu au putut fi încărcate',
      filtersHelp: "Alegeți mai întâi OU: lista de campanii depinde de ea. Apoi statusul și campania, care este decisivă: cifrele provin din aria ei. Site-ul, Fundamentalul și persoana restrâng în cadrul acestei arii. Intervalul de date se aplică doar campaniilor active; una expirată este raportată integral.",
      filtersHelpAria: "Cum se combină filtrele cu campania",
      modalidadSelector: 'Filtru Strălucim Împreună',
      daysLeft: 'Zile rămase',
      activeOus: 'OU active',
      modalidadTodos: 'Toți nominalizații',
      modalidadPersonaUnica: 'Doar destinatar unic',

      modalidadGrupal: 'Doar grup (echipă)',
      modalidadCrossOu: 'Inter-OU',
      pickCampaign: "Selectează mai întâi o campanie.",
      habitsRanking: 'Clasament Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Recunoașteri',
      colName: 'Nume',
      colBu: 'BU',
      colDept: 'Dept.',
      colOrigin: 'Sursă',
      filterHabitsByFundamental: 'Filtrează obiceiurile după Fundament',
      allFundamentals: 'Toate Fundamentele',
      colCount: 'Recunoașteri',
      colOu: 'OU',
      colCountry: 'Țară',
      colBadge: 'Insignă',
      colCrossed: 'Origine încrucișată',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-mail',
      colEmployeeId: 'Marcă',
      colCrossOu: 'Între OU',
      colDominantType: 'Tip dominant',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Utilizatori Staff',
      adoptionFrontline: 'Utilizatori Frontline',
      adoptionTotal: 'Utilizatori total',
      noActivity: 'Fără activitate',
      adoptionHint: '{{reconocedores}} din {{plantilla}} au nominalizat',
      adoptionTotalHint: '{{pct}} din efectivul total ({{plantilla}})',
      noActivityHint: 'Nu au trimis niciodată o nominalizare',
      clearAll: 'Șterge tot',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        kpiCrossOu: 'Recunoașteri între UO',
        whatCrossOu: 'Recunoașteri în care cel puțin o persoană recunoscută aparține altei UO decât cea a persoanei care recunoaște.',
        calcCrossOu: 'Se numără o dată pe recunoaștere: ajunge ca o persoană recunoscută să fie din altă UO. Dacă UO unei persoane recunoscute nu se cunoaște, nu se consideră traversare.',
        datumAwardsPoints: 'Campania acordă puncte',
        whatAwardsPoints: '{{valor}}. Arată dacă recunoașterile acestei campanii aduc puncte persoanelor recunoscute.',
        calcAwardsPoints: 'Provine din configurarea campaniei („Se aplică puncte”). Doar administratorii de puncte văd punctele.',
        sheetReceivedRecognitions: 'Toate recunoașterile primite',
        receivedRecognitionsTitle: 'Toate recunoașterile primite',
        receivedRecognitionsSubtitle: "Aceleași coloane ca «Toate recunoașterile», cu ce au primit persoanele din OU filtrată (sau din OU celui care exportă) în toate campaniile Brillamos din perioadă. Coloana Campaign arată care.",
        sheetSummary: 'Rezumat executiv',
        sheetDefinitions: 'Definiții',
        sheetDistribution: 'Distribuție Fundament',
        sheetFunnel: 'Pâlnie de adopție',
        sheetTopRecognized: 'Cei mai recunoscuți',
        sheetTopRecognizers: 'Cei care recunosc cel mai mult',
        sheetAllRecognitions: 'Toate recunoașterile',
        summaryTitle: 'Campania Strălucim Împreună',
        definitionsTitle: 'Ce înseamnă fiecare dată?',
        definitionsSubtitle: 'Explicație în limbaj simplu, pentru oricine descarcă acest fișier, fără a fi nevoie de cunoștințe despre date.',
        distributionTitle: 'Distribuție pe Fundament',
        distributionSubtitle: 'Pondere calculată din recunoașterile acestei campanii.',
        distributionChart: 'Recunoașteri pe Fundament',
        distributionNote: 'O recunoaștere poate include mai multe Fundamente sau mai multe Obiceiuri în același timp, iar fiecare se numără separat: sumele din acest tabel pot să nu coincidă cu totalul campaniei sau cu numărul Fundamentului lor.',
        distributionEmpty: 'Fără date: campania nu are recunoașteri cu Fundament înregistrat în perioadă.',
        funnelTitle: 'Pâlnie de adopție',
        funnelSubtitle: 'Segmentare calculată după frecvența recunoașterilor trimise în perioada campaniei.',
        funnelEmpty: 'Fără date: campania nu are recunoașteri în perioadă.',
        topRecognizedTitle: 'Cei mai recunoscuți',
        topRecognizersTitle: 'Cei care recunosc cel mai mult',
        rankingSubtitle: 'Clasament calculat din recunoașterile acestei campanii.',
        topRecognizersEmpty: 'Fără date: nimeni nu a oferit recunoaștere în această campanie.',
        allRecognitionsTitle: 'Toate recunoașterile',
        allRecognitionsSubtitle: 'Detaliu brut al campaniei: câte un rând pentru fiecare candidat recunoscut. Numele coloanelor rămân în forma originală, ca tabelele pivot ale comitetului să funcționeze în continuare.',
        metaPeriod: 'Perioadă',
        metaFilters: 'Filtre aplicate',
        metaScope: 'Aria de aplicare',
        whatPointsAwarded: 'Suma punctelor valabile acordate de campanie fiecărei persoane recunoscute, în perioada și aria de aplicare ale raportului. Doar pentru administratorii de puncte.',
        noPoints: "Fără puncte",
        metaGenerated: 'Generat',
        colKpi: 'KPI',
        colValue: 'Valoare',
        colDetail: 'Detaliu',
        colDatum: 'Dată',
        colWhatIs: 'Ce este',
        colHowCalculated: 'Cum se calculează',
        colFundamentals: 'Fundamente',
        colPercentOfTotal: '% din total',
        colSegment: 'Segment',
        colPeople: 'Persoane',
        colAdministrative: 'Administrativi',
        colOperational: 'Operaționali',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundament',
        colRank: '#',
        colArea: 'Arie',
        colSite: 'Sediu',
        headcountTitle: 'Personal',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Persoane',
        kpiPeers: 'Colegi (recunoașteri unice între colegi de același nivel)',
        kpiLeaders: 'Lideri (recunoașteri unice la care participă un lider)',
        kpiTotalSent: 'Total recunoașteri trimise',
        kpiIndividual: 'Total recunoașteri către o singură persoană',
        kpiGroup: 'Total recunoașteri adresate grupurilor',
        kpiPeopleInGroup: "Persoane recunoscute în recunoașteri de grup",
        whatPeopleInGroup: "Câte persoane au primit recunoașterile de grup: o recunoaștere de grup pentru 5 persoane adună 5.",
        calcPeopleInGroup: "Suma destinatarilor fiecărei recunoașteri cu mai mult de unul, cu aceleași filtre ca restul KPI-urilor.",
        kpiTotalNominations: "Total nominalizări (una pentru fiecare persoană recunoscută)",
        whatTotalNominations: "Către o singură persoană + Persoane recunoscute în recunoașteri de grup. Este unitatea foii «Toate recunoașterile», care are un rând pe persoană.",
        calcTotalNominations: "Total recunoașteri către o singură persoană + Persoane recunoscute în recunoașteri de grup. A nu se confunda cu «Total recunoașteri trimise» (= o singură persoană + grup), care numără fiecare recunoaștere o dată. «Toate recunoașterile» listează și nominalizările ascunse sau raportate (cu Status-ul lor) și cele venite din altă campanie prin «trimite la Strălucim Împreună»; coloana Reco_ID grupează rândurile aceleiași recunoașteri.",
        datumTeamRecognitions: 'Recunoașteri adresate echipelor',
        datumAudienceStaff: 'Public Staff (administrativi)',
        datumAudienceFrontline: 'Public Frontline (operaționali)',
        datumLeader: 'Lider',
        whatRecognitionsMade: 'Câte recunoașteri au fost trimise în total în cadrul campaniei, cu filtrele aplicate.',
        calcRecognitionsMade: 'Se adună toate recunoașterile cu dată în perioada campaniei.',
        whatUniqueRecognized: 'Câte persoane diferite au primit cel puțin o recunoaștere. Cine a primit cinci se numără o singură dată.',
        calcUniqueRecognized: 'Se numără persoanele diferite care apar ca destinatari în perioadă.',
        whatTeamRecognitions: 'O recunoaștere este de grup atunci când are mai mult de un destinatar.',
        calcTeamRecognitions: 'Se numără recunoașterile cu doi sau mai mulți destinatari.',
        whatIndividual: 'Recunoașteri ale campaniei adresate unei singure persoane.',
        calcIndividual: 'Se numără recunoașterile cu exact un destinatar.',
        whatPeers: 'Recunoașteri în care nici cel care recunoaște, nici cel care primește nu are oameni în subordine: coleg către coleg, lider către lider, manager către manager.',
        calcPeers: 'Se filtrează recunoașterile între colegi de același nivel din această campanie.',
        whatLeaders: 'Recunoașteri la care participă cel puțin o persoană cu oameni în subordine.',
        calcLeaders: 'Se filtrează recunoașterile în care cel care trimite sau cel care primește are rol de lider, supervizor sau manager.',
        whatStaffAdoption: 'Din toate persoanele de birou (Staff), ce procent a recunoscut deja pe cineva în această campanie.',
        calcStaffAdoption: 'Persoanele Staff cu cel puțin o recunoaștere trimisă în campanie, împărțite la totalul persoanelor Staff din publicul său.',
        whatFrontlineAdoption: 'Din toate persoanele din operațiuni sau producție (Frontline), ce procent a recunoscut deja pe cineva în această campanie.',
        calcFrontlineAdoption: 'Persoanele Frontline cu cel puțin o recunoaștere trimisă în campanie, împărțite la totalul persoanelor Frontline din publicul său.',
        whatTotalUsers: 'Câte persoane din publicul campaniei au trimis cel puțin o recunoaștere în cadrul ei.',
        calcTotalUsers: 'Persoane cu cel puțin o recunoaștere trimisă în perioada campaniei. Nu este o numărătoare istorică pe toată durata contului.',
        whatNoActivity: 'Persoane din public care nu au trimis nicio recunoaștere în timpul campaniei.',
        calcNoActivity: 'Publicul campaniei minus persoanele cu cel puțin o recunoaștere trimisă în ea.',
        whatAudienceStaff: 'Persoane cu cont corporativ Entra ID.',
        whatAudienceFrontline: 'Persoane care se înregistrează pe platformă cu adresa proprie de e-mail.',
        whatParticipationRate: 'Procentul din publicul-țintă care a participat la campanie trimițând cel puțin o recunoaștere.',
        calcParticipationRate: 'Participanți împărțiți la publicul-țintă al campaniei.',
        whatUniqueRecognizers: 'Persoane diferite care au trimis cel puțin o recunoaștere în această campanie.',
        calcUniqueRecognizers: 'Numărul emițătorilor diferiți din recunoașterile campaniei.',
        whatDistribution: 'Ierarhie pe două niveluri: fiecare Fundament cu ponderea sa din totalul campaniei și, dedesubt și indentate, obiceiurile zilnice cu ponderea pe care o reprezintă în cadrul acelui Fundament.',
        calcDistribution: 'Ponderea unui Fundament este numărul său de recunoașteri împărțit la totalul campaniei. Cea a unui Obicei este numărul său de recunoașteri împărțit la totalul Fundamentului său.',
        whatFunnel: 'Segmentează publicul campaniei după frecvență: Constanți (patru sau mai multe pe lună), Ocazionali (una până la trei) și Inactivi (niciuna). Fiecare etapă se detaliază suplimentar în Administrativi și Operaționali.',
        calcFunnel: 'Procentul și coloana Persoane se calculează pe publicul campaniei, nu pe întreaga organizație. Administrativi și Operaționali numără aceleași persoane după tipul postului și rămân goale dacă acea clasificare nu este disponibilă.',
        whatAllRecognitions: 'Detaliu brut al campaniei, câte un rând pentru fiecare candidat: blocurile Nominee, OnBehalfOf și Candidate complete, data, matricea Obiceiurilor active și indicatorii de audit. Nu maschează persoane: este sursa de lucru a comitetului, iar pragul de anonimat se aplică rapoartelor agregate.',
        calcAllRecognitions: 'Lista completă a recunoașterilor din perioadă. Coloanele de Obiceiuri includ doar pe cele active în catalog la momentul exportului. Coloana Reco_ID rămâne goală pentru că sistemul încă nu generează un identificator unic pe rând.',
        noteLeader: 'Un rol este considerat de lider atunci când are oameni în subordine.',
        masked: 'Ascuns din motive de anonimat',
        crossOuCount: '{{count}} OU',
      },
    },
    history: {
      selectCampaign: 'Alege o campanie',
      colName: 'Nume',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
        colType: "Tip",
        colStatus: "Stare",
        colRecognitions: "Recunoașteri",
        colExpiration: "Data de încheiere",
        colActions: "Acțiuni",
        status: {
        activo: "Activă",
          expirado: "Expirată",
          borrador: "Ciornă",
        },
      // P18-ter — raport GLOBAL al campaniilor (toate, nu una singură), după modelul 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Total campanii',
      kpiTotalRecognitions: 'Total recunoașteri',
      kpiAudienceTotal: 'Audiență totală',
      kpiParticipantsTotal: 'Participanți',
      kpiParticipantsStaff: 'Participanți Staff',
      kpiParticipantsFrontline: 'Participanți Frontline',
      kpiParticipationRate: 'Rata de participare',
      kpiAvgPerParticipant: 'Medie de recunoașteri per participant',
      colDescription: 'Descriere',
      colParticipants: 'Participanți',
      colParticipantsStaff: 'Participanți Staff',
      colParticipantsFrontline: 'Participanți Frontline',
      colDuration: 'Durata campaniei',
      colFrequency: 'Frecvență',
      colGoalPercent: '% din obiectiv',
      downloadGlobalExcel: 'Descarcă raportul global',
      downloadGlobalError: 'Raportul global nu a putut fi descărcat.',
      // Excel Istoric (`historicosExcel.ts`) — texte EXCLUSIVE fișierului descărcabil: nume de foi,
      // banner, metadate și glosar. Etichetele de date nu se repetă aici: se reutilizează cheile
      // `kpi*`/`col*` de mai sus, ca fișierul și ecranul să spună același lucru.
      excel: {
        sheetSummary: 'Rezumat executiv',
        sheetDefinitions: 'Definiții',
        sheetCampaigns: 'Campanii istorice',
        summaryTitle: 'Istoric pe campanie',
        summarySubtitle: 'Consolidează istoricul campaniilor de recunoaștere: audiență, participare și volum de recunoașteri pentru fiecare.',
        campaignsSubtitle: 'Detaliu comparativ pe campanie.',
        definitionsTitle: 'Ce înseamnă fiecare indicator?',
        definitionsSubtitle: 'Explicație în limbaj simplu, aliniată cu Rezumatul executiv și cu modul de măsurare al fiecărui KPI.',
        metaFilter: 'Filtru aplicat',
        metaGenerated: 'Generat',
        filterAllCampaigns: 'Toate campaniile',
        colKpi: 'KPI',
        colValue: 'Valoare',
        colNote: 'Notă / definiție',
        colDatum: 'Indicator',
        colWhatIs: 'Ce este',
        colHowMeasured: 'Cum se măsoară',
        colHowCalculated: 'Cum se calculează',
        colComparedTo: 'Se compară cu',
        colWhereShown: 'Unde apare',
        colAudienceOu: 'Audiență OU',
        whereSummary: 'Rezumat executiv',
        whereSummaryCampaigns: 'Rezumat executiv / Campanii istorice',
        datumStaffFrontline: 'Participanți Staff / Participanți Frontline',
        durationDays_one: '{{count}} zi',
        durationDays_few: '{{count}} zile',
        durationDays_other: '{{count}} de zile',
        whatCampaigns: 'Numărul de campanii incluse în istoric sau în filtrul aplicat.',
        measuredCampaigns: 'Se numără fiecare campanie înregistrată cu nume valid în istoric.',
        calcCampaigns: 'Numărul de campanii unice cuprinse în aria raportului.',
        vsCampaigns: 'Față de totalul campaniilor disponibile sau față de raportări anterioare.',
        whatRecognitions: 'Recunoașteri acumulate în aria selectată.',
        measuredRecognitions: 'Se numără fiecare recunoaștere înregistrată pentru campaniile incluse.',
        calcRecognitions: 'Suma tuturor recunoașterilor din campaniile filtrate.',
        vsRecognitions: 'Față de alte campanii, perioade anterioare sau obiectivul stabilit.',
        whatAudience: 'Numărul de angajați cărora li s-a adresat campania.',
        measuredAudience: 'Se ia audiența-țintă definită în configurarea campaniei.',
        calcAudience: 'Totalul angajaților eligibili din OU, țară, BU sau aria configurată.',
        vsAudience: 'Baza de calcul a participării; 100% înseamnă întreaga audiență.',
        whatParticipants: 'Persoane distincte care au participat trimițând cel puțin o recunoaștere.',
        measuredParticipants: 'Se numără persoanele unice care au trimis cel puțin o recunoaștere.',
        calcParticipants: 'Numărul distinct de expeditori cu una sau mai multe recunoașteri.',
        vsParticipants: 'Față de Audiența totală și față de campanii comparabile.',
        whatStaffFrontline: 'Dintre participanți, câți lucrează în birou (Staff) și câți în producție (Frontline).',
        measuredStaffFrontline: 'Se ia segmentul curent al fiecărei persoane la generarea raportului, nu cel de la momentul participării.',
        calcStaffFrontline: 'Numărul de participanți după segmentul din fișa lor din director.',
        vsStaffFrontline: 'Față de totalul Participanților de pe același rând.',
        whatRate: 'Procentul din audiența-țintă care a participat efectiv.',
        measuredRate: 'Se măsoară ca raport între participanți și audiența totală.',
        calcRate: 'Participanți / Audiență totală.',
        vsRate: 'Față de obiectivul de participare; 100% înseamnă că toată audiența a participat.',
        whatAvg: 'Media recunoașterilor generate de fiecare participant activ.',
        measuredAvg: 'Se măsoară între persoanele care au trimis cel puțin o recunoaștere.',
        calcAvg: 'Total recunoașteri / participanți.',
        vsAvg: 'Față de alte campanii sau față de media așteptată pe participant.',
      },
    },
    headcount: {
      notaPeriodo: 'Referință pentru perioadă: indicatorii de mai sus se calculează pe acest efectiv.',
      notaAdopcion: 'Este numitorul adopției: din acest efectiv, câte persoane au nominalizat.',
      title: 'Personal',
      updatedOn: 'Personal actualizat: {{fecha}}',
      updatedOnTitle: 'Personal actualizat',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europa: {{fecha}}',
      sourceUsa: 'SUA: {{fecha}}',
      sinDato: 'Fără date',
      hint: 'Ultima încărcare a utilizatorilor înregistrați în platformă',
      total: 'Total persoane',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Hartă de căldură OU × Fundamental',
      subtitle: 'Volumul de recunoașteri pe OU și Fundamental. Intensitatea culorii arată concentrația relativă în cadrul fiecărei coloane.',
      ou: 'Unitate organizațională',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Total',
    },
    network: {
      title: 'Rețea ONA',
      subtitle: 'Fluxul de recunoaștere între unități (colaborare încrucișată).',
      ous: 'Unități',
      flows: 'Fluxuri',
      legendCross: 'Flux cross-OU',
      legendInternal: 'Flux intern',
      legendNode: 'Unitate (dimensiune = volum)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Flux (De la → Către)',
      colRecognitions: 'Recunoașteri',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Volum de recunoașteri',
      colDominantFundamentalHelp: 'Lungimea barei reprezintă volumul de recunoașteri al fluxului; culoarea arată care Fundament a fost cel mai recunoscut în el.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'Ce înseamnă fiecare dată?',
      subtitle: 'Explicație în limbaj simplu pentru oricine descarcă acest fișier, fără cunoștințe de analiză de date.',
      colData: 'Dată',
      colWhat: 'Ce este',
      colHow: 'Cum se calculează',
      colVs: 'Se compară cu',
      percentTotalWhat: 'Ce parte din tot personalul activ aparține fiecărei generații.',
      percentTotalHow: 'Persoanele active din acea generație, din toate OU din domeniu, împărțite la totalul personalului activ cu bandă generațională cunoscută.',
      percentTotalVs: 'Celelalte generații din același tabel.',
      gapWhat: 'Cât de mult trăiește o generație fiecare Fundament, pe o scară de la 1 la 4, și cât de departe este Fundamentul său cel mai scăzut față de cel mai ridicat.',
      gapHow: 'Media scorurilor Pulso pe generație și Fundament; Δ este maximul minus minimul rândului, cu o zecimală.',
      gapVs: 'Celelalte Fundamente ale aceleiași generații.',
      heatmapWhat: 'Câte recunoașteri s-au acordat în fiecare unitate organizatorică, defalcate pe Fundament.',
      heatmapHow: 'Numărătoare grupată pe OU și Fundament; celulele cu mai puțin de 5 recunoașteri sunt ascunse din motive de anonimat.',
      heatmapVs: 'Celelalte OU și Fundamente din același tabel.',
      networkWhat: 'Câte recunoașteri au circulat de la o unitate organizatorică la alta.',
      networkHow: 'Numărul recunoașterilor trimise de la o OU la alta, ordonat descrescător.',
      networkVs: 'Celelalte fluxuri din același tabel.',
    },
    generational: {
      title: 'Distribuție Generațională',
      subtitle: 'Recunoașteri grupate pe bandă generațională.',
      filterBu: 'Filtrează după BU…',
      buAll: 'BU: Toate',
      filterDepto: 'Filtrează după departament…',
      roleAll: 'Toate',
      roleLeaders: 'Lideri',
      rolePeers: 'Colegi',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Decalaj generațional × Fundamental',
      gapSubtitle: 'Scor mediu (1–4) pe generație și Fundamental. Δ Decalaj ≥ 1,0 = critic.',
      gapTitleHelp: 'Fiecare celulă este rotunjită la 1 zecimală pentru afișare. Δ Decalaj se calculează pe baza valorii complete (nerotunjite) a diferenței dintre maximul și minimul rândului, de aceea poate să nu coincidă cu scăderea vizuală a coloanelor rotunjite.',
      colGeneration: 'Generație',
      colGap: 'Δ Decalaj',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} persoană',
      people_other: '{{count}} persoane',
      majority: 'majoritate',
      coverageTitle: 'Unități cu acoperire de date generaționale',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Exportă panoul Demografic (4 foi)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Componența personalului pe generație, OU și tip de colaborator',
      metaPeriod: 'Perioadă',
      metaFilters: 'Filtre aplicate',
      metaGenerated: 'Generat',
      colPercentTotal: '% din total',
      colYearRange: 'Interval de ani',
      colPeople: 'Persoane',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Notă',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Majoritate',
      noteSmallSample: 'Eșantion mic',
    },
    leaders: {
      title: 'Lideri',
      subtitle: 'Dimensiunea directă a echipei și recunoașteri per lider.',
      export: 'Exportă în Excel',
      colLeader: 'Lider',
      colPosition: 'Poziție',
      colOu: 'UO',
      colLevel: 'Nivel',
      colTeamSize: 'Dimensiunea echipei',
      colTeamReceived: 'Recunoașteri echipă (primite)',
      colTeamReceivedHelp: 'Total recunoașteri primite de persoane din cadrul structurilor liderilor.',
      colTeamSent: 'Recunoașteri echipă (trimise)',
      colTeamSentHelp: 'Total recunoașteri trimise de persoane din cadrul structurilor liderilor.',
      colLeaderSent: 'Recunoașteri trimise de lider',
      colLeaderReceived: 'Recunoașteri primite de lider',
      colParticipation: 'Participare',
      colRatio: 'Raport',
      colExport: 'Exportă',
      exportRow: 'Exportă acest rând',
      exportRowFor: 'Exportă rândul lui {{name}}',
      kpiTotalLeaders: 'Total lideri',
      kpiTeamSizeSum: 'Dimensiunea echipei',
      kpiRatioAvg: 'Raport primite/trimise',
      kpiParticipationAvg: 'Participare',
      emptyByPerson: 'Nu s-au găsit rezultate: persoana selectată nu are subordonați direcți în aria ta.',
      currentWeek: '(săptămâna curentă, implicit)',
      teamSizeNote: 'Mărimea echipei numără subordonații direcți din organigramă și nu se schimbă cu datele sau cu Fundamentalul; recunoașterile echipei, da.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Rezumat executiv',
        sheetDefinitions: 'Definiții',
        sheetTeams: 'Echipe după lider',
        teamsSubtitle: 'Detaliu al recunoașterilor pe structură ierarhică.',
        definitionsTitle: 'Ce înseamnă fiecare informație?',
        definitionsSubtitle: 'Explicație în limbaj simplu, pentru oricine descarcă acest fișier — fără să fie nevoie de cunoștințe despre date.',
        metaPeriod: 'Perioadă',
        metaFilters: 'Filtre aplicate',
        metaGenerated: 'Generat la',
        colKpi: 'Indicator',
        colValue: 'Valoare',
        colDetail: 'Detaliu',
        colDatum: 'Informație',
        colWhatIs: 'Ce este',
        colHowCalculated: 'Cum se calculează',
        detailTotalLeaders: 'Totalul liderilor care au persoane în subordine în efectiv.',
        detailTeamSize: 'Suma dimensiunii echipei (subordonați direcți) a liderilor afișați.',
        detailTeamReceived: 'Totalul recunoașterilor primite de persoanele din structurile liderilor.',
        detailTeamSent: 'Totalul recunoașterilor trimise de persoanele din structurile liderilor.',
        detailLeaderReceived: 'Totalul recunoașterilor primite direct de lideri.',
        detailLeaderSent: 'Totalul recunoașterilor trimise direct de lideri.',
        detailRatio: 'Recunoașterile de echipă primite împărțite la cele trimise.',
        detailParticipation: 'Participarea medie a echipelor liderilor.',
        whatTeamSize: 'Câte persoane raportează direct acelui lider.',
        howTeamSize: 'Numărul persoanelor al căror manager este liderul. Nu se cumulează nivelurile inferioare ale organigramei.',
        whatTeamReceived: 'Câte recunoașteri a primit în total echipa acelui lider, de la oricine.',
        howTeamReceived: 'Suma recunoașterilor în care destinatarul face parte din echipa directă a liderului.',
        whatTeamSent: 'Câte recunoașteri a trimis în total echipa acelui lider, către oricine.',
        howTeamSent: 'Suma recunoașterilor în care expeditorul face parte din echipa directă a liderului.',
        whatLeaderReceived: 'Câte recunoașteri a primit în total liderul, de la oricine.',
        howLeaderReceived: 'Numărul recunoașterilor în care destinatarul este liderul. Nu include echipa sa.',
        whatLeaderSent: 'Câte recunoașteri a trimis liderul, către oricine.',
        howLeaderSent: 'Numărul recunoașterilor în care expeditorul este liderul. Nu include echipa sa.',
        whatRatio: 'Cu cât mai multă recunoaștere primește o echipă, comparativ cu ce oferă altora.',
        howRatio: 'Recunoașterile de echipă primite împărțite la cele trimise. „—” dacă echipa nu a trimis niciuna.',
        whatParticipation: 'Ce procent din echipa acelui lider a recunoscut pe cineva cel puțin o dată.',
        howParticipation: 'Persoanele din echipă cu cel puțin 1 recunoaștere trimisă, împărțite la mărimea echipei. Primirea nu contează: este acțiunea altei persoane.',
        whatLeader: 'Angajat care are personal în subordine în statul de funcții al companiei.',
        howLeader: 'Orice persoană cu cel puțin un subordonat direct. Rezumatul însumează liderii din toate geografiile ariei consultate.',
        whatLevel: 'Adâncimea liderului în organigramă: N-1 este rădăcina (fără manager), apoi N-2, N-3… în jos.',
        howLevel: 'Lanțul de manageri până la rădăcină + 1, calculat pentru întreaga companie, nu doar între liderii vizibili în această listă.',
      },
    },
    moderation: {
      title: 'Moderare',
      subtitle: 'Detaliul recunoașterilor raportate. Include date de contact pentru escaladare.',
      total: 'Total raportări',
      pending: 'În așteptare',
      hidden: 'Ascunse',
      restored: 'Restaurate',
      colReported: 'Raportat',
      colReportedEmail: 'Email raportat',
      colOu: 'UO',
      colCountry: 'Țară',
      colReporter: 'Raportor',
      colReporterEmail: 'Email raportor',
      colReason: 'Motiv',
      colStatus: 'Stare',
      colDate: 'Data',
      statusPending: 'În așteptare',
      statusHidden: 'Ascuns',
      statusRestored: 'Restaurat',
      statusPublished: 'Publicat',
      colComment: 'Comentariu raportat',
      colLanguage: 'Limbă',
      colReportCount: '# Raportări',
      export: 'Exportă în Excel',
      colCampaign: 'Campanie',
      allCampaigns: 'Toate campaniile',
      campaignNone: 'Fără campanie',
      campaignUnavailable: 'Campanie indisponibilă',
    },
    campaigns: {
      title: 'Istoric campanii',
      subtitle: 'Campanii încheiate: audiență și recunoașteri.',
      search: 'Caută după nume…',
      // D4 — selector de categorie (Fundamentales/Brillamos/Personalizada) care înlocuiește
      // exportul combinat al tabelului.
      filterTypeLabel: 'Categorie',
      filterAllTypes: 'Toate categoriile',
      summaryParticipants: 'Total participanți',
      summaryRate: '% participare',
      colName: 'Nume',
      colType: 'Tip',
      colAudience: 'Audiență (persoane)',
      colRecognitions: 'Recunoașteri',
      // C2 — «Participare pe campanie» (rep-panel-campgeneral).
      colParticipants: 'Participanți',
      colRate: 'Rata de participare',
      colAvgUser: 'Medie per participant',
      colAvgUserHelp: 'Recunoașteri medii generate de fiecare participant la campanie: recunoașteri ÷ participanți.',
      dominantFundamentalTooltip: 'Fundamentul cel mai recunoscut: {{name}}',
      colStart: "Data de început",
      colExpiration: "Data de încheiere",
      prevPage: 'Anterior',
      nextPage: 'Următor',
      pageOf: 'Pagina {{page}} din {{total}}',
      type: {
        Fundamentales: 'Fundamentale',
        Brillamos: 'Shine Together',
        Personalizada: 'Personalizată',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      // D6 — eroare vizibilă utilizatorului când exportul campaniei eșuează (rețea/backend), prin Toast.
    },
  },
  // ── D5 Pass-C — Preferințe, echipă, tablou de bord, clasament, campanie personalizată ──
  notifPrefs: {
    title: 'Notificări',
    subtitle: 'Alege ce avertizări vrei să primești pe e-mail.',
    unavailable: 'Preferințele tale nu au putut fi încărcate.',
    emailEnabled: 'Primește e-mailuri',
    emailHint: 'Comutator general pentru toate e-mailurile.',
    saveError: 'Preferințele tale nu au putut fi salvate.',
    cat: {
      recognitionReceived: 'Recunoașteri primite',
      streakAndBadges: 'Serii și insigne',
      campaigns: 'Campanii',
      digest: 'Rezumat de activitate',
    },
    catHint: {
      recognitionReceived: 'Când cineva te recunoaște.',
      streakAndBadges: 'Seria ta și insignele deblocate.',
      campaigns: 'Noutăți despre campaniile Strălucim.',
      digest: 'Rezumat periodic al activității tale.',
    },
    catLockedAntiSpoiler: 'Blocat cât timp Modul Anti-Spoiler este activ: nu te putem anunța despre recunoașterile tale până la încheierea campaniei.',
  },
  team: {
    mostRecognized: 'Cei mai recunoscuți', mostRecognizers: 'Cei mai activi recunoscători',
    title: 'Echipa mea',
    subtitle: 'Participarea echipei tale la recunoaștere.',
    subtitleFor: 'Echipa lui {{name}}',
    empty: 'Încă nu există activitate a echipei tale.',
    teamSize: 'Dimensiunea echipei',
    sent: 'Trimise',
    received: 'Primite',
    participation: 'Participare',
    members: 'Membrii echipei',
    emptyMembers: 'Nu există membri de afișat.',
    colMember: 'Membru',
    colSent: 'Trimise',
    colReceived: 'Primite',
    colStreak: 'Serie',
    noStreak: 'Fără serie',
    explore: 'Explorează echipa sa',
    myTeam: 'Echipa mea',
    breadcrumb: 'Traseul echipelor',
    colTopFundamental: 'Top fundamental',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Recunoscut pentru:',
    fundEnviado: 'Recunoaște pentru:',
    colActions: 'Acțiuni',
    viewButton: 'Vezi profilul lui {{name}}',
    viewButton_short: 'Vezi',
    backToTeam: 'Înapoi la echipă',
    backToProfile: 'Înapoi la profilul meu',
    expandMember: 'Vezi detaliile lui {{name}}',
  },
  tablero: {
    title: 'Tablou de bord executiv',
    subtitle: 'KPI-urile Programului de Recunoaștere. Doar administratorii de puncte văd punctele.',
    pointsTitle: 'Punctele campaniei',
    pointsCampaign: 'Campanie cu puncte',
    pointsNone: 'Nicio campanie nu acordă puncte.',
    pointsHint: 'Cu UO și intervalul de date din bară.',
    empty: 'Nu există indicatori pentru aria selectată.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Toate Fundamentalele',
    allGenerations: 'Toate generațiile',
    notApplicableNote: 'Cu filtrul de generație activ, indicatorii calculați pe totalul angajaților apar ca „n/a”: recensământul nu este defalcat pe generații, deci acel procent ar însemna altceva.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Generația Alpha',
      GenZ: 'Generația Z',
      Millennial: 'Millennials',
      GenX: 'Generația X',
      BabyBoomer: 'Baby Boomers',
      Silent: 'Generația Tăcută',
    },
  },
  leaderboard: {
    title: 'Clasament pe OU',
    subtitle: 'Nominalizări pe unitate organizațională/țară.',
    noOu: 'Fără OU',
    you: ' (tu)',
  },
  campaignType: {
    personalizada: 'Campanie personalizată',
  },
  campaignLanding: {
    customNote: 'Aceasta este o campanie informativă. Explorează documentele și microsite-ul ei.',
  },
  innovacion: {
    kpiStreak: 'Serie',
    kpiStreakHint: 'record: {{record}} săptămâni',
    kpiStreakHintMonthly: 'record: {{record}} luni',
    kpiNominations: 'Nominalizări',
    kpiNominationsHint: 'Trimise în această campanie',
    kpiNominationsHint2: '{{count}} persoane diferite',
    kpiUnique: 'Persoane nominalizate',
    kpiUniqueHint: 'Destinatari unici',
    kpiDaysLeft: 'Zile rămase',
    suppressed: 'Datele nu sunt afișate din motive de confidențialitate: grupul este prea mic pentru a afișa cifre.',
    kpisUnavailable: 'Indicatorii în timp real nu sunt disponibili momentan.',
    fundamentalsTitle: 'Fundamentele acestei campanii',
    nominateSecondary: 'Mergi la pagina Nominalizare',
    recentTitle: 'Recunoașteri recente',
    recentEmpty: 'Încă nu există recunoașteri în această campanie.',
    noCampaign: 'Nu există o campanie personalizată activă. Poate fi creată din Administrare → Campanii.',
  },
};

export default recognition;
